export default {
  outdated_client_title: 'Outdated Version',
  outdated_client_message: 'Your version of the application has expired or it is outdated.',
  outdated_client_bold: 'Please sign in again to load the latest version.',
  expired_client_title: 'Expired Session',
  expired_client_message: 'Your session has expired or you have logged in in a different device.',
  expired_client_bold: 'Please sign in again in order to continue.',
  different_client_title: 'Session in Different Device',
  different_client_message: 'You have started a different session in a different device or browser.',
  different_client_bold: 'If you wish to use the application in this device, please sign out from all other devices and then sign in again.',
  offline_client_title: 'Offline Device',
  offline_client_message: 'It seems that you are disconnected from the internet.',
  offline_client_bold: 'Please reconnect to the internet and click the <i>Reload</i> button if this message does not automatically disappears.',
  outdated_client_button: 'Logout',
  reload_client_button: 'Reload',
  errors: {
    message: 'Hi there\nIt seems you encountered an error:',
    tell_us_more: 'To help us troubleshoot this issue, please let us know what you were trying to do.'
  },
  page_titles: {
    login: 'Authentication',
    login_seo: '{name} - {btype} Management Software - Kydemy Authentication',
    kydemy: 'Dashboard',
    accounts: 'Accounts',
    registrations: 'Registrations',
    account_details: 'Account Details',
    classes: 'Classes',
    class_details: 'Class Details',
    finances: 'Finances',
    messages: 'Messages',
    events: 'Events',
    event_details: 'Event Details',
    configuration: 'Configuration',
    reports: 'Reports',
    forgot_password: 'Password Recovery',
    registration_validation: 'Validate Registration Email Address',
    wizard: 'Configuration Wizard',
    import_students: 'Import Students Wizard',
    student_attendance: 'My Class Attendance',
    profile: 'My Profile',
    reset_password: 'Reset Password',
    gallery: 'Pictures Gallery',
    student_payments: 'My Payments',
    relatives_attendance: 'Students Attendance',
    relatives_profile: 'Student Profile',
    link_payment: 'New Payment',
    videos: 'Classes Videos',
    files: 'Classes & Student Files',
    streaming_session: 'Online Class/Session',
    student_notifications: 'Notification Preferences',
    subscription_registration: 'Subscription Registration',
    subscriber_landing: 'Subscription Details',
    subscriber_class: 'Subscription Contents',
    subscriber_config: 'Subscription Configuration',
    grades: 'Student Grades',
    evaluations: 'Evaluar Alumnos'
  },
  langs: {
    en: 'English',
    es: 'Spanish',
    ca: 'Catalan',
    fr: 'French'
  },
  leader: 'Leader',
  follower: 'Follower',
  male: 'Male',
  female: 'Female',
  booleans: {
    true: 'Yes',
    false: 'No'
  },
  month_selector: {
    all: 'All Months',
    any: 'Any Month',
    none: '-- None --'
  },
  login: {
    title: 'Kydemy - Authentication',
    form_title: 'Member Login',
    username: 'Username/Email:',
    password: 'Password:',
    usernamePlaceholder: 'Enter username',
    passwordPlaceholder: 'Enter password',
    loginButton: 'LOGIN',
    loginError: 'Login Error: invalid username/password',
    remember_me: 'Remember me',
    forgot_password_link: 'Forgot password?',
    forgot_password_title: 'Reset Password',
    forgot_password_desc: 'Please enter your email address and we will send you an email with the directions to reset your password.',
    forgot_password_placeholder: 'Email address',
    reset_password_button: 'Reset Password',
    email_sent: 'Email Sent',
    email_details: 'Soon you will receive an email with the requested information and directions.',
    close: 'Close',
    password_confirmation: 'Confirmation',
    passwordConfirmationPlaceholder: 'Re-enter password',
    save_password_button: 'Update Password',
    password_reset: 'Reset Password',
    password_reset_success: 'Your password has been updated successfully. Please try to sign in using your new password.',
    password_reset_no_success: 'Your password could not be updated. Please bear in mind that passwords can only be updated up to 24 hours after you receive the email. Please try to request a new password or contact us.',
    username_reminder: '<b>TIP:</b> You can use your email address instead of your username in order to log in.',
    user_not_active: 'We could not find your email address in our records or the user is not active. Please contact us so we can get your account set up.',
    cancel: 'Go back to login',
    active_error: 'Your account is currently disabled, but you can still register using the <b class="has-text-info">REGISTRATION</b> button and use the same username and password.'
  },
  headerbar: {
    overview: 'Overview',
    members: 'Students',
    classes: 'Classes',
    events: 'Events',
    finances: 'Finances',
    messages: 'Messages',
    configuration: 'Configuration',
    reports: 'Reports'
  },
  overview: {
    memberships: 'Memberships',
    new_members: 'Registrations History',
    week_income: 'Week Income',
    today_classes: 'Today\'s Classes',
    week_classes: 'Classes this Week',
    active_users_last_minutes: 'Active users - last {minutes} minutes',
    no_belt: 'No Belt',
    belts: 'Belts',
    birthdays: 'Upcoming Birthdays',
    days_remaining: '{days} days left',
    days_today: 'Today',
    days_tomorrow: 'Tomorrow',
    days_yesterday: 'Yesterday',
    month_payments_overview: 'Payments Overview',
    no_birthdays: '-- There are no upcoming birthdays --',
    no_active_users: '-- There are no active users at this moment --'
  },
  members: {
    no_students: 'There are no {role} in the platform for the selected filters',
    leader: 'Leader',
    follower: 'Follower',
    active: 'Active',
    inactive: 'Inactive',
    registrations: 'Registrations',
    create_role: 'New: <b>{role}</b>',
    new_student: 'Create new Student',
    new_member: 'Create new {role}',
    has_debts: 'This student has outstanding debts',
    columns: {
      firstname: 'First Name',
      lastname: 'Last Name',
      tags: 'Tags',
      email: 'Email',
      username: 'Username',
      password: 'Password',
      phone_number: 'Phone',
      phone_prefix: 'Prefix',
      belt: 'Belt',
      age: 'Age',
      datetime: 'Since',
      membership: 'Membership',
      roles: 'Roles',
      levels: 'Levels',
      type: 'Account',
      id_number: 'ID/Passport',
      postal_code: 'Zip/P.C.',
      postal_address: 'Address',
      last4: 'Bank Account',
      terms_accepted: 'Terms Accepted',
      photo_release_signed: 'Photo Release',
      location: 'Location'
    },
    roles: {
      admins: 'Admins',
      managers: 'Managers',
      teachers: 'Teachers',
      students: 'Students',
      relatives: 'Relatives',
      subscribers: 'Subscribers',
      leads: 'Leads'
    },
    select_all: 'SELECT PAGE',
    select_none: 'SELECT NONE',
    select_count: 'SELECT ALL: {count}',
    selected: 'SELECTED USERS',
    activate: 'Activate Users',
    inactivate: 'Disable Users',
    apply_tooltip: 'Apply updates to selected users',
    send_bulk: 'Send bulk message to selected users',
    delete_tags: 'Delete Tags'
  },
  calendar: {
    months: {
      jan: 'January',
      feb: 'February',
      mar: 'March',
      apr: 'April',
      may: 'May',
      jun: 'June',
      jul: 'July',
      aug: 'August',
      sep: 'September',
      oct: 'October',
      nov: 'November',
      dec: 'December'
    },
    days: {
      mon: 'Monday',
      tue: 'Tuesday',
      wed: 'Wednesday',
      thu: 'Thursday',
      fri: 'Friday',
      sat: 'Saturday',
      sun: 'Sunday'
    }
  },
  events: {
    gallery: 'Gallery',
    attendees: 'Attendees',
    new_event: 'Create New Event',
    no_events: 'There are no events created yet',
    name: 'Event Name',
    description: 'Description',
    datetime: 'Starts',
    datetime_end: 'Ends',
    location: 'Venue',
    event_type: 'Event Type',
    capacity: 'Max Capacity',
    price: 'Admission Fee',
    active: 'Event Active',
    create_event: 'Create Event',
    delete_event: 'Delete Event',
    save_event: 'Save Changes',
    select_venue: 'Select a Venue',
    select_event_type: 'Select a Type',
    new_venue: 'New Venue',
    new_event_type: 'New Event Type',
    event_date: 'Event start date and time',
    event_end: 'Event end date and time',
    free: 'Free',
    inactive: 'Inactive',
    going: 'Going:',
    interested: 'Interested:',
    button_interested: 'Interested',
    button_not_going: 'Not Going',
    button_going: 'Going',
    add_calendar: 'Add to Calendar',
    buy_ticket: 'Buy Ticket',
    event_saved: 'The Event was saved successfully',
    event_error: 'The Event could not be saved. Please contact us.',
    add_attendee: 'Add Attendee',
    remove_attendee: 'Remove Attendee',
    already_in_event: 'The selected student is already in the event',
    attendee_added: 'The student has been added to the event',
    attendee_removed: 'The student has been removed from the event',
    no_attendees_going: 'There are no attendees registered for this event yet',
    no_attendees_interested: 'No students have shown interest for this event so far.',
    no_attendees_notgoing: 'No students has confirmed that they will not attend the event.',
    num_payments: 'Number of Payments',
    total: 'Total Collected',
    add_attendee_going: 'Add to Event',
    add_attendee_interested: 'Add to Interested',
    add_attendee_notgoing: 'Add as Not Going',
    add_attendee_payment: 'Event Payment',
    add_attendee_payment_content: 'This Event has a price: {price}, therefore attendees are expected to pay in order be added to the Event. You can choose to generate a payment with the appropriate payment method or add the attendee to the event without creating a payment.',
    add_attendee_payment_warning: 'If you decide to add the attendee without creating a payment, the event collection sum will not match the expected amount.',
    cancel: 'Cancel',
    add_attendee_cc_payment: 'Add & Create Credit Card Payment',
    add_attendee_cash_payment: 'Add & Create Cash Payment',
    add_attendee_no_payment: 'Add Without Payment',
    confirm_delete_attendee: 'Delete Attendee Confirmation',
    confirm_delete_attendee_content: 'Do you really want to remove {name} from the event?<br/>Please note that most likely {name} has bought a ticket for this event.',
    confirm_delete_attendee_button: 'Remove Attendee',
    confirm_delete_event: 'Delete Event Confirmation',
    confirm_delete_content: 'You are about to delete this event. This action cannot be undone.',
    delete_event_error_payments: 'There are payments associated to this event. Do you really want to delete this event?',
    delete_event_error_attendees: 'There are attendees associated to this event. Do you really want to delete this event?',
    event_deleted: 'Event deleted successfully',
    venue_online: 'Online Event',
    event_types: {
      event_type_title: 'Create a new Event Type',
      create_event_type: 'Create Event Type',
      name: 'Name',
      cancel: 'Cancel',
      event_type_created: 'Event Type created successfully'
    },
    sections: {
      going: 'Event Attendees:',
      notgoing: 'Not Going:',
      interested: 'Interested:'
    }
  },
  venues: {
    create_location: 'Create Location',
    create_venue_title: 'Create a new Venue',
    create_location_title: 'Create a new Location',
    create_venue: 'Create Venue',
    search_venue: 'Search',
    name: 'Name',
    address: 'Address',
    search_venue_placeholder: 'Enter the Google Maps venue/place name',
    cancel: 'Cancel',
    venue_created: 'Venue created successfully'
  },
  classes: {
    classes: 'Classes',
    calendar: 'Calendar',
    calendar_month: 'Month',
    calendar_week: 'Week',
    list: 'Cards',
    table: 'Table',
    registration_status: {
      expired: 'Finished',
      future: 'Upcoming',
      waiting_list: 'Waiting List'
    },
    registration_sections: {
      expired: 'Previously enrolled students',
      future: 'Students starting soon',
      waiting_list: 'Students on the waiting list'
    },
    attendance_status: {
      registration: 'Registered',
      trial: 'Trial',
      make_up: 'Make Up',
      booking: 'Booked'
    },
    class_type: {
      regular: 'Regular',
      thematic: 'Thematic',
      intensive: 'Intensive',
      workshop: 'Workshop'
    },
    class_type_desc: {
      regular: 'Regular classes are those recurring classes that are included in the student\'s memberships fee.',
      thematic: 'Las clases temáticas son clases específicias que entran dentro de la cuota del alumno.',
      intensive: 'Los intensivos son clases especiales que no suelen estar cubiertas por la cuota de los alumnos.',
      workshop: 'Los workshops son clases intensivas, normalmente impartidas por profesores externos y con una cuota independiente.'
    },
    classes_no_schedules: 'There are classes without schedules that can not be shown in the calendar. You can edit these classes in Table view.',
    date: 'Date',
    style: 'Style',
    level: 'Level',
    teacher_leader: 'Teacher (Leader)',
    teacher_follower: 'Teacher (Follower)',
    leaders_followers: 'Leaders / Followers',
    leaders: 'Leaders',
    followers: 'Followers',
    start_end: 'Start/End',
    next_class: 'Next Class',
    rate: 'Rate',
    no_dates: 'The class does not have schedules set',
    name: 'Name',
    teachers: 'Teachers',
    teacher: 'Teacher',
    extra_teachers: 'Add additional teachers',
    couples: 'Couples',
    students: 'Students',
    select_style: 'Select a Style',
    select_level: 'Select a Level',
    add_student: 'Add Student to the Class',
    add_student_waiting_list: 'Add Student to the Waiting List',
    class_couples: 'Couples in Class',
    waiting_list: 'Waiting List',
    request_list: 'Pending Requests',
    add_couple: 'Add couple to the Class',
    add_couple_waiting_list: 'Add Couple to the Waiting List',
    no_couple: '-- No {role} --',
    no_couples: 'No Couples in this Class',
    no_students: 'There are no Students in this Class',
    description: 'Description',
    description_placeholder: 'A brief description about the class purpose/methodology/content/etc',
    type: 'Type',
    status: 'Status',
    price: 'Price',
    location: 'Location',
    membership_track: 'Rate',
    default_track: '-- DEFAULT --',
    free_for: 'Included for',
    none: 'Not Included',
    upload_image: 'Upload Image',
    class_public: 'Public',
    class_private: 'Private',
    class_online: 'Online Class',
    online: 'Online',
    class_classroom: 'Classroom',
    online_class_info: 'Online classes do not need to be scheduled and students can register at any time. In this way you can create reusable courses for your students to consume at any time using videos, files and links.',
    class_status: {
      active: 'Active',
      planned: 'Planned',
      archived: 'Archived'
    },
    class_status_desc: {
      active: 'Classes with active status will be visible to the students and will appear in the searches.',
      planned: 'Planned classes are those that are not yet available or are not confirmed.',
      archived: 'Archived classes are those finished classes and it is desired that they do not appear in the class listings.'
    },
    class_visibility: {
      public: 'Public',
      private: 'Private'
    },
    class_visibility_desc: {
      public: 'Public classes are visible for everyone: all teachers and all students.',
      private: 'Private classes are only visible for teachers and students which are part/enrolled in the class.'
    },
    bookings: {
      label: 'Enrollment',
      registrations: 'Registrations',
      bookings: 'Bookings',
      both: 'Both: Reg. + Book.',
      help: [
        '<b class="has-text-info">BETA:</b> this is a new feature being tested.',
        '<b>Registrations:</b><br/>Students enroll for the entire course. You expect to have the same students every day.',
        '<b>Bookings:</b><br/>Students book a day of class in advance. Students must book classes manually every time they intend to attend. You might have different students every day.',
        '<b>Both (registrations & bookings):</b><br/>You can have registered students, attending every day (reserved spots in the class), and students booking individual class days.'
      ],
      book_class: 'Book Class',
      modal_title: 'Book Class',
      select_different_date: 'Back',
      book_now: 'Book Now',
      waiting_list: 'Join Waiting List',
      booking_error: 'There was a problem booking the class, please contact us',
      booking_success: 'Class booked successfully',
      already_booked: 'You have already booked this class',
      fully_booked: 'This class is fully booked at the moment',
      last_spots: 'Last spots available in the class'
    },
    class_visibility_note: '* Please note that only Active classes will be displayed.',
    details: 'Details',
    time_slots: 'Schedule',
    select_location: 'Pick a Classroom',
    select_days: 'Pick a Weekday',
    links: 'Links',
    class_videos: 'Class Videos:',
    class_files: 'Class Files:',
    videos: 'Videos',
    files: 'Files',
    attendance: 'Attendance',
    gallery: 'Gallery',
    notes: 'Notes',
    save: 'Save',
    no_classes: 'No Classes for this Month / Year / Search Filter',
    msg_class_created: 'Class created successfully',
    msg_class_updated: 'Class updated successfully',
    add: 'Add',
    add_recurrent: 'Add Recurrent Date',
    effective_dates: 'Class Effective Dates',
    calendar_dates: 'Add Calendar Dates',
    from: 'from',
    to: 'to',
    on: 'On',
    at: 'at',
    for: 'for',
    every: 'Every',
    minutes: 'minutes',
    payment_ok: 'The membership or class fee has been paid',
    payment_no_ok: 'The member does not have either the class or membership fees up to date',
    remove_from_class: 'Remove student from this class',
    attendance_section: {
      select_date: 'Select a Day',
      no_attendance_list_header: 'No Attendance List',
      no_attendance_list_message: 'No Attendance Lists created for the selected month',
      no_attendance_list: 'There is not an attendance list created for this class/date.',
      cannot_delete_attendance_list: 'Lists with students in \'Trial\', \'Booked\', or \'Make Up\' statuses cannot be deleted.',
      class_cancelled: 'You cannot create an attendance list for a cancelled class',
      date_match_error: 'WARNING: There is no class scheduled for the selected date',
      mode_dates: 'Attendance List',
      mode_members: 'Members Statistics',
      mode_stats: 'Class Statistics',
      mode_ratings: 'Ratings',
      make_up_class: 'Make up class, add student or setup a trial class',
      make_up_attendance: 'Made up attendance on {date} in class "{class}"',
      make_up_attendance_for: 'Making up attendance for the class "{class}" of {date}',
      add_to_attendance_list: '{name} has been added to the attendance list successfully',
      del_to_attendance_list: '{name} has been removed from the attendance list',
      firstname: 'Firstname',
      lastname: 'Lastname',
      attendance: 'Attendance',
      average: 'Average',
      delete_list: 'Delete List',
      confirmation: 'Confirmation',
      confirm_delete: 'Are you sure that you want to delete the attendance list?',
      cannot_be_undone: 'This action cannot be undone',
      cancel: 'Cancel',
      delete: 'Delete',
      create_list: 'Create Attendance List',
      students_title: 'Class Students:',
      students_other_title: 'Other Students:',
      making_up_attendance: 'Making Up Attendance:',
      teachers_title: 'Class Teachers:',
      create_teacher_list: 'Create Teacher\'s Attendance List',
      error_add_teacher: 'Could not update teacher attendance',
      add_teacher_list: 'Add new teacher to this attendance list',
      add_class_payment: 'Add class payment',
      teacher_payment_info: 'By default the teacher payment for this class will be calculated using the information in the teacher\'s profile or class details.</br>Please <b>NOTE</b> that this value will override any other payment configuration for this teacher and only for this class in this specific date.',
      students_attendance: 'Students Attendance',
      teachers_attendance: 'Teachers Attendance',
      delete_teacher: 'Remove from List',
      save_notes_button: 'Save Notes',
      class_notes: 'Class Notes:',
      class_notes_students: 'Notes for students',
      class_notes_private: 'Internal notes for Teacher/Staff',
      class_notes_private_title: 'Private Note',
      class_notes_success: 'Class Notes updated successfully',
      class_notes_error: 'Could not update class notes, please contact us',
      confirm_delete_notes: {
        title: 'Confirmation: Delete Note',
        content: 'Are you sure that you want to delete this note?',
        button: 'Delete Note'
      },
      add_common_students: 'Add previous/recent students',
      add_class_teachers: 'Please add teachers to the class',
      capacity: 'Capacity',
      usage: 'Students',
      ratings: {
        no_ratings: 'There are no student ratings recorded for this class',
        students: 'Students',
        attended: 'Attended',
        of: 'of',
        columns: {
          date: 'Date',
          attendance: 'Attendance',
          ratings: 'Ratings',
          class_rating: 'Class Rating',
          teacher_rating: 'Teacher Rating',
          meeting_rating: 'Meeting Rating'
        },
        class_rating: 'Class Rating: {value}',
        teacher_rating: 'Teacher Rating: {value}',
        meeting_rating: 'Meeting Rating: {value}'
      }
    },
    links_section: {
      title: 'Title',
      url: 'Link Address',
      description: 'Description',
      no_links: 'There are no Links created for this class',
      publish_date: 'Publication Date',
      visibility: 'Visibility',
      immediately: 'Immediately',
      publish_date_tooltip: 'Leave blank to publish immediately',
      payment_required: 'You must have your payments up to date to visit this link',
      visibilities: {
        public: 'Public',
        students: 'Only enrolled students',
        payed: 'Enrolled & Payments OK',
        private: 'Private - Only Staff'
      }
    },
    videos_section: {
      add_video: 'Add Video',
      upload_video_option: 'Upload new Video',
      select_video_option: 'Select Existing Video',
      upload_video_browse: 'Browse File',
      publish_date_placeholder: 'Publication Date',
      publish_date_tooltip: 'Leave blank to publish immediately',
      statuses: {
        done: 'Ready',
        processing: 'Processing',
        pending: 'Waiting',
        error: 'Error'
      },
      visibilities: {
        public: 'Public',
        students: 'Only enrolled students',
        payed: 'Enrolled & Payments OK',
        private: 'Private - Only Staff'
      },
      delete_modal: {
        title: 'Delete video confirmation',
        content: 'Do you really want to delete the selected video?',
        button: 'Delete'
      },
      edit_modal: {
        title: 'Edit Video Information',
        name: 'Video Title:',
        visibility: 'Video visibility:',
        schedule: 'Schedule video:',
        thumbnail: 'Select a thumbnail:',
        button: 'Save'
      },
      error_type: 'Unrecognized video format',
      error_size: 'Only valid videos up to 5.0 GB can be uploaded',
      no_videos: 'This class has no videos yet',
      no_videos_available: 'There are no other videos available',
      edit_video: 'Edit video details',
      delete_video: 'Delete this video',
      upload_error: 'Error uploading the video, please contact us',
      upload_success: 'Video uploaded, it will take some minutes to be processed',
      edit_error: 'Error editing video information, please contact us',
      edit_success: 'Video information updated successfully',
      delete_error: 'Error deleting video, please contact us',
      delete_success: 'Video deleted successfully',
      add_success: 'Video added successfully',
      add_error: 'Error adding video, please contact us',
      num_classes: '{num} Classes',
      video_payment_required: 'You must have your payments up to date to play this video',
      sorting: 'Enable sorting mode',
      error_sorting: 'Error saving new videos order',
      videos: 'Videos',
      stats: 'Stats',
      video_views: 'Videos View Count',
      video_data: 'Videos Stats Data',
      no_stats_data: '-- No Stats information available --',
      columns: {
        title: 'Title',
        total_views: 'Total Views',
        num_members: 'Students',
        videos: 'Videos',
        members: 'Students',
        class: 'Class'
      }
    },
    files_section: {
      add_file: 'Add File',
      upload_file_option: 'Upload new File',
      select_file_option: 'Select Existing File',
      upload_file_browse: 'Browse File',
      publish_date_placeholder: 'Publication Date',
      publish_date_tooltip: 'Leave blank to publish immediately',
      delete_modal: {
        title: 'Delete file confirmation',
        content: 'Do you really want to delete the selected file?',
        button: 'Delete'
      },
      edit_modal: {
        title: 'Edit File Information',
        name: 'File Title:',
        visibility: 'File visibility:',
        schedule: 'Schedule file:',
        button: 'Save'
      },
      error_type: 'Only MS Office / LibreOffice / iWork documents, PDFs, images and audio files are allowed',
      error_size: 'Only valid files up to 15MB can be uploaded',
      no_files: 'There are no files uploaded yet',
      no_files_available: 'There are no other files available',
      edit_file: 'Edit file details',
      delete_file: 'Delete this file',
      upload_error: 'Error uploading the file, please contact us',
      upload_success: 'File uploaded successfully',
      edit_error: 'Error editing file information, please contact us',
      edit_success: 'File information updated successfully',
      delete_error: 'Error deleting file, please contact us',
      delete_success: 'File deleted successfully',
      add_success: 'File added successfully',
      add_error: 'Error adding file, please contact us',
      num_classes: '{num} Classes',
      file_payment_required: 'You must have your payments up to download this file'
    },
    cancel: 'Cancel',
    delete: 'Delete',
    delete_class: 'Delete Class',
    archive_class: 'Archive Class',
    create_class_couples: 'Create group class for Couples',
    create_class_singles: 'Create group class for individual Students',
    create_class_private: 'Create Private Class',
    new_class: 'New Class',
    copy_class: 'Create a Copy',
    msg_class_copied: 'Class Copied successfully',
    copy: 'Copy',
    delete_info: 'Only archived classes with no payments and without enrolled students can be deleted',
    copy_info: 'Create a copy of the current class as Planned',
    confirmation: 'Delete Class: Confirmation',
    confirm_delete: 'Are you sure that you want to delete the current class?',
    cannot_be_undone: 'This action cannot be undone and all information related to the class will be erased permanently: payments, attendance lists, etc.',
    class_deleted: 'Class Deleted',
    class_deleted_info: 'The Class and all its associated resources have been deleted successfully.',
    back_to_classes: 'Back to Classes',
    select_class: 'Select a class',
    error_create: 'Error creating class',
    error_update: 'Error updating class',
    error_image_format: 'Only JPEG and PNG images are supported',
    error_image_upload: 'Error updating class image, please try again',
    msg_image_updated: 'Class image updated succesfully',
    delete_couple: 'Delete Couple',
    move_to_waiting_list: 'Move couple to Waiting List',
    move_to_class: 'Move couple into Class',
    delete_leader: 'Remove Leader',
    delete_follower: 'Remove Follower',
    add_to_class: 'Add Student to Class',
    add_to_waiting_list: 'Add Student to Waiting List',
    delete_student: 'Remove Student from Class',
    reject_request: 'Decline Registration Request',
    reject_request_title: 'Decline Class Registration Request',
    reject_request_content: 'Please provide some feedback for the student:',
    reject_request_cancel: 'Cancel',
    reject_request_button: 'Decline Request',
    reject_request_error: 'You must provide some information.',
    merge_with: 'Partner with: {fullname}',
    name_placeholder: 'Class Name',
    capacity_placeholder: 'Maximum Couples/Students',
    select_students: 'Please select at least one student to continue',
    new_lead_modal: {
      title: 'Create new Lead',
      title_class: 'Select or Create Lead and add to Class',
      create: 'Create Lead',
      button: 'Create and Add to Class',
      button_add: 'Add to Class',
      create_error: 'Could not create the account, please review the information and try again',
      create_success: 'Lead created successfully',
      add_error: 'There was an error adding the lead to the class, please check if he/she is already in the class',
      reset: 'Reset'
    },
    make_up_class_modal: {
      title: 'Add Students or Make Up Class',
      student_title: 'Make Up Class',
      add_student: 'Add Student',
      add_lead: 'Add Lead',
      make_up_class: 'Make Up Class',
      cancel_button: 'Cancel & Go Back',
      add_user_message: 'Please note that this student will be added to the current Attendance List.<br/>It will not be added to other attendance lists nor to the class students.',
      field_student: 'Select a student:',
      field_class: 'Select a Student Class:',
      select_class: 'Select a Class:',
      select_student_class: '-- Select a Student and a Class --',
      field_date: 'Select a Date:',
      field_date_class: 'Select a Class:',
      error_no_active_classes: 'The student cannot make up a class as he / she is not currently enrolled in any active classes or has no attendance.',
      register_trial_payment: 'Register a {price} class trial (drop in) payment.',
      or: '- OR -'
    },
    single_payment: 'Single Payment',
    single_payment_info: 'If <b>ENABLED</b> the class will be marked as paid for all students with just a single payment from any of the students.<br/>If <b>DISABLED</b>, each student will have to make an independent payment. (default)',
    single_payment_note: 'This option is not compatible with the "included for membership" option.',
    schedule: {
      class_cancelled: 'The class was cancelled',
      class_schedule_updated: 'Class Schedule updated',
      cancelled: 'CANCELLED',
      active: 'ACTIVE',
      single_date: 'Single Date',
      recurrent_date: 'Recurrent Date',
      class: 'Class',
      event: 'Event',
      private_class: 'Private Class',
      new_item: 'New Schedule Item',
      create_class: 'Create Class',
      create_event: 'Create Event',
      create_and_edit: 'Create & Edit',
      couples: 'Couples',
      solo: 'Solo',
      name: 'Name',
      payment: 'Payment',
      multiple: 'Multiple',
      single: 'Single',
      register_payments: 'Create {num} payments for a total of {total}.',
      register_attendance: 'Create attendance records for {num} student/s.',
      style_level: 'Style/Level',
      start_end_time: 'Start/End Time',
      repeats: 'Repeats',
      until: 'Until',
      classroom: 'Classroom',
      venue: 'Venue',
      picture: 'Event Image',
      add_to_schedule_title: 'Add to Schedule',
      add_to_schedule: 'Add to Schedule',
      occurrences: 'instances',
      class_students: 'Class Students',
      class_teachers: 'Class Teachers',
      teachers: 'Add Teacher',
      modal_cancel: {
        title: 'Cancel Class',
        content: 'Do you really want to cancel the class scheduled for <b>{date}</b>?<br/>You can select to <b>notify</b> the currently registered students of this class, this action will <b>send an email </b> and a <b> mobile notification to each student</b> letting them know that the class has been cancelled.',
        button_cancel: 'Cancel Class',
        button_cancel_notify: 'Cancel & Notify Students',
        button_back: 'Back',
        check_notify_students: 'Notify class students by email and mobile notification',
        message_label: 'Include Message'
      },
      modal_restore: {
        title: 'Restore Canceled Class',
        content: 'Are you sure you want to restore this class? (no longer will be cancelled)',
        content_bold: 'Please note that notifications will not be sent to students.',
        button_restore: 'Restore',
        button_back: 'Back'
      },
      modal_delete: {
        title: 'Delete Class Schedule',
        content_datetime: 'This action will delete a single date from the class schedule.',
        content_series: 'This action will delete <b>all</b> the dates belonging to this schedule series.',
        button_delete: 'Delete',
        button_back: 'Back'
      },
      modal_edit: {
        button_back: 'Back',
        class_date: 'Class Date',
        save_changes: 'Save Changes'
      },
      modal_streaming: {
        title: 'Streaming Configuration',
        label_for: 'Configuration for',
        label_platform: 'Streaming platform',
        label_url: 'Streaming Link (URL)',
        label_password: 'Password (optional)',
        future_classes: 'This and future classes',
        button: 'Save Configuration',
        error: 'Error storing streaming configuration',
        success: 'Streaming configuration saved successfully',
        copy_error: 'Could not copy password to clipboard',
        copy_ok: 'The password has been copied successfully to the clipboard'
      },
      delete_date: 'Delete Date',
      delete_series: 'Delete Series',
      cancel_class: 'Cancel Class',
      restore_class: 'Restore Canceled Class',
      add_schedule: 'Add Schedule',
      edit: 'Edit',
      edit_date: 'Edit Date',
      edit_series: 'Edit Series',
      timeslot_cannot_edit: 'This schedule cannot be edited. Please delete it and re-create it in order to update it.',
      live_streaming: 'Enable live streaming for this class',
      streaming: 'Streaming Config.',
      streaming_new: 'Upcoming Classes',
      streaming_old: 'Past Classes',
      schedule_error: 'Could not save class schedule, please contact us.',
      more_than_18_months: 'Class schedules must be for a single academic year and cannot extend more than 18 months into the future.'
    },
    add_class_payment: 'Define a class payment for this teacher/class',
    teacher_payment_info: 'By default the teacher payment for this class will be calculated using the information of the teacher\'s profile.</br>Please <b>NOTE</b> that this value will override that payment configuration for this class. This value will be the whole payment for all the classes instances/hours.',
    confirmations: {
      title: 'Students Attendance Confirmation:',
      student: 'Student',
      email_sent: 'Email Sent',
      sent_datetime: 'Sent Date',
      last_response_datetime: 'Last Response Date',
      response: 'Response'
    },
    archive_confirmation: {
      title: 'Archive Class',
      content: 'You are about to archive this class. This action will cancel future class dates by updating the class configuration if needed. Archived classes will not be displayed on calendars/lists any longer.',
      button: 'Archive'
    },
    color_modes: {
      auto: 'Auto Color',
      styles: 'Class Style',
      locations: 'Location/Centre',
      teachers: 'Class Teachers'
    },
    teacher_filter: 'All Teachers',
    teacher_filter_selected: '{num} teachers selected',
    archive_modal: {
      info: 'Currently you have {num} classes expired for more than two months.',
      button: 'Archive {num} classes',
      ignore: 'Ignore expired classes',
      archived: 'Classes archived successfully'
    },
    week_config: {
      start_time: 'Start Time',
      end_time: 'End Time',
      visible_days: 'Visible Days',
      button: 'Save',
      title: 'Week Calendar Options',
      show: 'Show Details',
      style_level: 'Style & Level',
      class_time: 'Schedule',
      classroom: 'Classroom',
      teachers: 'Teachers'
    }
  },
  newItemModal: {
    select_classroom: '-- CLASSROOM --',
    select_venue: '-- VENUE --',
    select_event_type: '-- EVENT TYPE --',
    holiday: 'Holiday',
    repeat_options: [
      {
        code: 'no_repeat',
        name: 'Doesn\'t Repeat',
        icon: 'calendar-day'
      },
      { divider: true },
      {
        code: 'weekly',
        name: 'Weekly',
        icon: 'calendar-week'
      },
      {
        code: 'monthly',
        name: 'Monthly',
        icon: 'calendar'
      },
      {
        code: 'custom',
        name: 'Custom',
        icon: 'calendar-alt'
      }
    ]
  },
  member: {
    members: 'Members',
    active: 'Active',
    login: 'Can login',
    disabled: 'The member is disabled',
    cannot_login: 'The member cannot access the application.',
    no_classes: 'The student does not have any Classes yet',
    without_membership: 'Without Membership',
    no_membership: '-- No Membership --',
    select_membership: '-- Select Membership --',
    select_style: '-- Select Style --',
    select_class: '-- Select Class --',
    select_tags: '-- Select Tag --',
    select_voucher: '-- Select Voucher --',
    select_class_status: '-- Filter by Status --',
    select_no_classes: 'Without Active Classes',
    auto_membership: '-- AUTO Membership--',
    error_auto_membership: 'Insufficient advanced memberships configuration',
    no_membership_payment: 'This student does not have any membership assigned.<br/>The automatic result of the membership fee will be inaccurate.',
    postal_address: 'Enter Home Address',
    id_number: 'Enter ID/Passport Number',
    postal_code: 'Enter Zip/Postal Code',
    terms_accepted: 'Terms Signed / Accepted',
    photo_release_signed: 'Photo Release Signed',
    cancel: 'Cancel',
    save: 'Save',
    button_delete: 'Delete',
    cannot_delete_tooltip: 'This account has either payments or attendance data, therefore it cannot be deleted. Please try to disable the account instead.',
    send_invite: 'Send Invite',
    last_invite: 'Last invite sent on: {datetime}',
    impersonate: 'Impersonate',
    impersonate_confirmation: 'Impersonate Confirmation',
    impersonate_text: 'You are about to impersonate the selected account, you will be able to see and use the application as that user.',
    impersonate_warning: '<b>Warning:</b> All your actions will be recorded as the selected account and those actions cannot be undone.',
    impersonate_back: 'Back to {name}',
    invite: {
      cancel: 'Cancel',
      send: 'Send Email',
      email_lang: 'Email language',
      confirmation: 'Invite Email Confirmation',
      confirm_send_invite: 'You are about to send an invite email to {name}. This action will:',
      confirm_items: [
        'Activate the user in the platform',
        'Enable login for the user',
        'Create a temporary password',
        'Email the user the login information',
        'The user will have to enter a new password after the first successful login'
      ],
      cannot_be_undone: 'This action cannot be undone',
      last_invite: 'You already sent an invite email to {name} on {datetime}',
      invite_sent: 'Invite sent to {email}'
    },
    update_avatar: 'Update Avatar',
    error_format: 'Only JPEG / PNG images are supported',
    roles: {
      admin: 'Administrator',
      manager: 'Manager',
      teacher: 'Teacher',
      student: 'Student',
      relative: 'Relative',
      subscriber: 'Subscriber',
      lead: 'Lead'
    },
    roles_error: 'Please select at least one role',
    classes_status: 'Classes Status',
    add_tags: 'Add Tags',
    create_new_tag: 'Create new tag',
    payments_section: {
      new_payment: 'Register new payment',
      new_payment_tooltip: 'Record a manual payment made offline',
      new_debt: 'Register student Debt',
      new_debt_tooltip: 'Generates a new debt for this student so it can be notified and paid online (if online payments enabled)',
      date: 'Date',
      time: 'Time',
      amount: 'Amount',
      details: 'Details',
      discount: 'Discount',
      confirmation: 'Confirmation',
      confirm_delete: 'Are you sure that you want to delete the payment?',
      cannot_be_undone: 'This action cannot be undone',
      save: 'Save Payment',
      delete: 'Delete Payment',
      cancel: 'Cancel',
      undo: 'Undo Changes',
      change_class: 'Change Class',
      type: 'Type',
      period: 'Period',
      class: 'Class',
      notes: 'Notes',
      event: 'Event',
      select_event: 'Select an Event',
      license_expiration: 'License Expiration',
      delete_payment: 'Delete this payment',
      cannot_delete_cc: 'Online credit card transactions cannot be modified',
      license_will_expire: 'The license will expire on <b>{date}</b>',
      no_payments: '-- There are no payments created for this student yet --',
      ignore_until: 'Ignore Until',
      ignore_forever: 'Ignore Forever',
      types: {
        belt: 'Belt Payment',
        membership: 'Membership Fee',
        class: 'Class Payment',
        other: 'Other Payment',
        license: 'License/Registration Fee',
        event: 'Event Payment',
        pack: 'Intensive Pack',
        num_classes: 'Amount Classes',
        voucher_voucher: 'Voucher Pack',
        voucher_trial: 'Trial Class',
        voucher: 'Voucher Pack',
        trial: 'Trial Class',
        refund: 'Refund'
      },
      types_short: {
        class: 'Class',
        membership: 'Membership',
        belt: 'Belt',
        event: 'Event',
        license: 'License',
        other: 'Other',
        pack: 'Pack',
        voucher: 'Voucher',
        refund: 'Refund',
        trial: 'Trial'
      },
      select_months: '-- Select Months --',
      student_debts: 'Outstanding Debts:',
      student_payments: 'Payment History:',
      debt_license: 'License expired and not renewed.',
      debt_license_expired: ' Expired on {date}',
      debt_num_classes: 'Excess in number of classes/month: {num_classes}',
      debts_columns: {
        month: 'Month',
        type: 'Type',
        details: 'Details',
        amount: 'Amount',
        total: 'Total'
      },
      debt_types: {
        belt: 'Belt Payment',
        membership: 'Membership Fee',
        class: 'Class Payment',
        license: 'License/Registration Fee',
        num_classes: 'Number of Classes',
        other: 'Other Payments',
        event: 'Event Ticket',
        voucher: 'Voucher Pack'
      },
      manual_debt: 'Manual debt',
      no_trial_classes: 'No trial classes found',
      select_trial_class: '-- Select a Trial Class --',
      voucher_classes: 'Number of Classes',
      voucher_classes_total: 'Classes',
      voucher_classes_total_tooltip: 'Amount of classes included in this voucher',
      voucher_classes_used: 'Used',
      voucher_classes_used_tooltip: 'Amount of used classes',
      voucher_classes_available: 'Available',
      voucher_classes_available_tooltip: 'Remaining classes available',
      voucher_classes_list: 'Classes Included',
      voucher_exhausted: 'Voucher Exhausted',
      add_class: 'Add Class',
      payment_link_tooltip: 'Generate a new Payment Link or Review an existing one',
      payment_link_expired_tooltip: 'The Payment Link has expired',
      link_modal_title: 'Generate Payment Link',
      link_modal_content: 'You can generate a payment link to be sent to a student using an external email client. Please select the desired expiration span in which this payment link will be available.',
      expirations: {
        week: '1 Week',
        week_2: '2 Weeks',
        month: '1 Month',
        no_exp: 'No Expiration'
      },
      expiration_label: 'Link Expiration',
      link_label: 'Payment URL/Link',
      link_expiration: 'Expiration Date',
      link_unlimited_expiration: 'Without Expiration',
      link_copy: 'Copy Link to Clipboard',
      close_modal: 'Close',
      generate_link: 'Generate Payment Link',
      delete_link: 'Delete Link',
      renew_link: 'Renew Link',
      payments_configuration: 'Payments Configuration',
      generate_link_conflict: 'There is a link already generated for this debt.',
      copy_clipboard_ok: 'Payment Link copied to Clipboard',
      copy_clipboard_error: 'The link could not be copied, please copy the link manually',
      no_stripe: 'In order to generate payment links you need to enable the <b>Online Payments</b> and link Kydemy to one of our payment providers.',
      register_payment: 'Register student payment for {amount}',
      select_payment_method: 'Select payment method:',
      proportional: '* Proportional price for the {numDays} remaining days of this month.',
      refund_modal: {
        title: 'Refund Payment',
        content: 'Please note that the amount cannot exceed the payment amount of <b class="has-text-info">{amount}</b>. You can also delete/edit the payment if you created the payment by mistake or the information contains errors.',
        bold_content: 'Please enter the amount to be refunded:',
        refund_button: 'Refund Amount',
        close_button: 'Cancel Refund',
        refund_method: 'Refund Method'
      },
      ignore_debt: 'Ignore this debt',
      ignore_debt_title: 'Ignore Debt Confirmation',
      ignore_debt_content: 'You are about to ignore a student debt. Please note that this action is permanent and should only be used to address very rare situations.',
      ignore_debt_content_bold: 'You should NOT be ignoring a debt if:',
      ignore_debt_button: 'Ignore Debt',
      ignore_debt_items: [
        '<b>The debt is result of a trial/test class:</b> use trial class payment',
        '<b>The student did not attend class:</b> fix the student attendance.',
        '<b>The student is exempt of payment:</b> add student to payments white list.'
      ],
      update_payment_amount_with_discount: 'If you modify the amount of this payment, the discount information will be lost as the discount cannot be computed for an arbitrary amount.',
      new_payment_modal: {
        title_payment_type: 'Select payment type',
        title_debts_type: 'Select debt type',
        create_payment: 'Create Payment',
        create_debt: 'Create new Debt',
        edit_payment: 'Update Payment',
        delete_payment: 'Delete Payment',
        label_payment_method: 'Payment Method',
        label_location: 'Payment Location',
        label_extra: 'Show advanced options',
        label_comments: 'Comments & notes',
        label_vat: 'VAT / TAX',
        label_date: 'Payment Date/Time',
        label_discount: 'Discount',
        label_subtotal: 'Price - Subtotal',
        label_taxbase: 'Tax base',
        label_override_total_amount: 'Overwrite Amount',
        section_base: 'BASE',
        section_discount: 'DISCOUNT',
        section_vat: 'Taxes - {vat}%',
        section_total: 'TOTAL',
        no_discount: '-- NO DISCOUNT --',
        on_payment_success: 'Payment data saved successfully',
        on_payment_deleted: 'The payment has been deleted',
        on_payment_error: 'Error generating the payment',
        on_payment_error_delete: 'Error deleting the payment',
        _vat: 'Default VAT',
        _no_vat: 'No Tax / VAT',
        memberships: {
          payment_title: 'New Membership Fee payment',
          debts_title: 'New Membership Debt',
          label_membership: 'Membership Fee',
          label_span: 'Span / Length',
          label_months: 'Selected Months'
        },
        classes: {
          label_show_all_classes: 'Show all classes',
          payment_title: 'New Class payment',
          debts_title: 'New Class Debt',
          label_class: 'Select a Class'
        },
        events: {
          payment_title: 'New Event payment',
          debts_title: 'New Event Debt',
          label_event: 'Select an Event'
        },
        belts: {
          payment_title: 'New Belt/Exam payment',
          debts_title: 'New Belt/Exam Debt',
          label_belt: 'Select a Belt'
        },
        others: {
          payment_title: 'Create Other payment',
          debts_title: 'Create Other Debt',
          label_notes: 'Payment Details'
        },
        licenses: {
          payment_title: 'Create License/Registrations fee payment',
          debts_title: 'Create License/Registrations fee Debt',
          label_expiration: 'Expiration Date'
        },
        vouchers: {
          payment_title: 'Create classes voucher payment',
          debts_title: 'Create classes voucher payment',
          label_voucher_type: 'Voucher Type',
          custom_button: 'Custom Voucher',
          predefined_button: 'Predefined Voucher',
          label_voucher: 'Selected Voucher',
          voucher_title: '{name} - {num} classes',
          num_classes: '{num} classes',
          generic_voucher: 'Classes voucher',
          label_classes_included: 'Classes Included',
          label_price: 'Voucher Price',
          override_expiration: 'Override Expiration'
        },
        trials: {
          payment_title: 'Create a trial class payment',
          label_trial_type: 'Class trial type',
          select_trial_button: 'Unpaid Trial Class',
          calendar_button: 'New Class/Date trial',
          label_select_trial: 'Pick a Trial Class',
          label_class: 'Select a Class',
          label_date: 'Class Date'
        }
      }
    },
    attendance_section: {
      attended: 'Attended',
      non_attended: 'Non Attended',
      substitutions: 'Substitutions',
      make_up: 'Make Ups',
      made_up: 'Made Ups',
      only_active: 'Active Classes',
      all_classes: 'All Classes',
      total: 'Total'
    },
    dob: 'Date of Birth',
    membership: 'Membership',
    discount: 'Discount',
    no_discount: '-- No Discount --',
    roles_label: 'Roles',
    no_roles: 'Please Select',
    no_role: 'Select a Role',
    msg_created: 'Student created successfully',
    msg_updated: 'Student updated successfully',
    msg_update_error: 'The student could not be updated, please contact us or try again',
    msg_avatar_updated: 'Avatar uploaded and updated successfully',
    sections: {
      details: 'Profile',
      settings: 'Settings',
      classes: 'Classes',
      payments: 'Payments',
      comments: 'Comments',
      attendance: 'Attendance',
      timekeeper: 'Working Hours',
      wages: 'Wages',
      attachments: 'Files',
      documents: 'Documents'
    },
    leader: 'Leader',
    follower: 'Follower',
    leader_info: 'Leader: is in the couple who invites the follower to make certain movements and figures while listening to the music to play it',
    follower_info: 'Followe: is in the couple who plays the music and indications of the leader',
    dance_role: 'Dance Role',
    details: 'Details',
    levels: 'Levels',
    no_levels: '-- No Levels --',
    now: 'Today',
    start: 'Start',
    search: {
      no_results: '-- No Results --',
      classes_month: 'Classes Month',
      search: 'Search',
      meets_requirements: 'Meets Requirements',
      insufficient_level: 'Insufficient Level',
      other: 'Other'
    },
    requirements: {
      cancel: 'Cancel',
      update_add: 'Update & Add to Class',
      add: 'Add to Class',
      title: 'Class Requirements:',
      content: 'One or both members of the selected couple do not meet the minimum requirements of this class. You can choose one of the following options:',
      content_update: '<b>Update & Add to Class:</b> this action will update each member of the couple so they have have the minimum level required by this class.',
      content_add: '<b>Add to Class:</b> this action will add the couple as is to the class, even if the do not meet the requirements of the class.'
    },
    relatives: 'Relatives',
    use_account_contact_info: '-- Use Account Contact Info --',
    no_relatives: 'This account does not have relatives associated yet',
    relatives_trash: 'Delete Relative',
    relatives_edit: 'Edit Relation Type',
    relatives_save: 'Save Relation Type',
    relatives_undo: 'Cancel',
    add_relative: 'Add Relative:',
    create_relative_account: 'New Account',
    existing_relative_account: 'Existing Account',
    relative_types: {
      spouse: 'Spouse',
      partner: 'Partner',
      parent: 'Parent',
      sibling: 'Sibling',
      grandparent: 'Grandparent',
      child: 'Child',
      grandchild: 'Grandchild',
      cousin: 'Cousin',
      other: 'Other'
    },
    teacher_classes: 'Teacher Classes:',
    student_classes: 'Student Classes:',
    trial_classes: 'Trial / Drop-in Classes:',
    add_class: 'Add Classes',
    add_class_modal: {
      title: 'Add Student to Classes',
      content: 'Please select the classes that you want to enroll the current student.',
      content_bold: 'Only classes for the student style/level are displayed. Please update the Style/Levels in the Settings tab.',
      add_button: 'Add to Classes',
      ignore_style_level: 'Ignore Styles/Levels and show all classes',
      success: 'Student successfully added to the selected class',
      error: 'Could not add student to class',
      delete_success: 'The student was removed from the class',
      delete_error: 'The student could not be removed from the class'
    },
    delete_class_confirm: {
      title: 'Remove Student from Class',
      content: 'You are about to remove this student from the class.<br/>Do you want to proceed?',
      button: 'Remove Student Class'
    },
    delete_classes_confirm: {
      title: 'Remove student from classes',
      content: 'In order to mark this student as inactive, you must remove him from his classes. <br/>¿Are you sure you want to remove him from all of his classes?',
      button: 'Remove from all classes'
    },
    delete_account_confirm: {
      title: 'Delete Account',
      content: 'You are about to delete this account and all their associated information: messages, activity, etc. Are you sure that you want to proceed?'
    },
    delete_success: 'Account deleted successfully',
    delete_error: 'An unexpected error ocurred, the account was not deleted.',
    timekeeper: {
      label_enabled: 'Register Working Hours',
      label_ssn: 'Social Security Number',
      label_working_hours: 'Working Hours',
      label_break_hours: 'Rest/Lunch Hours',
      label_working_days: 'Working Days',
      label_save: 'Save Settings',
      label_edit: 'Edit',
      no_records: 'There are no Working Hours recorded by this employee',
      report_file: '{month} Working Hours for {employee}',
      start_work: 'Begin Work Day',
      pause_work: 'Take a Break',
      resume_work: 'Resume Work',
      end_work: 'End Work Day',
      unstop_work: 'Undo Stop & Continue',
      work_started: 'Work Started',
      work_ended: 'Work Ended',
      work_paused: 'Break Started - Work Paused',
      work_resumed: 'Break Ended - Work Resumed',
      error_updating: 'Error updating time record',
      breaks_updated: 'Break Time Updated',
      day: 'Date',
      day_start: 'Start',
      day_end: 'End',
      day_breaks: 'Breaks',
      day_hours: 'Hours Worked',
      day_expected_hours: 'Planned Hours',
      day_effective_hours: 'Effective Hours',
      day_balance: 'Balance',
      total: 'Total',
      no_breaks: 'No Breaks Recorded, using default configuration.',
      in_break_label: 'BREAK',
      confirm_unstop_title: 'Undo Stop & Continue Work',
      confirm_unstop_content: 'You can cancel the Stop action and continue working. Please update the time assigned to breaks accordingly if necessary.',
      confirm_unstop_button: 'Undo Stop',
      minutes: 'minutes',
      hours: 'hours',
      confirm_logout_title: 'Work in Progress',
      confirm_logout_content: 'You are about to sign out, but currently you are recording work time. Please select if you wish to sign-out and keep recording time, pause or stop today\' work.',
      confirm_logout_button_logout: 'Sign Out',
      confirm_logout_button_pause: 'Pause & Sign Out',
      confirm_logout_button_stop: 'Stop & Sign Out',
      in_progress: 'In Progress',
      unregistered: 'Unregistered',
      employee_report_signed: 'Employee Signature',
      company_report_signed: 'Company Signature',
      signature_same_month: 'Signatures not available: Month unfinished',
      report_not_signed: 'Signature Pending',
      report_signed: 'Hours Report Signed',
      sign_employee: 'Sign (employee)',
      sign_company: 'Sign (company)',
      sign_button: 'Sign Report',
      signature_modal_title: 'Sign Working Hours Report',
      signature_modal_content: 'Please draw your signature in the box bellow:',
      error_no_signature: 'Please provide a valid signature',
      signed_success: 'Signature stored successfully',
      signed_error: 'There was an error saving the signature',
      create_new_record: 'Create new record',
      update_record_success: 'Record updated successfully',
      update_record_error: 'Error updating record, please contact us',
      new_record_modal: {
        title: 'Create new Record/s',
        start: 'Start Time',
        end: 'End Time',
        duration: 'Breaks in minutes',
        button: 'Create Record/s',
        success: 'Day/s record/s created successfully',
        error: 'Error creating record/s'
      }
    },
    wages: {
      go_back: 'Close & Go Back',
      save: 'Save Details',
      wage_modality: 'Wage Modality:',
      mode_month: 'Monthly Salary',
      mode_hour: 'Hourly Wage',
      mode_class: 'Class Wage',
      null_label: 'Please Select a Modality:',
      month_label: 'Monthly Remuneration:',
      hour_label: 'Hourly Rate Remuneration:',
      class_label: 'Per Class Remuneration:',
      update_success: 'Wage Information Updated',
      no_wages_data: 'Wage Details not Configured',
      tag_per_month: 'Month',
      tag_per_hour: 'Hour',
      tag_per_class: 'Class',
      hours: 'Hours',
      minutes: 'Minutes',
      no_teachers_attendance_list: 'There is no teacher attendance information for this day',
      payment_type: 'Payment Type',
      date: 'Date',
      time: 'Lective Time',
      attendance_list: 'Att. List',
      attended: 'Attended',
      payment: 'Amount',
      totals: 'Totals',
      no_payment_data: 'There is no payment data for this teacher and for the selected month.',
      class_month_payments_note: '<b>NOTE:</b> The total amount of attendance lists or teacher attendance records are not computed for Monthly salaries or Whole Classes payments.',
      payment_types: {
        month_wage: 'Monthly Salary',
        hour_wage: 'Hourly Salary',
        class_wage: 'Class Salary',
        attendance_payment: 'Attendance Payment',
        no_attended: 'No Attendance',
        class_payment: 'Whole Class Payment'
      },
      delete_confirm: {
        title: 'Delete Wage Information',
        content: 'This action will permanently delete a wage information entry. By doing so, you may cause an impact on historic information and reports, resulting in inaccurate information/results. Do you really want to delete this entry?',
        button: 'Delete',
        success: 'Wage information deleted',
        error: 'Could not delete this record, please contact us'
      },
      update_confirm: {
        title: 'Update Wage Information',
        content: 'This action will permanently modify a wage information entry. By doing so, you may cause an impact on historic information and reports, resulting in inaccurate information/results. Do you really want to update this entry?',
        button: 'Update',
        success: 'Wage information updated',
        error: 'Could not update this record, please contact us'
      }
    },
    notes: {
      disclaimer: 'These notes will NOT be visible for students',
      student_notes: 'Student Notes',
      success: 'Notes updated successfully',
      error: 'Error updating notes, please contact us'
    },
    attachments: {
      no_attachments: '-- No files have been uploaded yet --',
      upload: 'Upload File',
      attachments_error_type: 'Only MS Office / LibreOffice / iWork documents, PDFs and images are allowed',
      attachments_error_size: 'Only files up to {size} MiB are allowed',
      upload_success: 'File uploaded successfully',
      upload_error: 'Error processing file, please try again later',
      delete_success: 'File deleted successfully',
      delete_error: 'There was an error deleting the file, try again later',
      new_file_modal: {
        title: 'Upload new file',
        upload: 'Create File',
        name: 'Name:',
        tags: 'Tags:'
      },
      columns: {
        name: 'Name',
        file_name: 'Filename',
        file_date: 'Date',
        file_size: 'Size',
        file_type: 'Type',
        tags: 'Tags',
        visible: 'Student Access',
        classes: 'Classes',
        student: 'Student'
      },
      delete_modal: {
        title: 'Delete File',
        content: 'Are you sure that you want to delete this file?',
        button: 'Delete File'
      }
    },
    devices: {
      mobile: 'Mobile',
      web: 'Browser'
    },
    terms_modal: {
      title: 'Student Terms & Conditions Signature',
      new_button: 'Sign Document',
      save_button: 'Save Signature',
      clear_button: 'Clear',
      save_success: 'Signature stored successfully',
      save_error: 'Signature could not be saved, please contact us',
      show_terms_button: 'Show Document',
      terms_accepted: 'Terms Signed',
      terms_not_accepted: 'Terms NOT Signed',
      terms_accepted_no_signature: 'Terms Accepted, NOT signed',
      download_button: 'Generate PDF',
      generate_pdf: 'Download PDF'
    },
    classes_schedule: {
      title: 'Schedule Availability',
      button: 'Add hours to availability'
    },
    extra_memberships: {
      add_extra: '-- Add Extra Membership --',
      select_extra: '-- Select Extra Membership --'
    },
    classes: {
      statuses: {
        active: 'Ongoing Classes',
        future: 'Upcoming Classes',
        trial: 'Trial Classes',
        past: 'Previous Classes',
        booking: 'Booked Classes',
        booking_waiting_list: 'Book Class Waiting List',
        waiting_list: 'Waiting List',
        planned: 'Planned Classes'
      }
    }
  },
  finances: {
    tabs: {
      payments: 'Payments',
      debts: 'Debts',
      expenses: 'Expenses',
      cashbox: 'Cashbox',
      invoices: 'Invoices',
      remittances: 'Remittances'
    },
    cashbox: {
      cashboxes: 'Cashboxes',
      cashbox_operations: 'Operations / Movements',
      empty: 'There is no cashbox information, please use the button bellow to open/start your cashbox.',
      open_button: 'Open Cashbox',
      close_button: 'Close Cashbox',
      open_success: 'Cashbox opened successfully',
      open_error: 'There was an error preparing the cashbox information',
      withdrawal: 'Withdrawal',
      deposit: 'Deposit',
      open: 'Open',
      close: 'Close',
      current: 'Current',
      closed: 'Closed',
      tooltip_withdrawal: 'New Withdrawal',
      tooltip_deposit: 'New Deposit',
      operation_success: 'Operation processed successfully',
      operation_error: 'The operation could not be completed, please contact us',
      amount: 'Amount',
      observations: 'Observations',
      report_filename: 'Cashbox Export',
      report_month: 'Export month cashboxes',
      week: 'Week',
      close_modal: {
        title: 'Close Cashbox',
        content: 'Please enter the value of the contents of the cashbox and your observations if needed:',
        content_bold: 'This action cannot be undone, please review before all payments before closing.',
        button: 'Close Cashbox'
      },
      open_modal: {
        title: 'Open Cashbox',
        content: 'Please enter the current amount in the cashbox to start your activity:',
        button: 'Start Cashbox'
      },
      deposit_modal: {
        title: 'New Deposit',
        content: 'Please enter the deposit amount and provide additional observations if needed:',
        button: 'Create Deposit'
      },
      withdrawal_modal: {
        title: 'New Withdrawal',
        content: 'Please enter the withdrawal amount and provide additional observations if needed:',
        button: 'Create Withdrawal'
      },
      columns: {
        date: 'Date',
        teller: 'Teller',
        student: 'Student',
        details: 'Details',
        amount: 'Amount',
        accumulated: 'Accumulated',
        difference: 'Difference'
      }
    },
    remittances: {
      no_remittances: 'We have been unable to calculate remittances/debts for this month. Please note that students must have a bank account added to their profile and for membership payments, the selected months should not be excluded in the memberships configuration.',
      remittances_info: 'Only students with Bank Accounts are shown / exported',
      download_button: 'Download Spreadsheet XLSX',
      download_xml_button: 'Download SEPA XML',
      generate_payments: 'Mark Selected as Paid',
      show_deleted: 'Show Deleted',
      hide_deleted: 'Hide Deleted',
      report_name: 'Remittances',
      membership_current: 'current',
      membership_default: 'computed',
      membership_override: 'override',
      columns: {
        student: 'Student',
        type: 'Type',
        details: 'Details',
        amount: 'Amount',
        discount: 'Discount',
        account: 'Account'
      },
      generate_payments_modal: {
        title: 'Confirm: Generate Payments',
        content: 'This action will generate <b class="has-text-info">{num}</b> payment records in Kydemy for the selected students / payments.',
        button: 'Generate Payments',
        success: 'Payments generated successfully',
        error: 'Could not generate all payments, please reload and try again. If the problem persists, please contact us.'
      },
      xml_modal: {
        title: 'Generate SEPA Remittances XML',
        content: 'Please review/edit your business information in order to generate a valid SEPA remittances file that you will be able to upload to your bank.',
        content_bold: 'You must have completed/signed direct debit authorization SEPA mandate forms for each student.',
        business_name: 'Business name',
        business_id: 'Business ID/VAT',
        business_iban: 'Business Account IBAN',
        business_bic: 'Business Account/Bank BIC',
        button: 'Generate SEPA XML',
        advanced_hide: 'Hide advanced details',
        advanced_show: 'Show advanced details',
        advanced_tooltip: 'If you are not sure, leave this field empty',
        suffix: 'Business line suffix',
        creditor_id: 'Creditor ID',
        button_save: 'Save Account Info',
        button_delete: 'Delete Account',
        account_alias: 'Account Alias',
        success: 'Account saved successfully',
        error: 'Could not save account',
        delete_success: 'Account deleted successfully',
        delete_error: 'Could not delete account',
        empty_message: 'In order to generate remittances XML files (SEPA Direct debit mandates), you need to provide your business/bank data (creditor account information). Click the following button to create a new SEPA creditor account.',
        empty_message_button: 'Create Creditor Account'
      }
    }
  },
  expenses: {
    select_month: 'Select Month',
    new_expense: 'New Expense',
    no_expenses: '-- No Expenses have been registered yet --',
    no_expenses_month: '-- No Expenses have been registered for the selected month --',
    file_error: 'There was an error processing the invoice file, please try again later or contact us.',
    file_error_type: 'Invalid invoice file type, only PDF and JPEG images are supported.',
    file_error_size: 'Invoice files cannot exceed 5MB, this file weights {size}',
    expense_success: 'Expense saved successfully',
    expense_error: 'There was an error saving the expense, please contact us',
    delete_title: 'Delete Expense Invoice',
    delete_content: 'You\'re about to permanently delete an expense invoice, do you want to proceed?',
    delete_button: 'Delete Expense',
    delete_success: 'The expense has been deleted successfully',
    delete_error: 'There was an error deleting the expense, please try again or contact us.',
    columns: {
      type: 'Type',
      provider: 'Provider',
      tax_id: 'TAX ID',
      created: 'Created/Due',
      status: 'Status',
      vat: 'VAT',
      amount: 'Total Amount'
    },
    expense_modal: {
      payer_business: 'Payer Business',
      provider_business: 'Provider Business',
      invoice_category: 'Invoice Category',
      invoice_status: 'Invoice Status',
      invoice_vat: 'Invoice VAT',
      invoice_amount: 'Invoice Amount',
      invoice_title: 'Invoice Concept',
      invoice_number: 'Invoice Number',
      invoice_date: 'Invoice Date',
      invoice_file: 'File/Picture',
      withholding_percent: 'Withholding Tax',
      withholding_amount: 'Withholding Amount',
      local_amount: 'Local Amount',
      local_amount_tooltip: 'Please add the value of this invoice in your local currency, you can check your bank statements or use a currency conversion calculator.',
      currency: 'Invoice Currency',
      due_date: 'Due Date',
      paid_date: 'Payment Date',
      observations: 'Observations',
      advanced_fields: '-- Advanced Fields --',
      status: {
        open: 'Open',
        overdue: 'Overdue',
        paid: 'Paid'
      },
      save: 'Save Expense',
      delete_title: 'Confirmation: Delete Attachment',
      delete_content: 'You are about to delete the expense attachment "{name}" permanently, do you want to proceed?',
      delete_button: 'Delete Attachment',
      delete_error: 'Error deleting the attachment, please try again or contact us',
      delete_success: 'Attachment deleted successfully'
    },
    business_selector: {
      new_business: '-- New Business --',
      title: 'Register a new Business',
      name: 'Name',
      vat: 'VAT Number',
      phone_number: 'Phone Number',
      email: 'Email Address',
      postal_code: 'Zip/Postal Code',
      category: 'Category',
      button: 'Register Business'
    },
    report_name: 'Expenses',
    category_selector: {
      select: '-- Choose a Category --',
      categories: {
        rent_mortgage: 'Rent & Mortgage',
        rent: 'Rent',
        mortgage: 'Mortgage',
        utilities: 'Utilities',
        electricity: 'Electricity',
        gas: 'Gas',
        water: 'Water',
        cellphone: 'Cellphone',
        phone: 'Phone',
        internet: 'Internet',
        air_conditioning: 'Air conditioning',
        trash: 'Trash',
        furniture_hardware: 'Furniture & Hardware',
        furniture: 'Furniture',
        computers: 'Computers',
        hardware: 'Hardware & Lighting',
        pos: 'POS',
        machinery: 'Machinery',
        supplies: 'Supplies',
        stationery: 'Stationery',
        ink: 'Ink',
        cleaning: 'Cleaning',
        ads_marketing: 'Ads & Marketing',
        internet_ads: 'Internet ads',
        physical_ads: 'Physical ads',
        giveaways: 'Giveaways',
        cards_flyers: 'Cards flyers',
        community_manager: 'Community manager',
        agency: 'Agency',
        software: 'Software',
        website: 'Website',
        domains: 'Domains',
        certificates: 'Certificates',
        support: 'Support',
        saas: 'Saas',
        travel: 'Travel',
        tickets: 'Tickets',
        travel_gas: 'Travel gas',
        meals: 'Meals',
        accommodation: 'Accommodation',
        rental: 'Rental',
        service: 'Service',
        vehicle: 'Vehicle',
        maintenance: 'Maintenance',
        vehicle_gas: 'Vehicle gas',
        insurance: 'Insurance, Licenses & Certificates',
        insurances: 'Insurances',
        office_insurance: 'Office insurance',
        occupational_insurance: 'Occupational insurance',
        life_insurance: 'Life insurance',
        disability_insurance: 'Disability insurance',
        other_insurance: 'Other insurance',
        licenses: 'Licenses',
        federation_license: 'Federation license',
        instructor_license: 'Instructor license',
        judge_license: 'Judge license',
        club_license: 'Club license',
        health_permit: 'Health permit',
        copyright_license: 'Copyright license',
        other_license: 'Other license',
        employees: 'Employees',
        wage: 'Wage',
        bonus: 'Bonus',
        commission: 'Commissions',
        present: 'Presents',
        benefits: 'Benefits',
        health: 'Health insurance',
        workers_compensation: 'Workers compensation',
        retirement: 'Retirement',
        self_employment: 'Self employment',
        taxes: 'Taxes',
        property: 'Property',
        business: 'Business',
        payroll: 'Payroll',
        social_security: 'Social security',
        other_taxes: 'Other taxes',
        professional_services: 'Professional services',
        marketing: 'Marketing',
        design: 'Design',
        legal: 'Legal',
        labor: 'Labor',
        tax: 'Tax',
        it: 'IT',
        external_teacher: 'External teacher',
        other: 'Other',
        training_education: 'Training education',
        training: 'Training',
        conferences: 'Conferences',
        workshops: 'Workshops',
        private_classes: 'Private classes',
        events: 'Events',
        venue_rental: 'Venue rental',
        food: 'Food',
        beverage: 'Beverage',
        catering: 'Catering',
        tickets_identification: 'Tickets & Identification',
        promotion: 'Promotion',
        entertainment: 'Entertainment',
        event_decoration: 'Event decoration',
        renovation: 'Renovation',
        decoration: 'Decoration'
      }
    }
  },
  payments: {
    no_payments_day: 'There are no payments registered for the selected date',
    payments: 'Payments',
    debts: 'Debts',
    payments_for: 'Payments for',
    debts_for: 'Debts for',
    total: 'Total',
    total_debt: 'Total to be Paid',
    time: 'Time',
    member: 'Student',
    membership: 'Membership',
    type: 'Payment Type',
    method: 'Payment Method',
    method_refund: 'Refund Method',
    months: 'Months',
    amount: 'Amount',
    payments_day: 'Day',
    payments_month: 'Month',
    types: {
      month: 'Month',
      trimester: 'Quarter',
      year: 'Year',
      custom: 'Custom'
    },
    debt_header_memberships: 'Membership Fees Debts',
    debt_header_classes: 'Classes Debts',
    debt_header_events: 'Events Debts',
    debt_header_vouchers: 'Class Vouchers Debts',
    debt_header_others: 'Other Payments Debts',
    debt_header_belts: 'Belts / Exams Debts',
    debt_header_licenses: 'Licenses / Registrations Fees Debts',
    debt_header_num_classes: 'Number of Classes Warning',
    expired: 'License Expired',
    no_license_expiration: 'No last license information',
    sub_total_members: 'Sub Total Memberships {code}',
    total_memberships: 'Total Memberships',
    attendance_details: 'Attendance Details',
    membership_classes_month: 'Max Classes Allowed',
    classes_attended: 'Classes Attended',
    class: 'Class',
    total_classes: 'Total Classes',
    total_vouchers: 'Total Class Vouchers',
    total_trials: 'Total Trial Classes',
    event: 'Event',
    total_events: 'Total Events',
    belt: 'Belt',
    total_belts: 'Total Belts',
    notes: 'Notes',
    total_others: 'Total Other Payments',
    total_refunds: 'Total Refunds',
    expires: 'Expiration',
    total_licenses: 'Total License Payments',
    classes: 'Intensives Included',
    voucher_classes: 'Voucher Classes',
    trial_class: 'Trial Class',
    total_packs: 'Total Intensive Packs Payments',
    no_debts: 'There are no payments registered for this month or all payments are up to date. Debts will be computed only for those months in which there are payments made.',
    debts_with_attendance: 'Only members that have attended classes within the selected month will be displayed.',
    debts_without_attendance: 'Only students that have NOT attended any classes within the selected month will be displayed or enrolled in intensive classes or workshops that have not been paid yet.',
    with_attendance: 'With Attendance',
    without_attendance: 'Without Attendance',
    number: 'Number of Payments',
    download_xlsx: 'Download Spreadsheet',
    download_pdf: 'Download PDF',
    download_reports: 'Download Receipts',
    generating_zip: 'Generating Zip file...',
    payment_types: {
      class: 'Class Payments',
      membership: 'Membership Payments',
      event: 'Event Payments',
      license: 'License Payments',
      belt: 'Belt Payments',
      pack: 'Intensive Packs Payments',
      other: 'Other Payments',
      voucher: 'Voucher Pack',
      trial: 'Trial Class',
      refund: 'Refund'
    },
    membership_types: {
      month: 'Monthly Fees',
      trimester: 'Quarterly Fees',
      other: 'Other Fees'
    },
    discounts: {
      title: 'One-off Discounts for Online Payments',
      target_title: 'Discount for:',
      target_membership: 'Membership',
      type_title: 'Type:',
      type_value: 'Value/Amount ({eg})',
      type_percentage: 'Percentage ({eg})',
      value_title: 'Value:',
      button: 'Create discount',
      example: 'A price of <b>{price}</b> will become <b>{final_price}</b>. Discount: <b>{discount}</b>',
      delete_ok: 'Delete Discount',
      delete_disabled: 'The Discount has been applied and therefore it cannot be deleted',
      warning: 'There are several discounts that can be applied to this Student.<br/>When the student performs his/her next payment, the system will apply only the first discount available.',
      danger_global_discounts: '<b>Global discounts enabled:</b> You have already enabled global discounts. Please note that if you create a One-off discount for this student, it will take precedence over the global discounts. Please note that discounts are not cumulative.',
      on_off_discount: 'One-off Discount for Online Payments',
      month: 'Specific Month:',
      select_month: '-- Any Month --',
      columns: {
        created: 'Created',
        for: 'Discount For',
        is_percentage: 'Type',
        value: 'Value',
        payment: 'Used In Payment',
        discount: 'Discount',
        month: 'Specific Month'
      }
    },
    report_modal: {
      title: 'Payments Report',
      title_debts: 'Month Debts Report',
      content: 'Please deselect those payment types that you do not wish to include in the report:',
      button: 'Download Report'
    },
    voucher: 'Voucher',
    show_more: '-- Show more --'
  },
  messages: {
    messages: 'Messages',
    notifications: 'Notifications',
    activity: 'Activity',
    traces: 'Traces',
    messages_with: 'Messages with {name}',
    tooltip_sent: 'Message sent without response',
    tooltip_has_response: 'Message replied by the student',
    tooltip_student_read: 'The student has seen the last message',
    tooltip_student_unread: 'The student has NOT seen the message yet',
    tooltip_new: 'New or unread message',
    bulk: {
      compose: 'Compose',
      archived: 'Sent',
      title: 'Bulk Messaging',
      num_recipients: 'Number of Recipients',
      classes: 'Students in Classes',
      tags: 'Students with Tags',
      memberships: 'Memberships',
      styles: 'Styles',
      roles: 'Roles',
      filter_users: 'Recipients selected',
      button_add_users: 'Add Recipients',
      student_status: 'Account Status',
      all_students: 'All',
      all_locations: 'All Locations',
      recipients: 'Recipients',
      no_recipients_message: 'No users have been added to the recipients list yet',
      select_elements: 'Select {name}',
      num_selected: '{num} {elements} Selected',
      elements_classes: 'Classes',
      elements_tags: 'Tags',
      elements_memberships: 'Memberships',
      elements_styles: 'Styles',
      elements_roles: 'Roles',
      elements_locations: 'Centers',
      no_email: 'No valid email on record.',
      no_email_recipients: 'Only recipients with a valid email address on record',
      clear_recipients: 'Clear All Recipients',
      export_addresses_csv: 'Export Addresses CSV',
      export_addresses_csv_tooltip: 'This action will export all the email addresses to a CSV file to be imported in other tools such as Mailchimp',
      copy_addresses: 'Copy Addresses',
      copy_addresses_tooltip: 'This action will copy to your clipboard all the email addresses of the selected recipients so you can use them on an external email tool',
      copied_addresses: '{num} email addresses copied to clipboard',
      info_tokens: '<p>You can add special fields to the email and subject that will be automatically replaced:</p><ul>' +
        '<li><b>{name}:</b> The student first name will be displayed.</li>' +
        '<li><b>{surname}:</b> The student last name will be displayed.</li>' +
        '<li><b>{username}:</b> The username will be displayed.</li>' +
        '<li><b>{email}:</b> The email address will be displayed.</li>' +
        '</ul><i>Please note the curly brackets.</i>',
      subject: 'Email Subject',
      message: 'Email Body / Message',
      upload_file: 'Add Attachment',
      upload_another_file: 'Add Another Attachment',
      include_footer: 'Include Footer',
      gdpr: 'Please remember to include a suitable privacy disclaimer / GDPR applicable to these emails.',
      from_name: 'Sender/From Name',
      from_address: 'Sender/From Address',
      include_username: 'Include Username',
      include_classes: 'Include Classes Schedule',
      send_test_email: 'Send Test Email',
      send_n_emails: 'Send {num} Emails',
      spam_title: 'SPAM y configuración:',
      spam_message: '<p>As you might already know, SPAM is a great concern for users and regulators. Nowadays, email providers have put in place several mechanisms to block SPAM, verify the identity of the sender to avoid scams, etc.</p>' +
        '<p>For that reason, if you not have already done so, please contact us to setup SPF and DKIM so you can send emails with your email addresses/domain. Otherwise, <b>please use as Sender/From Address notifications@outbound.kydemy.com</b></p>',
      must_contain_text: 'Seems like your email body doesn\'t contain text. Your email must contain text so it is compatible with all kind of email providers.',
      send_error: 'There was an error sending your email. Contact us to review your configuration.',
      send_success: 'Your email/s have been successfully sent',
      errors: {
        subject: 'The email Subject is missing',
        body_html: 'The email message is missing',
        body_html_pasted_images: 'Pasted images are not allowed',
        from_name: 'Enter the from name to be displayed as sender',
        from_address: 'Please provide a from address or \'notifications@outbound.kydemy.com\'',
        recipient_ids: 'You must select at least one recipient'
      },
      test_modal: {
        title: 'Send Test Email',
        content: 'You can send a test email selecting the user that will be used to generate the email contents and entering the email address that will receive the test email.',
        content_bold: 'This action will not send emails to the recipients, just to the provided email address bellow.',
        button: 'Send Test Email',
        form_title: 'Select user:',
        form_address: 'Enter email address:'
      },
      send_modal: {
        title: 'Send Bulk Emails Confirmation',
        content: 'Are you sure that you want to generate and send emails?',
        content_bold: 'Please note that this action cannot be undone and might take some time depending on the number of recipients selected.',
        button: 'Send {num} Emails'
      },
      size_modal: {
        title: 'Exceeded maximum size',
        content: 'All attachments combined should not exceed 8MB in conjunction. Also, each attachment should not be more than 5MB.',
        button: 'Ok'
      },
      type_modal: {
        title: 'File type not allowed',
        content: 'Only PDF, Images, MP3, DOCX, XLSX and PPTX files are allowed.',
        button: 'Ok'
      },
      student: 'Student',
      email: 'Email Address',
      status: 'Email Sent',
      location: 'Location',
      use_as_template: 'Duplicate as New Message',
      no_filters_tooltip: 'The Account Status filter can be used to narrow down your results, but you need to select some other filters beforehand. For instance, you can select "Students" in the ROLES filter'
    },
    activity_section: {
      activity: 'Activity',
      content: 'Content',
      no_activity: 'Kydemy has not sent any emails/messages yet',
      emails: 'emails',
      columns: {
        account: 'Account',
        date: 'Date',
        type: 'Type',
        status: 'Status',
        sent: 'Sent',
        delivered: 'Delivered',
        opened: 'Opened',
        clicked: 'Clicked'
      },
      status: {
        sent: 'Sent',
        delivered: 'Delivered',
        opened: 'Read',
        clicked: 'Clicked',
        bounced: 'Error',
        spam: 'Spam',
        error: 'Error'
      },
      templates: {
        'bulk-email': 'Bulk',
        'message-received': 'Message',
        'invite-student': 'Invitation',
        'invite-manager': 'Invitation',
        'class-cancelled': 'Class Canceled',
        'student-class-cloned-confirmation': 'Class Confirmation',
        'student-registration': 'Registration',
        'student-registration-notification': 'Registration Notif.',
        'student-registration-confirmation': 'Registration Conf.',
        'password-reset': 'Password Reset',
        'student-current-month-membership-payment': 'C.M Reminder',
        'student-next-month-membership-payment': 'N.M. Reminder',
        'subscription-created': 'New Subscription',
        'subscription-created-notification': 'New Sub. Notif.',
        'student-registration-to-managers': 'New Subscription'
      }
    },
    navigate_modal: {
      title: 'Confirmation',
      content: 'Are you sure that you want to leave this page?',
      content_bold: 'You changes will be lost',
      button_leave: 'Discard Changes',
      button_stay: 'Keep Editing'
    }
  },
  config: {
    menu: {
      general: 'General',
      overview: 'Overview',
      usage: 'Usage',
      content: 'Content',
      students: 'Students',
      teachers: 'Staff',
      classes: 'Classes',
      styles: 'Styles',
      levels: 'Levels',
      memberships: 'Memberships',
      classrooms: 'Classrooms',
      tags: 'Tags',
      belts: 'Belts',
      licenses: 'Licenses',
      registrations: 'Registrations',
      storage: 'Storage',
      payments_invoicing: 'Payments & Invoicing',
      subscription: 'Subscription',
      payment_method: 'Payment Methods',
      invoicing: 'Invoicing',
      payments: 'Payments',
      debts: 'Debts',
      remittances: 'Remittances',
      discounts: 'Discounts',
      vouchers: 'Vouchers',
      referrals: 'Referral Program',
      site_administration: 'Site Administration',
      passwords: 'Passwords',
      general_information: 'General Information',
      network_configuration: 'Network Configuration',
      look_and_feel: 'Look and Feel',
      notifications: 'Notifications',
      social_networks: 'Social Links',
      shortcuts: 'Keyboard Shortcuts',
      localization_and_dates: 'Localization & Dates',
      regional_settings: 'Regional Settings',
      holidays: 'Holidays',
      subscriptions: 'Subscriptions',
      evaluations: 'Evaluations',
      documents: 'Documents',
      administration: 'Administration',
      config: 'Platform Configuration',
      stripe: 'Stripe',
      postmark: 'Postmark',
      one_signal: 'One Signal',
      branded_app: 'Branded App',
      features: 'Features'
    },
    overview: {
      title: 'Platform Overview',
      users_clases_overview: 'Students & Classes',
      active_users: 'Active Users',
      active_teachers: 'Active Teachers',
      active_classes: 'Active Classes',
      subtitle: 'Bellow is the current status of the platform. You can find important usage information, payments, etc.<br/> Do not hesitate to contact us and suggest what we can do to improve this view.',
      monthly_finances: 'Monthly Finances',
      monthly_debts: 'Monthly Student Debts',
      monthly_income: 'Monthly Income',
      every_24h: 'These figures are recalculated every 24 hours'
    },
    holidays: {
      title: 'Holidays',
      subtitle: 'Holidays are configured to disable recurrent classes to create instances on those dates.',
      add_date: 'Add Date'
    },
    regional_settings: {
      title: 'Regional Settings',
      subtitle: 'Adjust the default platform language for notifications and other types of content.'
    },
    payments: {
      title: 'Payments',
      subtitle: 'Here you can configure payments options and which members will not be taken into account when computing payments/debts.',
      whitelist_title: 'Payments Whitelist',
      taxes: 'Currency & Tax Rates',
      tax_name: 'Tax name',
      tax_rate: 'Tax rate',
      tax_default: 'Default',
      tax_active: 'Active',
      tax_edit: 'Edit',
      tax_rate_success: 'Tax rate saved successfully',
      tax_rate_deleted: 'Tax rate deleted successfully',
      tax_rate_error: 'Error updating tax rate',
      tax_rates_error: 'Error retrieving tax rates',
      payments_settings: 'Payments Settings',
      no_whitelist_members: 'There are no students/members on the list',
      payments_online: 'Online Payments Configuration',
      CURRENCY: 'Currency',
      PAYMENTS_VAT: 'Payments Taxes/VAT',
      LICENSES_ENABLED: 'Licenses/Registration Enabled',
      INTENSIVE_PACKS_ENABLED: 'Intensive Packs Enabled',
      ONLINE_PAYMENTS: 'Online Payments Enabled',
      STORE_CARDS: 'Allow Storing Credit Cards',
      PAYMENTS_IN_ADVANCE: 'Allow Membership Payments in Advance',
      STUDENT_DEBTS_WITHOUT_ATTENDANCE: 'Membership Debts without Attendance',
      UPDATE_PAYMENT_DATE: 'Payments Date Editable',
      PRINT_RECEIPTS: 'Enable Thermal Printer',
      PRINT_STUDENT_NAME: 'Add Student Name',
      PRINT_INVOICE_NUMBER: 'Add Invoice Number',
      PRINT_PAYMENT_METHOD: 'Add Payment Method',
      PRINT_COMPANY_CONTACT_DATA: 'Include Business Contact Info.',
      IGNORE_NUM_CLASSES_DEBTS: 'Ignore debts: Excess Number of Classes',
      DISABLE_ONLINE_PAYMENTS_BANK_ACCOUNTS: 'Disable for Students with Bank Accounts',
      MEDIA_ONLY_PAID_MONTHS: 'Media visible for paid months',
      MEDIA_ONLY_PAID_MONTHS_info: 'Each video/file in Regular and Thematic classes will only be displayed if the student has a membership payment for the month it was published.<br/><b>It is recommended that you set the publication/schedule date for each video/file/link to control their visibility accurately.</b>',
      CASHBOX_ENABLED: 'Cashbox management Enabled',
      MEDIA_GRACE_PERIOD: 'Payment-required Media Grace Period',
      validate_stripe: 'Validating Stripe Account',
      validating_stripe: 'We are validating with Stripe your account configuration, please wait...',
      stripe_modal_close: 'Close',
      stripe_integrated: 'Stripe Account Integrated - Online Payments Active',
      paypal_integrated: 'PayPal Account Integrated - Online Payments Active',
      paypal_connection_error: 'Kydemy could not connect to your PayPal account. Please check the credentials and make sure that you are not using <b>Sandbox</b> credentials, but the credentials of a <b>Live</b> App.',
      stripe_result_ok: 'Your Stripe account is now linked to Kydemy.<br/>Kydemy will be able to process credit card payments from your students.',
      stripe_result_error: 'There was an error linking your Stripe account with Kydemy. Please try again or contact us for assistance.',
      paypal_500: 'There was an error while connecting to PayPal, please try again later',
      connect_with_stripe: 'Use Stripe',
      connect_with_paypal: 'Use PayPal',
      paypal_modal: {
        title: 'PayPal Integration',
        description: 'In order to use PayPal you will need to have or create a new PayPal Business account. In order to learn how to properly link Kydemy with your PayPal account please read the following article: ',
        article_link: 'PayPal configuration guide',
        client_id: 'Application Client ID',
        secret: 'Application Secret',
        currency_supported: 'Your currency is supported by PayPal',
        currency_not_supported: 'Your currency is not supported by PayPal, you should select a different currency to allow your students to pay.',
        currency: 'Payments currency',
        exchange_rate: 'Exchange rate',
        exchange_rate_is: 'is',
        save: 'Test & Save'
      },
      stripe_not_supported: 'Stripe might not be available for your currency/country, you can attempt to create an account but most likely you won\'t be able to use Stripe. In that case you can still use PayPal',
      stripe_info: 'Kydemy uses third party technology in order to process online Payments. Our payment providers are an industry standard, reliable and safe solution to manage credit card and other types of payments. In order to enable online payments for your students you will need an account on one of them and link it with Kydemy.',
      stripe_unlinked: 'You have enabled online payments but you still have to link an account of one of our payment providers in order to be able to receive online payments. Please select one of the above options.',
      stripe_dashboard: 'Launch Stripe Dashboard',
      stripe_url_error: 'Could not launch Stripe Dashboard, please go to stripe.com and log into your account',
      stripe_url_blocked: 'It seems that your browser blocked the new window, please review and allow Kydemy to open new windows',
      currencies: {
        eur: 'Euro',
        usd: 'U.S. Dollar',
        gbp: 'Pound Sterling',
        aud: 'Australian Dollar',
        cad: 'Canadian Dollar',
        chf: 'Swiss Franc',
        sek: 'Swedish Krona',
        nzd: 'New Zealand Dollar',
        mxn: 'Mexican Peso',
        brl: 'Brazilian Real',
        ars: 'Argentinian Peso',
        cop: 'Colombian Peso',
        ves: 'Venezuelan Sovereign Bolívar',
        dop: 'Dominican Peso',
        crc: 'Costa Rican Colon',
        clp: 'Chilean Peso',
        uyu: 'Uruguayan Peso',
        pen: 'Peruvian Sol',
        bob: 'Bolivian Boliviano',
        tnd: 'Tunisian Dinar',
        pyg: 'Paraguayan Guaraní',
        czk: 'Czech Crown',
        bhd: 'Bahraini Dinar'
      },
      currencies_other: 'Other currency',
      tickets: 'Tickets & Printer Configuration',
      printer: '{type} Printer',
      no_printer: 'No Printer'
    },
    debts: {
      title: 'Debs Generation',
      subtitle: 'Debts generation can be adjusted using the following settings.',
      types: 'Debt Types',
      types_info: 'Student payment debts are created automatically. You can choose which types of debts to disable if you don\'t want them to be generated. However, you can still manually generate debts if needed.',
      settings: 'Debt Settings',
      ignore_before: 'Ignore Debts Before'
    },
    remittances: {
      title: 'Remittances',
      subtitle: 'You can create one or more creditors account configuration of SEPA remittances'
    },
    subscriptions: {
      title: 'Online Subscriptions',
      subtitle: 'With online subscriptions you can create your own media-distribution service based on monthly/yearly subscriptions.',
      subscriptions_info: '<b>Subscription Plans:</b> You need to create a different subscription plan for each modality of content and the number of allowed accounts.<br/>In each subscription plan you will be able to select classes to define the contents included in that plan.<br/>Also, each subscription will have different pricing models depending on geographical filtering.',
      plans_info: '<b>Plan Pricing Configuration:</b> Each subscription plan that you create can use different currencies and define specific prices for each country or continent. You must configure a monthly price and optionally an annual price.',
      subscriptions_online_disabled: 'The subscriptions are currently disabled. You need to configure an online payment method (in the Payments configuration) in order to use subscriptions.',
      subscriptions_disabled: 'The subscriptions are currently disabled. Please activate it if you wish to provide online classes based on a recurring subscription model:',
      subscriptions_enabled: 'Subscriptions Enabled',
      no_subscriptions: 'You have not created any subscriptions plans yet.',
      new_subscription: 'New Subscription Plan',
      subscription_plans: 'Subscription Plans',
      trialing: 'Trialing Subscribers',
      active: 'Active Subscribers',
      canceled: 'Canceled Subscribers',
      unpaid: 'Past due/Unpaid Subscribers',
      label_default_vat: 'Default VAT value',
      custom_vat: 'Specific Country VAT',
      vat_configuration: 'VAT Country Configuration:',
      subscription_modal: {
        title: 'Create new subscription plan',
        button: 'Save Subscription Plan',
        label_name: 'Name',
        label_code: 'Code',
        label_description: 'Description / Information / Contents',
        label_image: 'Subscription Poster',
        label_color: 'Color',
        label_max_accounts: 'Max. Accounts',
        label_included_subscriptions: 'Included Subscriptions',
        success: 'Subscription plan created successfully',
        error: 'Error creating subscription plan, please contact us',
        image_required: 'Please provide an image for your subscription poster'
      },
      columns: {
        name: 'Name',
        code: 'Code',
        max_accounts: 'Max Acc.',
        includes: 'Includes',
        plans: 'Plans',
        subscribers: 'Subscribers',
        classes: 'Classes',
        contents: 'Contents'
      },
      delete_modal: {
        title: 'Delete Online Subscription Plan',
        content: 'You are about to erase this subscription plan. If you continue the plan will no longer be available for subscribers. Consider disabling this plan if you want to keep your information.',
        button: 'Delete Subscription Plan',
        success: 'Subscription plan was successfully deleted',
        error: 'We could not delete this subscription, please contact us'
      },
      contents: {
        subscription_contents: 'Subscription Plan: Classes & Content',
        add_class: 'Add Class',
        sorting: 'Sort Classes',
        sorting_info: 'Classes from other included subscriptions will always display before the classes of this subscription.',
        no_classes: 'You have not added any classes to this subscription.',
        other_classes: 'Included classes from other subscriptions',
        deps: 'DEPS.',
        num_days: '{num} days',
        subscription_plans: 'Subscription Plan',
        columns: {
          name: 'Class name',
          subscription: 'Subs.',
          start_date: 'Available',
          end_date: 'Ends',
          subscriber_days: 'Min Days',
          requirements: 'Req.',
          contents: 'Contents',
          start_date_info: 'Start date from which this class will start to be visible to subscribers',
          end_date_info: 'When this class will stop being available to subscribers',
          subscriber_days_info: 'Minimum number of subscribed days required to access this class.',
          requirements_info: 'Required classes to be completed to access this class.'
        },
        modal: {
          button: 'Save Subscription Class',
          title: 'Add Class to Subscription',
          selected_classes: '{num} Classes Selected',
          label_class: 'Select online classes',
          label_start_datetime: 'Publication date',
          label_end_datetime: 'Unpublish date',
          label_class_dependencies: 'Required classes',
          label_available_delay_days: 'Subscription days',
          classes_placeholder: '-- Select Online Classes --',
          button_start_datetime: 'Start Date/Time',
          button_end_datetime: 'End Date/Time',
          success: 'Subscription Class updated',
          error: 'Error updating subcription class'
        },
        delete_modal: {
          title: 'Delete Subscription Class',
          content: 'Are you sure that you want to remove this class from the subscription? The class no longer will be available to subscribers of this subscription or other subscriptions that include this one.',
          button: 'Delete Class',
          success: 'Class successfully removed from subscription',
          error: 'There was a problem removing this class form the subscription, try again later.'
        }
      },
      blacklist: {
        title: 'Blacklist Region',
        label_country: 'Blacklist Country',
        label_continent: 'Blacklist Continent',
        placeholder_country: 'Select a country',
        placeholder_continent: 'Select a continent',
        button: 'Add to Blacklist',
        success: 'Region added to Subscription Blacklist',
        error: 'Could not add to blacklist, please try again or contact us'
      },
      plans: {
        title: 'Subscription Plan: Pricing Configuration',
        pricing_configuration: 'Pricing Configuration',
        contents: 'Classes/Content',
        back: 'Go Back',
        no_plans: 'You have not created any plans for this subscription yet.',
        new_plan: 'Create Pricing Plan',
        new_blacklist: 'Blacklist Region',
        monthly: 'Monthly',
        yearly: 'Annual',
        default_plan: 'Default',
        plan: 'Plan',
        no_default_plan: 'There is no default pricing plan',
        blacklisted: 'Region blacklisted',
        vat: 'VAT',
        modal: {
          button: 'Save Plan',
          title: 'New Subscription Plan',
          label_name: 'Plan name',
          label_code: 'Plan code',
          label_color: 'Plan color',
          label_price_month: 'Monthly price',
          label_price_year: 'Yearly price',
          label_currency: 'Price currency',
          label_country: 'Only for country',
          label_continent: 'Only for continent',
          label_active: 'Plan is active',
          label_default: 'Default subscription plan',
          label_trial: 'Trial days',
          placeholder_currency: 'Select a currency',
          placeholder_continent: 'Select a continent',
          placeholder_country: 'Select a country',
          success: 'Subscription Plan saved successfully',
          error: 'Error saving subscription plan, please contact us'
        },
        columns: {
          name: 'Plan name',
          code: 'Code',
          price_month: 'Monthly',
          price_year: 'Annual',
          target: 'Target',
          default_plan: 'Default',
          subscribers: 'Subscribers',
          trial: 'Trial'
        },
        delete_modal: {
          title: 'Delete Pricing Plan configuration',
          content: 'You are about to erase this pricing configuration for your subscription plan. If you continue the price will no longer be available for subscribers. Consider disabling this pricing plan if you want to keep your information.',
          button: 'Delete Pricing Plan',
          success: 'Subscription pricing plan was successfully deleted',
          error: 'We could not delete this pricing plan, please contact us'
        }
      }
    },
    documents: {
      title: 'Documents',
      subtitle: 'In this section you can define your "Terms & Conditions" and other documents your students need to read and sign.',
      documents_mode: 'Document and signatures mode:',
      paper_docs: 'Paper Documents & Signatures',
      digital_docs: 'Digital Documents & Signatures',
      docs_mode_info: '<p class="m-b-05"><b>Paper Documents:</b> Choose this option to handle paper-based documents. Students will sign physical copies, and you can use toggles in the system to mark whether each student has signed their document.</p><p><b>Digital Documents:</b> Select this option to manage all documents digitally within Kydemy. Students will sign directly on their devices, and Kydemy will securely store their digital signatures for easy access and record-keeping.</p>',
      switches: 'Student document signature tracking:',
      documents: 'Digital documents:',
      docs_info: 'The first Terms and Conditions document will be displayed on the registration page for students to review and accept during registration.',
      doc_title: 'Document Title',
      doc_contents: 'Contents',
      doc_translations: 'Translations',
      doc_templates: 'Templates',
      no_versions: '<b>IMPORTANT:</b> You\'re about to create the first version of this document.<br/>Once it\'s created, you won\'t be able to edit it, and each signature will apply to the latest version available at the time of signing. If you need to make changes, you\'ll need to create a new version.',
      new_document: 'New Document',
      new_doc_created: 'New document created successfully',
      new_doc_error: 'Could not create the document, please contact us',
      new_version_created: 'New version created successfully',
      new_version_error: 'Could not create new version, please contact us',
      active: 'Active',
      required: 'Required',
      multiple: 'Multiple',
      requires_new_signature: 'Require new signature',
      requires_new_signature_info: 'If enabled, all students will be required to sign again even if they have signed a previous version of this document.',
      doc_type: 'Type',
      versions: 'Versions',
      errors: {
        missing_content: 'Missing or invalid document content',
        missing_title: 'Missing or invalid document title',
        default_lang_missing: 'You have to provide title and content for the default language'
      },
      import_modal: {
        title: 'Import contents from Template',
        button: 'Import Contents',
        preview: 'Preview Template',
        warning: '<b>Note:</b> Importing a template will replace the document contents in all selected languages.',
        disclaimer: 'These templates are provided as a starting point for you to edit and complete as needed. <b>Important: Kydemy is not responsible for the content you create from these templates—they’re simply here to help you get started. If you have any questions, please consult a qualified professional.</b>',
        preview_message: 'Please note that the blue tags (like <b class="is-info tag">this</b>) will automatically be replaced with the student or business information when the signature is recorded.'
      },
      new_doc_modal: {
        title: 'Create new Document',
        button: 'Create Document',
        template: 'Select a document type/template',
        template_other: 'Empty Document',
        options: 'Options',
        required_info: 'When this option is enabled, all students or their parents/relatives will need to sign the document upon logging into Kydemy.',
        multiple_info: 'If you choose this option, the document can be filled out and signed multiple times—perfect for granting pick-up authorizations for different people. If you’re not sure, leave it unchecked.'
      },
      templates: {
        terms: 'Terms & Conditions',
        privacy: 'Privacy Policy (GDPR)',
        image: 'Use of Images',
        authorization: 'Authorization Document',
        'pick-up': 'Student Pick-up',
        other: 'Generic Document'
      },
      delete_doc_modal: {
        title: 'Delete document: {name}',
        content: 'Are you sure you want to delete this document? Deleting it will also permanently remove all associated signatures.',
        button: 'Delete Document',
        success: 'Document and signatures deleted successfully',
        error: 'The document could not be deleted, please contact us'
      }
    },
    evaluations: {
      title: 'Student Evaluations',
      subtitle: 'This section can be used to create new academic years, periodic assessments, and evaluation criteria.',
      tab_courses: 'Courses Config',
      tab_criteria: 'Evaluation Criteria',
      tab_templates: 'Criteria Templates',
      tab_classes: 'Classes',
      tab_grades: 'Grades',
      years: 'Academic Years',
      new_course: 'New Academic Year',
      delete_success: 'Course and assessments deleted successfully',
      delete_error: 'The course/assessments cannot be deleted to prevent data loss',
      label_name: 'Name',
      label_start: 'Start date',
      label_end: 'End date',
      label_num_assessments: 'Assessments',
      button_new_course: 'Create Academic Year',
      error_new_course: 'Could not create new course, please contact us',
      course_details: 'Course details',
      label_course_name: 'Course name',
      label_evaluation_name: 'Evaluation name',
      course_evaluations: 'Course Assessments',
      update_error: 'Could not update the course data, please contact us',
      update_success: 'Course updated successfully',
      error_max_one_year: 'The course has to be less than a year',
      days: 'days',
      template_values3: '3 Scores',
      template_values4: '4 Scores',
      template_values5: '5 Scores',
      template_af: 'F to A scores',
      template_afplus: 'F to A+ scores',
      template_values9: '1 to 10 scores',
      new_criterion: 'New Grading Criterion',
      button_new_criterion: 'Save Criterion',
      back: 'Cancel',
      no_grades: 'No grades created yet',
      template_select: '-- Select a grading template --',
      label_criterion_name: 'Criterion name',
      label_criterion_description: 'Description',
      info_grades: 'Select a scoring template to get started; then you can add/remove/modify grades to adjust the grading to your needs.<br/> Please note that you need to asign a 1 to 100 score value to each grade, this will be used to compute averages, failing scores and more.',
      success_new_criterion: 'Evaluation criterion saved',
      error_new_criterion: 'Could not save evaluation criterion, please try again or contact us',
      templates: {
        values3: [
          'Low',
          'Medium',
          'High'
        ],
        values4: [
          'Fail',
          'Good',
          'Very Good',
          'Excellent'
        ],
        values5: [
          'Poor',
          'Fair',
          'Good',
          'Very Good',
          'Excellent'
        ]
      },
      templates_title: 'Criteria Templates',
      new_template: 'New Template',
      template_available_criteria: 'Available Criteria',
      template_selected_criteria: 'Selected Criteria',
      template_save_success: 'Template saved successfully',
      template_save_error: 'Could not save template, please try again or contact us',
      template_delete_success: 'Template deleted successfully',
      template_delete_error: 'Could not delete template, please try again or contact us',
      with_template: 'With Template',
      without_template: 'Template Missing',
      class_template_success: 'Class evaluation template updated successfully',
      class_template_error: 'Could not update class evaluation template, please contact us',
      active: 'Active',
      all: 'All Classes',
      missing: 'No template',
      no_template: '-- NONE --',
      no_evaluations: 'There are no courses/evaluations. First you need to create evaluations to assign templates to classes for each evaluation.',
      no_classes: 'There are no classes for the selected filters or within the selected evaluation dates',
      save_all: 'Save All',
      columns: {
        course: 'Course',
        evaluation: 'Evaluation',
        num_classes: 'Classes',
        num_students: 'Students',
        num_grades: 'Grades'
      },
      export_progress: 'Generating PDFs',
      export_init: 'Preparing grades data...',
      export_zip: 'Zipping files...',
      min_attendance: 'Minimum student class attendance to be graded',
      show_deleted: 'Show deleted elements',
      delete_grading_template: 'Delete grading template',
      save_grading_template: 'Save grading template',
      new_grading_template: 'Save new grading template',
      new_grading_template_success: 'Grading template saved successfully',
      new_grading_template_error: 'Could not save grading template, please contact us',
      new_grading_template_button: 'New Template'
    },
    subscription: {
      title: 'Subscription Details',
      subtitle: 'You can review your subscription plan and current details on this page. Please let us know if there is any issues with your subscription.',
      cancel: {
        title: 'Cancel subscription:',
        pre_form: 'If you wish to cancel your subscription, please contact us using the <a class="crisp-chat has-text-weight-bold">chat</a> or use the following form:',
        reason: 'The main reason you want to cancel your subscription is:',
        reason_items: [
          'My business is closing down',
          'I want to try a different software',
          'The price does not suit me',
          'There is a missing feature I need...',
          'Other reason...'
        ],
        observations: 'Please add any observations about your experience with Kydemy',
        support: 'What do you think about our customer support:',
        support_bad: 'Bad 👎',
        support_acceptable: 'Acceptable 🤙',
        support_good: 'Good 👍',
        support_excellent: 'Excellent 🫶',
        recommend: 'Would you recommend Kydemy to a colleague:',
        recommend_no: 'No, sorry 😢',
        recommend_yes: 'Yes ❤️',
        terms: [
          'I understand that after canceling my subscription I will no longer have access to any of my data.',
          'By cancelling my subscription, I recognize that this action DOES NOT affect any previous/pending invoices.',
          'I also acknowledge that Kydemy is under no obligation to provide any support and will eventually delete all my data.'
        ],
        message: 'Your subscription will be canceled in <b class="has-text-danger">{remaining}</b> ({periodEnd}). After you Kydemy platform has been canceled, your data, files and videos will no longer be accessible.',
        button: 'Cancel my Kydemy Subscription',
        after_date: 'As per our <a class="has-text-weight-bold" href="https://www.kydemy.com/en/legal/terms#duration" target="_blank">terms and conditions</a> your subscription cannot be cancelled at this point. We need at least 5-7 days notice for processing subscription cancellations.'
      },
      reactivate: {
        status_note: 'The subscription will be cancelled in {remaining}',
        paragraphs_1: 'Your subscription is scheduled to be cancelled in <b>{remaining}</b> ({cancel_at}).',
        paragraphs_2: 'You can continue using Kydemy until that date, then all your data won\'t be accessible any longer.',
        paragraphs_3: 'If you prefer to continue using Kydemy after that date, and renew your subscription at the usual rate, please click on the following button:',
        button: 'Re-Activate Subscription'
      },
      discount_months: '{numMonths} Months',
      once: 'Once'
    },
    payment_method: {
      title: 'Payment Methods',
      subtitle: 'In this section you can administer your payment methods. Only "the default payment method" will be charged by Kydemy/Stripe.',
      no_methods: 'It looks like you haven\'t set up any payment methods yet.<br/>Without a payment method, your invoices may become overdue, and your platform could be canceled.',
      default_method: 'Default payment method',
      make_default_method: 'Make default payment method',
      delete_method: 'Delete payment method',
      create_button: 'New Payment Method',
      success_create_method: 'Payment method created successfully',
      error_create_method: 'Could not create payment method, please contact us',
      success_default_method: 'Default payment method updated successfully',
      error_default_method: 'Could not make the selected payment method the default one',
      success_delete: 'Payment method deleted successfully',
      error_delete: 'Could not delete payment method',
      new_payment_default: 'Use this new payment method as the default method for all future payments.',
      create_method: 'Save Payment Method',
      delete_modal: {
        button: 'Delete Method',
        title: 'Delete Payment Method',
        content: 'You are about to delete the selected payment method, do you want to proceed?'
      }
    },
    invoicing: {
      title: 'Invoicing: Invoices & Payments',
      subtitle: 'In this section you can review your platform subscription payments, online payments invoices and download the information as PDF.',
      platform_invoices: 'Platform Invoices',
      invoicing_details: 'Invoicing Details',
      stripe_invoices: 'Online Payments Invoices',
      not_linked: 'Currently you are not subscribed to any plan, so we cannot display your invoices or plan details. Please contact us in order to update your subscription information.',
      no_online_payments: 'Online Payments is not enabled or not properly configured. You will be able to review your online payment transactions here once your configuration is ready and you start processing payments.',
      no_months: 'You have not registered any payments yet.',
      unavailable: 'The billing period still open, you will be able to download the bill once the month is over.',
      month: 'Month',
      payments: 'Payments',
      download_available: 'Download Invoice PDF',
      download_disabled: 'The billing period is not finished yet',
      display_payments: 'Display Payments',
      fees: 'Online Payments Invoice',
      subscription_invoice: 'Kydemy Subscription Invoice - {start} - {end}.pdf',
      subscription_plan: 'Subscription Plan',
      subscription_status: 'Status',
      subscription_tax: 'Tax',
      subscription_period_end: 'Billing Period End',
      subscription_trial_period: 'Trial Period',
      paid: 'Paid',
      unpaid: 'Due / Unpaid',
      trial: 'Trial',
      void: 'Void',
      status: 'Status',
      period_start: 'Period Start',
      period_end: 'Period End',
      amount: 'Amount',
      taxes: 'Taxes',
      download_invoice: 'Download the Invoice in PDF',
      display_invoice: 'Display Invoice details',
      pay_invoice: 'Pay Pending Invoice',
      no_invoices: 'Currently there are not invoices available or we are experiencing difficulties to retrieve your invoices. Please try again later.',
      subscription_statuses: {
        trialing: 'Trial Period',
        active: 'Active',
        past_due: 'Past Due',
        canceled: 'Cancelled',
        unpaid: 'Unpaid',
        paused: 'Paused',
        processing: 'Processing Payment'
      },
      modal: {
        title: 'Online Payments: {month}',
        date: 'Date',
        student: 'Student',
        type: 'Type',
        amount: 'Amount',
        fee: 'Kydemy Fee',
        close: 'Close',
        total: 'Total'
      },
      business_data: {
        business_name: 'Business/Company Name:',
        fullname: 'Owner Full Name:',
        id_number: 'Business/VAT Number:',
        address_lines: 'Legal Address:',
        invoice_prefix: 'Invoice Prefix:',
        invoice_prefix_placeholder: 'Leave blank if unsure',
        invoice_terms: 'Invoice Legal/Privacy footer information:'
      },
      invoicing_details_message: 'This information will be used in the Kydemy invoices and the receipts for your students. Please provide the same details as in tax/legal documents.',
      error_invoicing_data: 'There was an error storing your invoicing information, please contact us.',
      update_invoicing_data: 'Invoicing Details updated successfully'
    },
    discounts: {
      title: 'Global Discounts',
      subtitle: 'In this section you can set generic discounts to later assign them to students. These discounts will affect both online payments and manual payments made from Kydemy.',
      discounts_info: 'Once activated and configured, global discounts can be selected from each student profile card. These discounts are only applicable to <b>monthly membership fees/payments</b>.',
      name: 'Name',
      code: 'Code',
      color: 'Color',
      type: 'Type',
      value: 'Value',
      num_students: 'Students',
      num_payments: 'Pagos',
      no_discounts: 'Discounts have not yet been released.',
      discount_created: 'The Discount has been created successfully',
      discount_updated: 'Discount updated correctly',
      discount_deleted: 'The Discount has been eliminated',
      active_discounts: 'Active Discounts',
      disabled_discounts: 'Disabled Discounts'
    },
    vouchers: {
      title: 'Class Vouchers',
      subtitle: 'In this section you can create your list of available class vouchers for students.',
      vouchers_info: 'Once activated and configured, vouchers will be available when creating payments and for students to purchase (if online payments enabled).',
      no_vouchers: 'There are no vouchers created so far.',
      voucher_created: 'The Voucher has been created successfully',
      voucher_updated: 'Voucher updated correctly',
      voucher_deleted: 'The Voucher has been eliminated',
      voucher_error: 'There was an error performing the action',
      add_voucher: 'Add Voucher',
      num_uses: 'Number of students using the voucher',
      expiration_tooltip: 'The expiration date will be set from the payment date.',
      payment_expiration_tooltip: 'This voucher had an original expiration of {num} days, and will no longer be valid after {date}',
      expired: 'Expired',
      columns: {
        name: 'Name',
        description: 'Description',
        classes_included: 'Classes Included',
        price: 'Price',
        num_students: 'Students',
        uses: 'Uses',
        expiration: 'Expiration'
      }
    },
    referrals: {
      title: 'Referral Program',
      subtitle: 'The referral program allows you to recommend Kydemy to other businesses and be rewarded for each one that becomes a customer. Also, they will benefit with an initial discount. Please note that you can recommend Kydemy to other business types such as: dance studios, music schools, arts academies, yoga/pilates studios, martial arts dojos, studies/languages schools, etc.',
      for_customers_discount: '{discount}% {months} MONTHS',
      for_customers: 'New Customers',
      for_you: 'For You',
      referrals_description: 'The new Kydemy referral program grants you <b class="has-text-success">€ 100.0 credit</b> in Kydemy products for each customer that becomes a Kydemy subscriber. Also the new referred customers get a <b class="has-text-info">10.0% discount</b> for the first 6 months.',
      referrals_directions: 'Just ask them to register for a demonstration with us <b class="has-text-danger">using your exclusive referrals link</b> so both of you get the program bonus:',
      copy_success: 'Referral link copied to clipboard',
      copy_error: 'The link could not be copied, please select the text and copy manually the link',
      referred_customers: 'Referred customers',
      no_referrals: 'You have not referred any customers yet or they are not an active Kydemy customer yet'
    },
    general_info: {
      title: 'General Information',
      subtitle: 'Here you can provide some details about your business that will be included in some sections of the website and emails.',
      clear_platform: 'Clear Platform Contents',
      erase_modal_title: 'Erase All Platform Contents',
      erase_modal_content: 'This action will erase all classes, students, teachers, events, payments, stats, etc. Please use this option only if you want to reset Kydemy to a initial stage, keeping the current/basic configuration.',
      erase_instructions: 'Please enter the full domain of this platform in order to continue: ({domain})',
      erase_completed: 'The platform data has been erased successfully',
      erase_error: 'There was an error deleting the platform data',
      business_types: [
        {
          name: 'Dance Studio',
          code: 'dance_academy',
          icon: 'music'
        },
        {
          name: 'Music School',
          code: 'music',
          icon: 'music'
        },
        {
          name: 'Arts Workshop',
          code: 'art_academy',
          icon: 'paint-brush'
        },
        {
          name: 'Studies/Languages School',
          code: 'education',
          icon: 'graduation-cap'
        },
        {
          name: 'Martial Arts',
          code: 'martial_arts',
          icon: 'male'
        },
        {
          name: 'Other Business',
          code: 'other',
          icon: 'cube'
        }
      ]
    },
    look_and_feel: {
      title: 'Look and Feel',
      subtitle: 'In this section you can adjust the styling of your Kydemy platform. Colors, fonts, logos, etc.',
      colors: 'Platform Colors',
      images: 'Logos & Images',
      logo: 'Logo',
      logo_header: 'Horizontal Logo',
      background: 'Background Image',
      background_alignment: 'Background Alignment',
      image_info: 'Logo images must be web-compatible SVG images (recommended) or PNG images and should have transparent background. Background images can be SVG, PNG or JPEG. The Logo is recommended to have a squared aspect ratio. The horizontal logo should be wide/panoramic (recommended) or square. The background image will cover the background color.',
      fonts: 'Typography',
      primary_color: 'Primary Color',
      background_color: 'Background Color',
      primary_font: 'Content Font',
      secondary_font: 'Titles Font',
      serif_font: 'Content / Serif Font',
      sample_message_title: 'Theme Example:',
      sample_secondary: 'Sample Title',
      sample_primary: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ex ligula, rutrum nec congue non, euismod vulputate ante. Sed at commodo odio. Quisque a elementum nunc. Etiam viverra, urna at facilisis tincidunt, libero arcu sagittis arcu, nec sollicitudin massa metus sed leo. Duis congue, risus aliquet euismod malesuada, dolor risus maximus mi, sed vehicula ipsum urna laoreet elit.',
      sample_serif: 'Fusce bibendum facilisis elit, tempus tristique felis ultricies vitae. Aliquam sit amet ullamcorper lacus, tincidunt interdum metus. Nam luctus, massa nec ornare consequat, purus augue auctor neque, vitae pharetra lectus dolor id sapien. Suspendisse in iaculis dolor. Mauris consequat ligula sed mollis semper. Cras ac euismod felis.',
      sample_button: 'Sample Button',
      update_theme: 'Save and Update Look and Feel',
      confirm_title: 'Theme Updated',
      confirm_content: 'Your new theme has been created, in order to load the theme we are going to force a full reload of the Kydemy assets.',
      confirm_button: 'Reload Kydemy',
      update_theme_error: 'There was an error updating your theme, please contact us or try again later.',
      image_format_error: 'Image type not valid, must be a SVG o PNG with transparent background.'
    },
    notifications: {
      title: 'Automatic Notifications',
      subtitle: 'Settings to generate automatic notifications that will be sent to students when the necessary conditions are met.',
      membership_payments_notifications: 'Notification Payments / Fees',
      next_month_memberships: 'Notify Payment Next Month',
      next_month_memberships_help: 'Send notification at the beginning / before the following month to remind the payment of monthly fees.',
      next_month_notification_days_in_advance: 'Days from the beginning month ({num})',
      month_payment_reminder: 'Payment Reminder current month',
      month_payment_reminder_help: 'Send a friendly reminder to students for the payment of the monthly fee (current month) to those students who have not yet made the payment.',
      month_payment_reminder_start_days: 'Days since the beginning month ({num})',
      include_payment_link: 'Include Link for Online Payment',
      include_payment_link_help: 'If online payments are active, include a link in the previous notifications to make the payment directly',
      voucher_exhausted: 'Report Classes Voucher Spent',
      voucher_exhausted_help: 'Send notification when a student has exhausted all classes of his bonus and needs to acquire another one.',
      notification_time: 'Time to Send Notifications',
      save: 'Save Settings',
      sent_automated_notifications: 'Sent Automated Notifications',
      no_automated_notifications: 'Kydemy has not sent any automated notifications yet',
      notified_students: 'Notified Students',
      notification_types: {
        NextMonthMemberships: 'Next Month Payment Notification',
        ReminderMemberships: 'Current Month Payment Reminder'
      },
      registration_notifications: 'Registration Notifications',
      new_registrations: 'Notify New Registrations',
      new_subscriptions: 'Notify New Subscriptions',
      do_not_notify: '-- Do not notify --'
    },
    settings: {
      PRODUCT_NAME: 'Product Name',
      COMPANY_NAME: 'Company Name',
      COMPANY_ADDRESS: 'Company Address',
      CONTACT_EMAIL: 'Contact Email',
      CONTACT_PHONE: 'Contact Phone',
      DEFAULT_LANGUAGE: 'Default Language',
      BUSINESS_TYPE: 'Main Business Type',
      LICENSE_EXPIRATION: 'License Expiration',
      LICENSE_FEE: 'License Fee',
      SOCIAL_LINKS_ENABLED: 'Social Links Enabled',
      WEBSITE_URL: 'Website URL',
      FACEBOOK_URL: 'Facebook URL',
      TWITTER_URL: 'X (Twitter) URL',
      INSTAGRAM_URL: 'Instagram URL',
      YOUTUBE_URL: 'YouTube URL',
      REGISTRATIONS_REQUIRE_DOB: 'Require Date of Birth',
      REGISTRATIONS_REQUIRE_ID: 'Require ID/Passport',
      REGISTRATIONS_REQUIRE_POSTAL_CODE: 'Require Zip/Postal Code',
      REGISTRATIONS_FILTER_CLASSES: 'Filter Registration Classes',
      REGISTRATION_AUTO_PROCESS_DEMO_CLASSES: 'Accept Online Classes registrations',
      REGISTRATIONS_TUTOR: 'Guardian/Parent Fields Enabled',
      REGISTRATIONS_ATTACHMENTS: 'Attachments in Confirmation Email',
      REGISTRATIONS_PAYMENT_REQUIRED: 'Payment Required',
      REGISTRATIONS_PAYMENT_IGNORE_FOR_FUTURE_MONTHS: 'Limit Payments in Advance',
      REGISTRATION_REQUIRE_BANK_ACCOUNTS: 'Require Bank Account',
      REGISTRATION_SHOW_MEMBERSHIPS: 'Display Memberships Prices/Table',
      REGISTRATION_SHOW_ADVANCED_MEMBERSHIPS: 'Display Advanced Memberships',
      REGISTRATION_REDIRECTION: 'Redirect on Registration Completed',
      RELATIVES_ENABLED: 'Accounts for Relatives',
      LEADS_ENABLED: 'Leads Enabled',
      TEACHER_CONTACT_DETAILS: 'View Students\' Contact Information',
      TEACHER_ATTENDANCE: 'Register Teacher Attendance',
      TEACHER_EDIT_CLASS: 'Edit Classes Information',
      TEACHER_UPDATE_LINKS: 'Manage Classes Links',
      TEACHER_UPDATE_MEDIA: 'Manage Classes Videos/Attachments',
      TEACHER_UPDATE_CLASS_STUDENTS: 'Update Class Couples/Students',
      TEACHER_EDIT_STUDENTS: 'Edit Students Information',
      TEACHER_REGISTER_PAYMENTS: 'View & Register Student Payments',
      TIME_KEEPER_ENABLED: 'Register Working Hours',
      MANAGERS_ACCESS_DEBTS: 'Managers: View total Debts',
      MANAGERS_REMITTANCES: 'Managers: Access Remittances',
      DANCE_ROLES_ENABLED: 'Dance Roles Enabled',
      BELTS_ENABLED: 'Martial Arts Belts Enabled',
      DATE_OF_BIRTH_ENABLED: 'Date of Birth / Ages Enabled',
      ID_NUMBER_ENABLED: 'ID/Passport Number Enabled',
      POSTAL_CODE_ENABLED: 'ZIP / Postal Code Enabled',
      STUDENTS_EDIT_PROFILE: 'Students can update their Profile',
      STUDENTS_MESSAGING: 'Students can send Messages',
      STUDENTS_MESSAGE_STUDENTS: 'Students can message other Students',
      STUDENTS_GALLERY: 'Upload to Class Gallery',
      BANK_ACCOUNTS: 'Store Bank Accounts',
      REGISTRATIONS_ENABLED: 'Registrations Enabled',
      STUDENTS_RECEIPTS: 'Download Payment Receipts',
      STUDENTS_BANNER_MESSAGE: 'Display Banner Message',
      STUDENTS_HIDE_PAYMENTS: 'Hide Payments/Prices Info',
      STUDENTS_HIDE_PAYMENTS_HISTORY: 'Hide Payments History/Records',
      LICENSES_DEBTS: 'Count Licenses as Debts',
      DISCOUNTS_ENABLED: 'Global Discounts Active',
      VOUCHERS_ENABLED: 'Class Vouchers Active',
      POSTAL_ADDRESS_ENABLED: 'Postal Address Enabled',
      TERMS_ENABLED: 'Terms Signed Enabled',
      TERMS_DIGITAL_SIGNATURE: 'Terms - Digital Signature',
      MULTI_MEMBERSHIPS: 'Multiple/Extra Memberships Enabled',
      PHOTO_RELEASE_ENABLED: 'Photo Release Signed Enabled',
      DEFAULT_PHONE_PREFIX: 'Default Phone Prefix',
      NOTIFY_MESSAGE_EMAIL: 'Notify New Messages by Email',
      TIMEZONE: 'Time Zone',
      ADVANCED_MEMBERSHIPS: 'Advanced Memberships Enabled',
      EVALUATIONS_ENABLED: 'Evaluations system',
      INTEGRATION_QR: 'Enable Kydemy QR App'
    },
    emails: {
      forgot_password: {}
    },
    styles: {
      title: 'Class Styles',
      subtitle: 'Styles are a way of classification for classes. Also they are used to assign different levels to each style in order to organize classes and members more efficiently.',
      name: 'Name',
      code: 'Code',
      create_style: 'Create Style',
      message: 'Styles are a useful way for you to categorize classes and establish an independent progression path for students using levels. Once you have configured your styles, you should set up the different levels available for each style in the Levels section.',
      error_existing_name: 'There is another style with a similar name',
      error_existing_code: 'The code already exists',
      delete_style_header: 'Deleting Styles',
      delete_style_message: 'Only styles with no classes associated can be deleted. You can always create new styles and associate the classes to the new style or rename an existing style.',
      style_created: 'Style created successfully',
      style_updated: 'Style updated successfully',
      style_deleted: 'The Style has been deleted',
      info_levels: 'Please select a levels template, you will be able to customize the style levels later using the Levels section.',
      no_styles: 'There are no styles created, please create using the form bellow.'
    },
    levels: {
      title: 'Style Levels',
      subtitle: 'Levels limit the progression or define the categories within a Style. Members will need to have a level equal or greater than the class in order to attend.',
      styles: 'Styles',
      levels_for: 'Levels for {styleName}',
      name: 'Name',
      code: 'Code',
      default: 'Default',
      selectable: 'Selectable',
      tooltip_selectable: 'If selectable, this level will be available for students and classes. If not, it will be available for classes.',
      tooltip_default: 'The default level will be chosen automatically when using this style in a class, unless a different level is selected.',
      level_created: 'Level added to the style successfully',
      level_updated: 'The Level was updated successfully',
      level_deleted: 'The Level was removed successfully',
      no_levels: 'There are no levels defined for the selected Style',
      no_delete: 'The level is being used by students or classes and therefore it cannot be deleted',
      error_existing_name: 'There is another level with a similar name',
      error_existing_code: 'The code already exists'
    },
    classrooms: {
      title: 'Classrooms & Locations',
      subtitle: 'Classrooms are used to locate the space that a class will take place. Classrooms will be selected when scheduling classes. Locations are groups of classrooms that are separated physically in different venues.',
      locations: 'Locations',
      location_details: 'Location details',
      classrooms_for: 'Classrooms for {location}',
      name: 'Name',
      rent: 'Monthly Rent',
      address: 'Address',
      save: 'Save',
      new_location: 'Add New Location',
      no_classrooms: 'There are no classrooms created for the selected location',
      classroom_created: 'The classroom has been created in the selected location',
      classroom_updated: 'The classroom has been updated successfully',
      classroom_deleted: 'Classroom deleted',
      location_updated: 'The location has been updated',
      location_created: 'Location created successfully',
      location_name_placeholder: 'Location or Venue name',
      location_address_placeholder: 'Full address',
      delete: 'Delete',
      disabled_delete_tooltip: 'In order to delete the Location, please delete all classrooms first',
      location_deleted: 'Location deleted successfully',
      error_existing_name: 'There is another classroom with a similar name',
      latitude: 'Latitude',
      longitude: 'Longitude',
      enabled: 'Enabled',
      disabled: 'Disabled'
    },
    classes: {
      title: 'Classes',
      subtitle: 'In this section you will be able to perform updates to the classes catalog and adjust general settings for classes.',
      upgrade_regular_classes: 'Clone and Upgrade Regular Classes',
      no_active_classes: 'At this moment, there are no active classes to be cloned.',
      last_date: 'Last Class',
      archive_classes: 'Archive old classes after cloning',
      update_class_name: 'Rename old classes with their level',
      upgrade_class: 'Upgrade new class to next level',
      upgrade_students: 'Upgrade students to next level',
      date_start: 'Start Date',
      date_end: 'End Date',
      notify_students: 'Notify students and request attendance confirmation',
      notify_students_info: 'This action will NOT copy the class students into the new class. Instead it will send an email for each class and to every enrolled student. In this email will appear the date when the class starts and two options:<br/>- One to Confirm that they will attend the new class.<br/>- One to notify that they no longer will attend the class.<br/>If they select the confirm option they will be added to the class.<br/>Please note that there might be students without an email address on record, and therefore will not be notified.',
      upgrade_classes: 'Upgrade {num_classes} Classes',
      confirmation: 'Upgrade Classes',
      confirm_upgrade_classes: 'Are you sure that you want to proceed and upgrade the selected classes?',
      cannot_be_undone: 'This action cannot be undone and the classes will be modified permanently',
      cancel: 'Cancel',
      success_upgrade: 'Classes upgraded successfully',
      error_upgrade: 'An unexpected error occurred upgrading classes',
      info_title: 'Cloning and Upgrading Classes',
      info_body: 'When upgrading classes, the new classes will contain the details, students, waiting lists and links of the original class. Recurring dates will be extended the same amount of months of the original class, using the same schedule details. Only regular and active classes can be upgraded.',
      warning_title: 'Upgrade Options',
      warning_body: 'If you choose to <b>rename old classes</b>, the original class will be archived with a suffix using their current level code. Use this option to avoid having several classes with the same name.<br/>' +
        'If you choose <b>upgrade to next level</b> the new class will have the following level to the one defined in the original class. Please review if your levels are properly configured before proceeding.<br/>' +
        '<b>Upgrade students level</b> will increase the level of a student by one level for the style of the class. If a student is present in several classes being upgraded, the level will be modified just once every time you upgrade classes.',
      other_settings: 'Settings for Classes',
      CLASS_COUPLES_ENABLED: 'Classes for Couples Enabled',
      COUPLES_ROLE_GENDER: 'Use Male/Female instead of Leader/Follower',
      CLASS_SINGLES_ENABLED: 'Classes for Individuals Enabled',
      CLASS_GALLERY: 'Picture Galleries Enabled',
      TRIAL_CLASS_PRICE: 'Trial Class (Drop In) Price',
      AUTOARCHIVE_CLASSES: 'Auto-archive expired classes',
      CLASS_REGISTRATION_IGNORE_LEVELS: 'Class Registrations ignores student level'
    },
    students: {
      title: 'Students',
      subtitle: 'You can adjust which student fields and options will be used and displayed across Kydemy. You can also batch import students into the platform using the import wizard.',
      fields: 'Student Fields:',
      options: 'Student Options/Actions:',
      invitations: 'Platform Invites:',
      invitations_button: 'Send Invitations',
      invitations_message: 'This action will send an invitation to all active students which have not received any invitations yet.<br/>This action will send send invitations to <b>{numInvitations}</b> students and grant them access to the platform.',
      no_emails_message: 'Currently you are missing <b>{numNoEmails}</b> Email Addresses for active students or relatives:',
      invitations_lang_message: 'All invitations will be sent using the default language: ',
      invitations_success: 'Invitations sent successfully',
      invitations_error: 'There was an error sending the invitations, please contact us or try again later',
      import_export: 'Import & Export:',
      import: 'Import Students:',
      import_content: 'You can batch import students using a sample spreadsheet. The import process is guided by a wizard with three different steps:',
      import_step_1: '<b>Download Spreadsheet:</b> download the template spreadsheet and complete it with all your students data. Please review the fields enabled before downloading the spreadsheet.',
      import_step_2: '<b>Upload Spreadsheet:</b> you will upload the spreadsheet to Kydemy. Kydemy will show you any errors and you will be able to review the data.',
      import_step_3: '<b>Import Data:</b> Once you have reviewed your students data you will be able to import it into Kydemy.',
      import_button: 'Open Import Wizard',
      export: 'Export Students & Teachers:',
      export_students: 'Download all the students/teachers and their associated information in a spreadsheet (XSLX) file.',
      export_button: 'Download XSLX',
      export_file: 'Kydemy - Students Export - {client} - {date}.xlsx',
      bank_account: 'Bank Account:',
      target_account: 'Target Account:',
      no_bank_accounts: 'No Bank Accounts',
      iban_bank_accounts: 'IBAN / SEPA',
      aba_bank_accounts: 'ABA + Account Number',
      other_bank_accounts: 'Other Account Numbers',
      no_bank_account: '-- No bank account--',
      create_member_first: '-- Create student first --',
      clear_bank_account_button: 'Clear',
      store_bank_account_button: 'Save',
      store_bank_account_title: 'Store Bank Account Number:',
      bank_account_success: 'Bank Account Stored',
      bank_account_error: 'Could not store Bank Account, please contact us',
      bank_account_format_error: 'The bank account format is invalid',
      validate_bank_accounts: 'Validate Accounts',
      unlock_encryption_key_title: 'Unlock Encryption Key',
      unlock_encryption_key: 'Unlock Key',
      unlock_encryption_key_description: 'In order to display the bank account you need to unlock the encryption key using the master encryption password.',
      account_number: 'Account Number:',
      account_holder: 'Account Holder:',
      account_holder_placeholder: 'Leave empty if same as student',
      registration_holder_placeholder: 'Bank account holder',
      set_encryption_key: 'Create a new master Encryption Key:',
      save_encryption_key: 'Save Key',
      encryption_key_success: 'Encryption Key Saved Successfully',
      encryption_key_error: 'There was an error storing the key, please contact us',
      set_encryption_key_message: 'You are about to create a encryption key that will be used to retrieve bank account numbers later on. The key will be encrypted and we will not be able to recover it. Therefore you should select a secure key, store it safely and only share it with the authorized staff.',
      include_bank_accounts: 'Include Students\' Bank Account numbers.',
      invalid_key: 'The provided key is not valid',
      students_banner: 'Students Banner Message',
      students_banner_save: 'Save & Enable Message'
    },
    tags: {
      title: 'Tags Management',
      subtitle: 'Here you can check which tags are being used, delete them and edit their name/color.',
      member_tags: 'Member Tags',
      attachment_tags: 'Attachments Tags',
      columns: {
        tag: 'Tag',
        uses: 'Uses'
      },
      delete_modal: {
        title: 'Delete Tag',
        content: 'You are about to delete the selected tag. All references to this tag will be lost. Do you really want to delete this tag?',
        button: 'Delete Tag'
      }
    },
    teachers: {
      title: 'Staff',
      subtitle: 'You can adjust which options and permissions will be available for your staff in Kydemy.',
      options: 'Options for Teachers:',
      staff_options: 'General Staff Options:'
    },
    belts: {
      title: 'Belts',
      subtitle: 'Manage the allowed belts in the platform. You can define colors, define the sorting and exam prices that will be used when creating belt payments.',
      name: 'Name',
      students: 'Students',
      date: 'Date',
      colors: 'Colors',
      belt_created: 'Belt created successfully',
      belt_updated: 'Belt successfully updated',
      belt_deleted: 'The Belt has been deleted',
      belt_date: 'Select a Date',
      select_belt: 'Select a Belt',
      no_belts: 'No Belts added so far',
      price: 'Price',
      no_payment: 'Unpaid',
      paid: 'Paid'
    },
    license: {
      title: 'Licenses & Registration Fees',
      subtitle: 'Configure the default price and expiration date for new licenses / registration fees.',
      note_title: 'License Expiration',
      note_content: 'Please note that new licenses will expire on the due date that was configured when the payment was registered.'
    },
    memberships: {
      title: 'Memberships',
      subtitle: 'Memberships are used to provide you flexibility in your services to your students. You can create different tiers of memberships with independent prices and a number of monthly classes included.',
      name: 'Name',
      code: 'Code',
      color: 'Color',
      classes_month: 'Classes Month',
      price_month: 'Month',
      price_trimester: 'Quarter',
      price_year: 'Year',
      num_students: 'Students',
      num_payments: 'Payments',
      no_memberships: 'There are no Memberships created in the platform',
      membership_created: 'Membership created successfully',
      membership_updated: 'Membership successfully updated',
      membership_deleted: 'The Membership has been deleted',
      membership_months: 'Payable Membership Months:',
      membership_months_desc: 'Please select which months you require your students to pay membership fees and disable those months exempt of membership fees.',
      advanced_memberships: 'Advanced Memberships:',
      advanced_memberships_letter: 'Letter',
      advanced_memberships_name: 'Name',
      advanced_memberships_price_classes: 'Price Classes',
      advanced_memberships_discount_quarter: 'Disc. Quarter',
      advanced_memberships_discount_year: 'Disc. Year',
      advanced_memberships_default: 'Default',
      advanced_memberships_week_classes: 'Classes/Week',
      advanced_memberships_tracks_message: 'The <b>Advanced Memberships</b> feature works creating <b>Tracks</b>. Then you can assign your tracks to your classes and the membership fees will be calculated according to the amount of classes/tracks per student.<br/>Each track has a letter associated so you can quickly identify it on the classes and students fees.<br/>Once all your tracks are ready, press the "Process Tracks & Generate Fees" button.',
      tooltip_name: 'Please enter a Track name',
      tooltip_price_class: 'Please enter the monthly fee for 1 class per week of this track',
      tooltip_discount_quarter: 'Percentage Discount for quarter payments, or 0 for no discount/quarter payments',
      tooltip_discount_year: 'Percentage Discount for year payments, or 0 for no discount/year payments',
      advanced_memberships_classes_price_tooltip: 'Monthly price/fee for {num} classes per week',
      update_advanced_memberships: 'Update details Advanced Memberships',
      generated_count: 'Currently there are <b class="has-text-info">{num}</b> auto-generated membership fees.',
      track_classes_week: '{num} Classes/Week',
      too_many_title: 'Memberships exceeded',
      too_many_content: 'With the current configuration, you are generating <b class="has-text-info">{count}</b> combinations of possible membership fees. The maximum allowed is <b class="has-text-danger">{max}</b>.',
      too_many_content_bold: 'Please simplify your configuration to not exceed this number.',
      multi_memberships: 'Extra fees and monthly equipment rental'
    },
    social_networks: {
      title: 'Social Networks Configuration',
      subtitle: 'In this section you can edit the links to your social networks and website so your students can access easily.'
    },
    save: 'Save',
    delete: 'Delete',
    cancel: 'Cancel',
    import: {
      spreadsheet_columns: 'Spreadsheet Columns',
      download_spreadsheet: 'Download Template Spreadsheet',
      info_title: 'Spreadsheet Instructions',
      info_content: 'The spreadsheet will contain a column for each field selected above. Please delete the second row, which contains a sample student for reference. For classes, memberships, levels and other fields additional sheets will be added as reference. Please include the selected IDs, comma separated.',
      step1_title: 'Download Template',
      step2_title: 'Upload & Review',
      step3_title: 'Import Students',
      upload_spreadsheet: 'Upload Spreadsheet',
      upload_title: 'Upload Details',
      upload_content: 'Once you upload the completed Spreadsheet an overview of the contents will be displayed. If there are errors will be marked for your review. Please choose between re-uploading an updated spreadsheet or continue with the import process.',
      num_ok: 'Students OK',
      num_error: 'Students with Errors',
      re_upload: 'Cancel & Upload New Spreadsheet',
      import_overview: 'Import Overview',
      import_data: 'Import Students',
      import_title: 'Remember',
      import_content: 'Only student records without any errors will be imported. If you have errors, please go back, amend the spreadsheet and re-upload it again. Creating Students in the system can fail if the student information is already in the system, such as duplicated usernames, email addresses, etc.',
      overview_ok: 'students will be imported.',
      overview_parents: 'parents will be imported.',
      overview_errors: 'students contains errors and will be skipped.',
      overview_import_remaining: 'Remaining',
      overview_import_success: 'Successfully Imported',
      overview_import_errors: 'Import Errors',
      overview_import_skipped: 'Skipped',
      columnsMandatory: {
        firstname: 'First Name',
        lastname: 'Last Name',
        membership: 'Membership'
      },
      columns: {
        email: 'Email Address',
        phone: 'Phone',
        dob: 'Date of Birth',
        registration: 'Registration Date',
        username: 'Username',
        password: 'Password',
        dance_roles: 'Dance Roles',
        active: 'Active',
        can_login: 'Can Login',
        belt: 'Belt',
        levels: 'Levels',
        classes: 'Classes',
        discount: 'Discounts',
        id_number: 'ID / Passport Number',
        postal_code: 'Postal Code',
        postal_address: 'Postal Address',
        terms_accepted: 'Terms Accepted',
        photo_release_signed: 'Photo Release Authorization',
        other_details: 'Other Details',
        bank_account: 'Bank Account',
        parent: 'Parent',
        roles: 'User Roles'
      },
      errors: {
        field_required: 'The field contains errors or is mandatory',
        username_exists: 'The username already used by an existing student',
        email_exists: 'The email is already registered',
        phone_exists: 'The phone number is already registered',
        invalid_username: 'The username provided is not valid'
      },
      warning_title: 'Important Notice',
      warning_content: 'With the template you will be able to import students and link them to their associated styles and levels, membership fees and classes. Therefore is recommended to download the spreadsheet <b>AFTER</b> creating all classes, membership fees, styles and levels.'
    },
    registrations: {
      title: 'Student Registrations',
      subtitle: 'You can enable student registrations and adjust the registrations settings. Furthermore, you can provide your terms and conditions, in different languages and custom questions for the registration process.',
      settings: 'Registration Settings',
      terms: 'Terms & Conditions for Students',
      questions: 'Custom Questions',
      save: 'Save Translation',
      save_questions: 'Save Translations',
      cancel: 'Cancel',
      edit_translations: 'Edit Question and Translations',
      delete_question: 'Delete Question and all translations',
      new_question: 'Create a new Question',
      confirm_title: 'Delete Registration Question',
      confirm_content: 'Are you sure that you want to delete this question and its translations?',
      confirm_button: 'Delete Question',
      no_filters: '-- No registration filters created, all classes will be displayed --',
      confirm_filter_title: 'Delete Classes Filter',
      confirm_filter_content: 'Are you sure that you want to delete this classes filter?',
      confirm_filter_button: 'Delete Filter',
      no_classes: '-- There are no classes --',
      filter_classes_title: 'Select Filter Classes',
      back: 'Back',
      filters: 'Active Class Filters:',
      filters_info: 'You can use these filters to provide specific links to a sub-set of classes in the registration. Please note that if you mark a filter as Default, that filter will be used for the default registrations instead of all active classes.',
      filter_name: 'Name',
      filter_url: 'URL',
      filter_alias: 'Alias',
      filter_default: 'Default',
      filter_classes_selected: 'Classes Selected',
      filter_classes_available: 'Classes Available',
      filter_online_payments: 'Payments',
      filter_require_license: 'Req. License',
      filter_order_by: 'Sorting',
      filter_order_by_name: 'Name',
      filter_order_by_date: 'Date',
      filter_order_by_type: 'Type',
      link_copy_ok: 'Filter URL copied to clipboard',
      link_copy_error: 'Could not copy filter URL to clipboard',
      attachments: 'Confirmation Attachments',
      attachments_info: 'These attachments will be emailed to the student within the confirmation notification once you have processed their registrations. Please note that if you reject a registration, these files will not be included in the rejection email.',
      attachments_filename: 'File Name',
      attachments_description: 'Description',
      attachments_email_description: 'Email Details',
      attachments_size: 'Size',
      attachments_select_file: 'Select File...',
      attachments_error: 'Only PDF, Images, MP3, DOCX, XLSX and PPTX files up to 2 MiB are allowed.',
      no_attachments: '-- No registration attachments uploaded --',
      details_tooltip: 'This text will be included in the student confirmation email, please add any instructions or information related to each attachment.',
      confirm_attachment_title: 'Delete Attachment',
      confirm_attachment_content: 'Are you sure that you want to delete this registration attachment?',
      confirm_attachment_button: 'Delete Attachment',
      days_threshold: 'Late reg. threshold ({num} days)',
      days_threshold_info: 'How many days after the 1st of the month will be considered a late registration?',
      limit_future_payments_info: 'Do not require online payments for monthly fees more than two months in advance',
      redirection_url: 'Redirection URL',
      payments_strategy: 'Late reg. strategy',
      payments_strategy_info: 'Strategy for late registrations:<br/><b>-Full price for the current month:</b> Registered late in May, May is paid in full.<br/><b>-Full price for the next month:</b> Registered late in May, June is paid in full.<br/><b>-Proportional price for the current month</b>: Registered 20th May, May is paid for 1/3 of the price.',
      strategies: {
        same_month: 'Current month - full price',
        next_month: 'Next month - full price',
        proportional: 'Current month - proportional'
      }
    },
    storage: {
      title: 'Storage Usage',
      subtitle: 'Analyze the current use of your storage and how the used space is distributed according to the different content types. You can also check your current free storage usage, or if you have exceeded it, the usage of additional storage units.',
      total: 'Total Storage usage:',
      types: {
        videos: 'Videos',
        attachments: 'Attachments',
        images: 'Images'
      },
      free_storage_title: 'Free Storage Usage',
      free_storage: 'Free Storage',
      used_storage: 'Free Storage Used',
      extra_storage: 'Extra Storage',
      available_storage: 'Free Storage Available',
      extra_storage_title: 'Extra Storage Usage',
      num_units: '{num} units',
      total_storage_used: 'Total Storage',
      extra_units: 'Extra Storage Units',
      current_unit_usage: 'Current Unit Usage',
      current_unit_free_space: 'Current Unit Free Space',
      message_free: 'You are currently using your Kydemy free storage and you will not have extra costs for storing of your current videos/attachments/images.',
      message_extra: 'You have exceeded the free storage available and you will be charged for each extra storage unit used.'
    }
  },
  user_menu: {
    my_profile: 'My profile',
    management_view: 'Management View',
    teacher_view: 'Teacher View',
    student_view: 'Student View',
    relative_view: 'Relative View',
    logout: 'Log out',
    help: 'Help Center',
    whatsapp_channel: 'WhatsApp Channel'
  },
  student: {
    headerbar: {
      overview: 'Overview',
      my_classes: 'Classes',
      events: 'Events',
      videos: 'Videos',
      files: 'Files',
      my_payments: 'My Payments',
      my_attendance: 'Attendance',
      messages: 'Messages',
      gallery: 'Gallery',
      evaluations: 'Evaluations',
      grades: 'Grades'
    },
    classes: {
      list: 'List',
      week: 'Week',
      month: 'Month',
      my_classes: 'My Classes',
      all_classes: 'All Classes',
      all_levels: 'All Levels',
      all_locations: 'All Locations',
      all_styles: 'All Styles',
      my_levels: 'My Levels',
      all: 'All',
      events: 'Events',
      all_classrooms: 'All Classrooms',
      show_filters: 'Show Filters',
      hide_filters: 'Hide Filters'
    },
    landing: {
      payments: 'Payments Status',
      membership: 'Membership',
      current_voucher: 'Current Voucher',
      regular_classes: 'Regular Classes',
      other_classes: 'Classes & Workshops',
      payments_up_to_date: 'Your payments are up to date',
      payments_up_to_date_advance: 'Your payments are up to date, however you can now make the <b>{month}</b> payment.',
      payments_error_message: 'Your payments are not up to date. Please review the following or contact us for further information:',
      payments_num_classes: 'It seems that you have exceeded the amount of classes that you could attend this/last month.',
      class: 'class',
      class_error_details: 'In {month} you attended {classes_attended} classes and your membership allowed {classes_month} classes and you paid for {classes_payed} classes.',
      last_comments: 'Last Messages',
      no_comments: 'You have not received any messages or comments yet',
      today_classes: 'Today Classes',
      no_classes_today: 'Today you don\'t have any classes scheduled',
      your_classes: 'My Classes',
      no_classes: 'Currently you are not enrolled in any class',
      attendance: 'Attendance',
      no_attendance: 'Currently we don\'t have enough information to calculate your attendance',
      new: 'New',
      license_status: 'License/Registration',
      belts_status: 'Belts',
      license: 'License',
      expired: 'Expired',
      pay: 'Pay Now',
      belt: 'Belt',
      missing_bank_account: 'We do not have your bank account number on file. Please provide your bank account number:',
      missing_bank_account_button: 'Add Bank Account',
      other_debts: 'Other Debts',
      hide_add_bank_account: 'Do not ask again'
    },
    class: {
      teachers: 'Teachers',
      details: 'Details',
      next_classes: 'Next Classes',
      last_classes: 'Last Classes',
      links: 'Links',
      request_registration: 'Request Registration',
      request_pending: 'Request Pending',
      request_registration_tooltip: 'Click this button if you wish to register in this class.',
      request_registration_tooltip_error: 'You don\'t have the level required to register in this class.',
      request_pending_tooltip: 'We have received your request, we will review it shortly.',
      registered: 'Registered',
      waiting_list: 'In Waiting List',
      declined: 'Request Declined',
      registration_modal_title: 'Request Class Registration',
      registration_modal_content: 'Do you want to register in <b>{cls}</b> ({style}, {level})?<br/>We will review your request as soon as possible and you will receive a confirmation within the platform.',
      registration_modal_button: 'Request Registration',
      registration_modal_cancel: 'Cancel',
      registration_request_sent: 'Request sent successfully',
      classrooms: 'Location & Classroom',
      classroom_name: 'Classroom'
    },
    profile: {
      currentPasswordPlaceholder: 'Enter current password',
      newPasswordPlaceholder: 'Enter your new password',
      confirmPasswordPlaceholder: 'Enter your new password again',
      errorWrongPassword: 'The password provided is not valid',
      update_password: 'Update Password',
      cancel_update_password: 'Cancel',
      email: 'Email Address',
      phone_number: 'Phone Number',
      username: 'Username',
      joined: 'Joined',
      dob: 'Birthday',
      leader: 'Leader',
      follower: 'Follower',
      details_message: 'If your details are not correct, please contact us and we will update your record.',
      current_password: 'Current Password',
      new_password: 'New Password',
      confirm_password: 'Password Confirmation',
      update_profile: 'Edit Details',
      update_notification_settings: 'Notifications Settings',
      select_dob: 'Select a Date',
      cancel: 'Cancel',
      save_profile: 'Save Changes',
      update_ok: 'Your profile has been updated successfully',
      update_error: 'There was an error updating your profile, please contact us'
    },
    videos: {
      no_videos: 'There are no videos available at this moment'
    },
    payments: {
      no_payments: 'There are no payments registered in the application',
      pending_payments: 'Pending Payments',
      payment_history: 'Payment History',
      pay_now: 'Pay Now',
      pay_all: 'Pay All',
      total: 'Total',
      total_desc: 'All Payments',
      new_payment: 'New Payment',
      new_payment_info: 'At the moment all your payments are up to date, however you can already make the payment for your next installments.',
      receipt_file: 'Payment Receipt - {client} - {type} - {date}.pdf',
      base_price: 'Base Price',
      discount_price: 'Discount',
      methods: {
        cash: 'Cash Payment',
        creditcard: 'Credit Card',
        stripe: 'Online Credit Card Payment',
        paypal: 'PayPal',
        bizum: 'Bizum',
        wire: 'Wire Transfer',
        check: 'Cashier\'s Check'
      },
      methods_short: {
        cash: 'Cash',
        creditcard: 'C. Card',
        stripe: 'C. Card Online',
        paypal: 'PayPal',
        bizum: 'Bizum',
        wire: 'Wire',
        check: 'Check'
      },
      modal: {
        title: 'New Payment for: {name}',
        cancel: 'Cancel',
        button: 'Register Payment',
        button_voucher: 'Add Class to Voucher',
        select_month: 'Select a Month',
        select_months: 'Select Months',
        payment_success: 'The payment has been registered successfully.',
        payment_error: 'There was an error registering the payment. Try again later or contact us.',
        new_payment: 'Register Payment'
      }
    },
    reset_password: {
      title: 'Welcome to {platform_name}',
      desc: 'As this is the first time you access the platform you are required to configure a new password.<br/>Please enter your new password and press \'Save and Continue\' in order to access the platform.',
      password: 'New password',
      password_confirmation: 'Confirmation',
      save_password_button: 'Save and Continue',
      passwordPlaceholder: 'Enter your new password',
      passwordConfirmationPlaceholder: 'Re-enter the new password',
      password_requirements: 'The password must be at least five characters long',
      update_password_success: 'Password updated successfully',
      update_password_error: 'Could not update password, try again or contact us'
    },
    files: {
      personal_files: 'Personal Files:',
      classes_files: 'Classes Files:'
    }
  },
  teacher: {
    landing: {
      your_classes: 'Your Classes',
      week_classes: 'Classes this Week',
      no_classes_week: 'You have no classes this week',
      no_classes: 'You don\'t have any classes assigned yet.',
      classes_attendance: 'Class Average Attendance',
      no_attendance: 'There is not enough data to show your classes attendance'
    }
  },
  relative: {
    landing: {
      avg_attendance: 'Average Attendance',
      classes: 'Current Classes'
    }
  },
  notifications: {
    action_required: 'A notification will be shown as unread while there are pending actions.',
    no_more_notifications: 'There are no more Notifications',
    registration_confirmation_status_updated: 'New class <b>attendance confirmation</b> for <a href="/#/kydemy/classes/{class_id}?tab=couples">{class_name}</a>: <b>{value}</b>',
    request_registration: 'New <b>class registration</b> request for <a href="/#/kydemy/classes/{class_id}?tab=couples">{class_name}</a>',
    registration_accepted: 'Your class registration request for <a href="/#/classes/{class_id}?tab=couples">{class_name}</a> has been <b>accepted</b>',
    registration_accepted_waiting_list: 'Your have been added to the <b>waiting list</b> of <a href="/#/classes/{class_id}?tab=couples">{class_name}</a>',
    registration_rejected: 'Your class registration request for <a href="/#/classes/{class_id}?tab=couples">{class_name}</a> has been <b>denied</b>:<br/><i class="help">{message}</i>',
    registration_auto_processed: 'New registration for online classes: {classes}',
    voucher_depleted: 'Classes <b>voucher</b> almost <b class="has-text-info">depleted</b>',
    voucher_expired: 'Classes <b>voucher</b> almost <b class="has-text-danger">expired</b>',
    new_class_private_note: 'New <b class="has-text-danger">PRIVATE note</b> for the class <a href="{classLink}">{class_name}</a> on {date}',
    new_class_public_note: 'New <b class="has-text-info">teacher note</b> for the class <a href="{classLink}">{class_name}</a> on {date}',
    new_task_assigned: 'You have been assigned a <b class="has-text-info">{task_priority}</b> priority task: <a href="#" onclick="window.showTasks()">{title}</a>',
    new_class_video: 'New <b class="has-text-info">video</b> added to your class <a class="has-text-weight-bold" href="{classLink}">{class_name}</a>',
    new_class_file: 'New <b class="has-text-info">file</b> added to your class <a class="has-text-weight-bold" href="{classLink}">{class_name}</a>',
    new_class_link: 'New <b class="has-text-info">link</b> added to your class <a class="has-text-weight-bold" href="{classLink}">{class_name}</a>',
    notification: 'Notification',
    unsubscribe: 'Unsubscribe',
    save: 'Save Preferences',
    tooltip_email: 'Email notifications',
    tooltip_push: 'Mobile push notifications',
    info_message: 'You can enable/disable notifications for each device/channel by clicking on the checkboxes and saving your preferences.',
    unsubscribed_info: 'You are currently unsubscribed from all notifications.<br/>You can enable notifications clicking on the following button:',
    subscribe_button: 'Enable Notifications',
    unsubscribe_modal: {
      title: 'Unsubscribe from all Notifications',
      content: 'You are about to unsubscribe from all notifications, and therefore you will not receive any information from this platform.',
      content_bold: 'If you unsubscribe you will not be notified of important messages and communications, do you really want to unsubscribe?',
      button: 'Unsubscribe'
    },
    save_success: 'Your notification preferences have been updated',
    save_error: 'There was an error updating your preferences, please contact us',
    unsubscribe_success: 'You are unsubscribed from all communications',
    unsubscribe_error: 'There was an error unsubscribing you, please contact us',
    bounced_error: 'This email address seems to be incorrect, emails are not being delivered',
    bounce_popover_title: 'Error with Email Account:',
    bounce_popover_description: 'The message could not be delivered due to an error. Below is the error we received when trying to deliver the mail:',
    bounce_popover_message: 'These bounce errors require manual intervention by the email account owner when there are errors in the client\'s account (inactive, quota exceeded, etc.); or on your part when the account does not exist (eg. mistyped address). Once the error is resolved, emails can be sent again using the button below to unlock the account.',
    bounce_popover_important: '<b>IMPORTANT:</b> If the error has not been resolved (by the account owner or the address has been rewritten), this error will occur again.',
    bounce_popover_button: 'Mark Problem as Fixed',
    tag_bounced: 'Error',
    tag_unsubscribed: 'Unsubscribed',
    tag_spam: 'SPAM Reported',
    tooltip_bounced: 'The email address of this user is incorrect or the emails cannot be delivered',
    tooltip_unsubscribed: 'This person has explicitly unsubscribed and we will not send new emails to him/her',
    tooltip_spam: 'This person has marked your emails as SPAM and we will not sending new emails to him/her',
    BULK_MESSAGE: 'News and communications',
    MESSAGE_RECEIVED: 'New message received',
    CLASS_CANCELLED: 'Class Cancelled',
    PAYMENT_MEMBERSHIP_CURRENT_MONTH: 'Current month - payment reminder',
    PAYMENT_MEMBERSHIP_NEXT_MONTH: 'Next month - payment reminder',
    load_more: 'Load more...'
  },
  messenger: {
    select_conversation: 'Please select a conversation or use the search box to send a new message',
    select_conversation_student: 'Please select a conversation to read your messages',
    no_messages_student: 'You have not received any messages or comments yet',
    compose_title: 'Compose a new Message',
    new_message_ok: 'Message sent successfully to {name}',
    new_message_error: 'The message could not be sent',
    delete_message_ok: 'Message deleted successfully',
    delete_message_error: 'The Message could not be deleted',
    delete_message: 'Delete',
    reply_message: 'Reply',
    reply_button: 'Send Reply',
    edit_message: 'Edit',
    edit_button: 'Update Message',
    edit_message_ok: 'The message has been updated',
    edit_message_error: 'The Message could not be updated',
    cannot_edit: 'The message has been read already, cannot be edited',
    cancel: 'Cancel',
    message_deleted: '-- This message has been deleted --',
    reply_placeholder: 'Enter your message here',
    edit_placeholder: 'Enter your edited message here',
    compose_placeholder: 'Enter your message here',
    send_message: 'Send Message',
    save_comment: 'Save Internal Comment',
    delete_confirmation_title: 'Confirmation: Delete Message',
    delete_confirmation_content: 'Are you sure that you want to delete this message?',
    cannot_be_undone: 'This action cannot be undone.',
    internal_comment: 'Only visible for teachers',
    no_internal_comment: 'Visible by {name} and teachers',
    teacher_comment: 'Teacher\'s Comment',
    private_comment: 'Internal comment',
    private_comment_description: 'Only visible for teachers',
    no_private_comment_description: 'Visible by {name} and teachers',
    no_messages: 'You have not sent nor received messages from {name} yet.',
    message_yourself: 'You cannot send messages to yourself.',
    send_whatsapp: 'Send Whatsapp',
    back_to_top: 'Back to top'
  },
  paymentModal: {
    add_payment_method: 'Add payment method',
    make_payment: 'Make Payment',
    make_payment_subscription: 'Make Subscription Payment',
    concept: 'Concept:',
    amount: 'Amount:',
    tax: 'Tax / VAT:',
    balance: 'Balance:',
    total: 'Total:',
    details: 'Details:',
    payment_info: 'Card Information:',
    secure_payment: '<b>Secure Payment:</b> Make a secure payment using your credit card. Your credit card information will be encrypted and managed by Stripe secure payments. Our system will not store your credit-card information.',
    secure_payment_paypal: '<b>Secure Payment:</b> Make a secure payment using your PayPal account or credit card. Your payment information will be kept safe by PayPal. Our system will not store your credit-card information.',
    cancel: 'Cancel',
    pay_now: 'Pay Now',
    cardholder: 'Cardholder Name:',
    license_payment_details: 'License valid until: {date}',
    belt_payment_details: '{name} Belt',
    subscription_due: 'Your subscription is due and should be paid as soon as possible to avoid platform cancellation.',
    subscription_uncollectible: 'You have an outstanding invoice.',
    subscription_processing: 'Your subscription payment is currently being <b>processed</b>. Please note that it may take a few days for your bank to authorize the transfer.',
    trialing_ends: 'Your Kydemy trial period <b>will expire in {days} days</b>.',
    trialing_ends_today: 'Your Kydemy trial period <b>expires today</b>.',
    trial_no_payment_method: 'Your subscription will unfortunately be <b class="has-text-danger">canceled</b> unless a payment method is added soon.',
    past_due_message: 'Your <b>subscription fee is past due</b>. Therefore, you must perform the missing payments in order to continue using Kydemy.',
    subscription_invoice_info: 'Your invoicing information is missing, please update your invoicing information:',
    update_info: 'Update now',
    types: {
      class: 'Class Payment',
      membership: 'Membership Fee',
      belt: 'Belt exam/fee Payment',
      multiple: 'Multiple Payments',
      event: 'Event',
      license: 'License Fee',
      other: 'Other Payment',
      voucher: 'Classes Voucher'
    },
    spans: {
      custom: 'Custom',
      month: 'Month',
      trimester: 'Quarter',
      year: 'Year'
    },
    custom_months_select_title_mobile: '{numMonths} Months',
    custom_months_select_title: '{numMonths} Months Selected',
    custom_months_select_title_empty: 'Select Months',
    payment_success: 'Your payment has been processed successfully.<br/>Thank you!',
    continue: 'Continue',
    errors: {
      error: 'Payment Error:',
      bad_request: 'There was an internal error processing the payment. Please try again later.',
      incorrect_cvc: 'Your credit/debit card\'s security code (CVC) is incorrect.',
      card_declined: 'Your credit/debit card was declined.',
      insufficient_funds: 'Your card has insufficient funds.',
      card_expired: 'Your card has expired.',
      expired_card: 'Your card has expired.',
      processing_error: 'An error occurred while processing your card. Try again in a little bit.',
      incorrect_zip: 'The provided ZIP/Postal Code is invalid for the supplied card.',
      card_issue: 'There was a problem validating your card, please try again in a little bit.',
      do_not_honor: 'There is a problem with the information provided, please check the expiration date and the card number. If the problem persists, contact the bank or the issuer of your card.',
      '3d_error': 'The payment security confirmation was unsuccessful.',
      lost_card: 'The payment could not be processed because the card has been flagged as lost.',
      payment_intent_authentication_failure: 'The payment security confirmation was unsuccessful.',
      CARD_TYPE_NOT_SUPPORTED: 'Your card type is not supported. Please try again with another card.',
      CONSENT_NEEDED: 'The payment could not be processed due to lack of consent.',
      PAYER_CONSENT_REQUIRED: 'The payment could not be processed due to lack of consent.',
      PAYEE_NOT_CONSENTED: 'The payment could not be processed due to lack of consent.',
      CURRENCY_NOT_SUPPORTED_FOR_CARD_TYPE: 'This card does not support the currency, please try again with a different card.',
      CURRENCY_NOT_SUPPORTED_FOR_COUNTRY: 'This currency is not supported in your country, please contact us.',
      PAYER_COUNTRY_NOT_SUPPORTED: 'Your country is not supported by PayPal, please contact us.',
      INSTRUMENT_DECLINED: 'The payment was rejected by your bank due to insufficient funds or incomplete information.',
      INVALID_ACCOUNT_STATUS: 'Payment declined due to your account status, please review your PayPal account.',
      MAX_AUTHORIZATION_COUNT_EXCEEDED: 'There was an error processing your payment, please try again with a diffent card and contact us if the problem persists.',
      MISSING_REQUIRED_PARAMETER: 'There was an error processing your payment, please try again with a diffent card and contact us if the problem persists.',
      ORDER_EXPIRED: 'The payment expired, please reload the page and try again.',
      ORDER_NOT_APPROVED: 'The payment expired, please reload the page and try again and use a different card if the problem persists.',
      PAYEE_BLOCKED_TRANSACTION: 'Your card could not be processed due to security reasons, please try again with a different card.',
      PAYER_ACCOUNT_LOCKED_OR_CLOSED: 'Your account is either locked or closed, please update your account and try again.',
      PAYER_ACCOUNT_RESTRICTED: 'Your account is currently restricted, please check your PayPal account and try again or contact PayPal.',
      PAYER_CANNOT_PAY: 'The payment could not be processed, please try again with a different card.',
      POSTAL_CODE_REQUIRED: 'Your payment could not be processed due to the postal code is required.',
      TRANSACTION_REFUSED: 'There was a problem processing the payment, please reload the page and try again and use a different card if the problem persists.',
      PAYEE_ACCOUNT_NOT_VERIFIED: 'Your account has not been verified by PayPal, please update your account and try again.',
      PAYPAL_ERROR: 'There was a problem processing the payment, please reload the page and try again and use a different card if the problem persists.',
      confirmation_error: 'There was a problem processing your registration. Please contact us to review this issue.',
      payment_intent_unexpected_state: 'The payment method is not currently available, please contact us.'
    },
    due_to: 'Due {date}',
    payment_questions: 'If you have any questions, contact us sending an email to <a href="mailto:{email}">{email}</a> or call at <a href="tel:{tel}">{tel}</a>.',
    payment_received: 'Payment Received',
    already_payed: 'The payment has already been paid. Thank you!',
    link_not_found: 'This payment link has expired or it is not active anymore. Please contact us in order to get a new link or arrange a different payment method.',
    discount_tag: 'Discount',
    discount_tooltip: 'The discount is already applied to the final amount',
    vat_incl: 'VAT ({vat}%)',
    vat_tooltip: 'The final amount already includes the VAT',
    store_card: 'Store information for future payments.',
    use_stored_card: 'Use previously used card information.',
    use_new_card: 'Use a new credit card.'
  },
  canceled_modal: {
    title: 'Subscription Cancelled',
    content: 'Your Kydemy subscription and platform have been cancelled due to lack of activity or missing payments.',
    content_bold: 'In order to restore your platform and re-activate your subscription, please contact us using the button bellow.',
    email_text: 'Contact Kydemy',
    email_subject: 'Restore Kydemy: {host}'
  },
  modal_confirmation: {
    save: 'Save',
    cancel: 'Cancel',
    back: 'Back',
    clear: 'Clear',
    cannot_be_undone: 'This action cannot be undone.',
    close: 'Close',
    generic_error: 'There was an error processing your request, please try again later'
  },
  gallery: {
    mode_timeline: 'Timeline',
    mode_gallery: 'Gallery',
    add_picture: 'Add Picture',
    new_image_title: 'Add New Student Picture',
    new_image_content: 'Please select a student to continue:',
    new_image_content_classes: 'Please select a class to continue:',
    cancel: 'Cancel',
    upload: 'Upload Picture',
    upload_image: 'Select Picture',
    reupload_image: 'Re-select Picture',
    empty_gallery: 'The Class Gallery is empty, please upload some pictures.',
    empty_gallery_student: 'Your Gallery is empty, please upload some pictures to any of your classes.',
    public_item: 'Public Image',
    private_item: 'Private Image',
    public_item_desc: 'Visible by all teachers and students',
    private_item_desc: 'Visible only by teachers and yourself',
    private_item_desc_teacher: 'Visible only by teachers and the student',
    delete_item: 'Delete Gallery Image',
    delete_item_confirm_title: 'Delete Gallery Image',
    delete_item_confirm_content: 'Are you sure that you want to delete the selected Image?',
    delete_item_confirm_button: 'Delete Image',
    cannot_be_undone: 'This action cannot be undone'
  },
  social_networks: {
    website: 'Website',
    facebook: 'Facebook Page',
    instagram: 'Instagram Profile',
    twitter: 'X (Twitter) Account',
    youtube: 'YouTube Channel'
  },
  registration: {
    login_button: 'Registration',
    or: 'OR',
    error: 'There was an error processing your registration. Please review your data and try again. Please contact us if the error persists.',
    success_title: 'Registration Successful',
    success_text: 'Thank you for registering.<br/>Once you validate your email address, we will review your request and you will receive a confirmation email.',
    success_message: 'You will receive an email at the address provided with the details of the registration and the instructions to validate your account.<b>Please note that you will not be fully registered until you validate your address and we have your registration details reviewed.</b>',
    picture_title: 'Profile Picture',
    picture_text: 'It would be really helpful if you could upload a profile picture.<br/>This picture will be used internally only and it will help us to provide you a better service and ease tasks like checking class attendance.',
    picture_warning: 'The picture must be current and be a face-shot where you are easily recognized. The picture will be clipped square. Only JPEG and PNG images are supported.',
    picture_upload: 'Upload Picture',
    picture_error: 'Error processing your picture, please select a different picture.',
    thank_you: 'Thank you!',
    process_registration: 'Process Registration',
    pending: 'Pending',
    processed: 'Processed',
    add_waiting_list: 'Add to waiting list',
    reject: 'Reject Registration',
    accept: 'Add to Class',
    missing_actions: 'missing actions for classes.',
    process_success: 'The registration was processed successfully.',
    process_error: 'There was an error processing the registration. Please try again later.',
    empty: 'Currently there are no pending registrations to be processed.',
    empty_processed: 'You have not processed any registrations yet.',
    no_classes: 'This registration is not linked to existing classes. It seems like the classes have been deleted after the student submitted his/her registration.',
    step1: {
      title: 'Terms & Conditions',
      accept_terms: 'I have read and I accept the terms and conditions.'
    },
    step2: {
      title: 'Class Registration',
      message: 'Please select the class or classes that you wish to register.',
      membership_prices_title: 'Membership Fees for Regular Classes:',
      membership_name: 'Membership Name',
      membership_prices: 'Membership Fees',
      membership_classes_month: 'Monthly Classes/Hours Included',
      price_month: 'Month',
      price_quarter: 'Quarter',
      price_year: 'Year'
    },
    step3: {
      title: 'Personal Details',
      firstname: 'First name:',
      lastname: 'Last name:',
      email: 'Email Address:',
      phone: 'Phone Number:',
      password: 'Password:',
      confirmation: 'Confirmation:',
      birthday: 'Date of Birth:',
      postal_code: 'Postal/Zip Code:',
      postal_address: 'Postal/Street Address:',
      id_number: 'ID/Passport Number:',
      dance_role: 'Dance Role:',
      dance_partner: 'Dance Partner:',
      dance_partner_name: 'Partner Name:',
      label_no_partner: 'I don\'t have a partner',
      label_yes_partner: 'I have a partner',
      placeholder_firstname: 'Enter your first name',
      placeholder_lastname: 'Enter your first name',
      placeholder_email: 'Please enter your email address',
      placeholder_phone_prefix: 'Prefix',
      placeholder_phone_number: 'Phone number',
      placeholder_password: 'Enter a Password ',
      placeholder_confirmation: 'Please re-enter password',
      placeholder_postal_code: 'Enter your Postal Code / Zip',
      placeholder_postal_address: 'Enter your Home Address',
      placeholder_id_number: 'Enter your ID or Passport',
      placeholder_dance_partner_name: 'Full name of your partner',
      close: 'Go Back',
      search_partner_none: 'My partner is not on the list',
      conflict_title: 'Account Already Registered:',
      conflict_message: 'It seems that the information you entered already exists. You might already have an existing account.<br/>Please try signing in or use the forgot password link in the login page to recover your password.<br/>Please contact us if you are unable to log in.',
      conflict_registration_title: 'Registration Pending:',
      conflict_registration_message: 'It seems that you have already submitted a registration which has not been reviewed yet.<br/>Please wait until the registration has been reviewed order to submit a new one.<br/>If you wish to amend your previous registration, please contact us directly.',
      login: 'Registered Student',
      login_description: 'If you already have an account, use your credentials to sign in and continue with the registration process.',
      register: 'New Registration',
      register_description: 'If you do not have an account, please complete the registration for new students.',
      login_button: 'Validate and Continue',
      account_holder: 'Bank account holder'
    },
    step4: {
      title: 'Review & Submit',
      subtitle: 'Review Your Registration Information:',
      message: 'You are about to submit your registration information, please review that all the provided data is correct and then press \'Finish\'',
      classes: 'Request Registration for Classes:',
      personal_data: 'Personal Details:',
      payment_info: 'Payment Information:',
      payment_message: 'By completing this registration you accept to be charged the amount of {amount}, corresponding to membership/classes fees.',
      student_registration_payment: 'Student Registration Payment'
    },
    stepPayment: {
      title: 'Payment Details',
      subtitle: 'Classes & Fees Payment Information',
      message: 'On this step you can include your credit-card information to pay the classes or monthly fees corresponding to the classes chosen before.<br/>Your credit card information will be encrypted and managed by Stripe secure payments. Our system will not store your credit-card information.',
      message_no_payment: 'At this time, it is not necessary to make any payment, you can proceed to the next step.',
      check_card: 'Check Card and Continue',
      membership_error_title: 'Invalid Class Selection',
      membership_error_message: 'We currently do not have a monthly membership fee that is compatible with the selected classes. Please go back to the class selection, check the available fees and adjust your class selection accordingly.',
      paypalPaymentOk: 'Your payment information has been processed by PayPal and you will be charged when you confirm your registration.'
    },
    modal: {
      title: 'Process Registration: {name}',
      content: 'Your are about to process this registration. The system will perform the selected actions for the {num_classes} class/es in this registration.<br/>Please note that the student will receive a confirmation email with these actions.<br/>Also they will receive required credentials/information to access the platform.<br/>Do you want to proceed?'
    },
    delete_modal: {
      title: 'Delete Student Registration',
      content: 'You are about to delete this student registration. Are you sure that you want to proceed?',
      button: 'Delete Registration'
    },
    validation: {
      error: '<p>There was an error validating your email address</p><p>Please contact us to manually validate your data and complete your registration.</p>',
      success: '<p>Thank you, your email has been validated successfully.</p><p>Now we will review your registration information and soon you will receive a confirmation email with your registration status.</p>',
      loading: '<p>We are validating your email address.</p><br/><p>Please wait...</p>',
      validated: 'Validated'
    },
    confirmation: {
      error: '<p>There was an error confirming your class registration.</p><p>Please contact us to manually complete your class registration.</p>',
      success: '<p>Thank you, your class registration information has been updated.</p>',
      loading: '<p>We are updating your class registration status.</p><br/><p>Please wait...</p>'
    },
    delete_success: 'Registration deleted successfully',
    delete_error: 'The registration could not be deleted',
    registration_conflict_tooltip: 'The registration cannot be processed due to a data conflict. Either the email address and/or phone number conflicts with an existing student, please update the existing student accordingly and delete this registration when finished.',
    registration_conflict: 'Student Data Conflict'
  },
  tasks: {
    no_tasks: 'Currently you do not have any tasks',
    title: 'Tasks',
    new_task: 'Create new task',
    show_done: 'Show completed tasks',
    priority: 'Priority',
    assigned_to: 'Assignee',
    complete_by: 'Deadline',
    status: 'Status',
    mark_done: 'Mark as Done',
    mark_undone: 'Reopen Task',
    edit_task: 'Edit Task',
    delete_task: 'Delete Task',
    fix_now: 'Check it now',
    save_task: 'Save Task',
    setup_task_done: 'This task is completed and no further actions are needed',
    cancel_button: 'Cancel',
    no_deadline: 'No Deadline',
    select_deadline: 'Select Deadline',
    task_title: 'Task Title:',
    task_description: 'Description:',
    task_priority: 'Priority:',
    task_assignee: 'Assignee:',
    task_deadline: 'Deadline:',
    assignee_member: 'User',
    assignee_role: 'Role',
    statuses: {
      done: 'Done',
      overdue: 'Overdue',
      pending: 'Pending'
    },
    titles: {
      NO_STYLES: 'Kydemy Configuration - Create Styles',
      NO_MEMBERSHIPS: 'Kydemy Configuration - Create Memberships',
      NO_CLASSROOMS: 'Kydemy Configuration - Create Classrooms',
      NO_LEVELS: 'Kydemy Configuration - Create Levels',
      NO_TEACHERS: 'Kydemy Configuration - Create Teachers',
      NO_CLASSES: 'Kydemy Configuration - Create Classes',
      NO_STUDENTS: 'Kydemy Configuration - Create Students',
      REVIEW_PAYMENTS: 'Kydemy Configuration - Review Payments Settings',
      REVIEW_SOCIAL_NETWORKS: 'Kydemy Configuration - Review Social Networks Settings',
      REVIEW_GENERAL_INFORMATION: 'Kydemy Configuration - Review General Information',
      REVIEW_BILLING_INFORMATION: 'Kydemy Configuration - Review Billing Information'
    },
    descriptions: {
      NO_STYLES: 'There are no styles created for your classes/platform. You must configure some styles before creating any classes.',
      NO_MEMBERSHIPS: 'There are no memberships created for your classes/students. Please configure some memberships before creating any classes.',
      NO_CLASSROOMS: 'There are no classrooms configured for your classes. Please create some locations/classrooms in order to create classes/schedule.',
      NO_LEVELS: 'There are no levels for the styles to be used by your classes/students. Please add some levels to the created styles.',
      NO_TEACHERS: 'There have not been teachers created in the platform. Please create some teachers for your classes.',
      NO_CLASSES: 'There are no classes created in the platform. Please create some classes so you can start using Kydemy.',
      NO_STUDENTS: 'There have not been students created in the platform. Please create some students so you can add them to classes.',
      REVIEW_PAYMENTS: 'We recommend you to review the payment settings: currency, vat/taxes, licenses, membership payments, online payments, etc.',
      REVIEW_SOCIAL_NETWORKS: 'We recommend you to review the configuration in order to include your social networks and other links.',
      REVIEW_GENERAL_INFORMATION: 'We recommend you review the platform General Information. This information will be displayed in some emails.',
      REVIEW_BILLING_INFORMATION: 'We need you to update the Billing information so your invoices and receipts will be generated correctly.'
    },
    routes: {
      NO_STYLES: {
        name: 'configuration',
        query: { section: 'styles' }
      },
      NO_MEMBERSHIPS: {
        name: 'configuration',
        query: { section: 'memberships' }
      },
      NO_CLASSROOMS: {
        name: 'configuration',
        query: { section: 'classrooms' }
      },
      NO_LEVELS: {
        name: 'configuration',
        query: { section: 'levels' }
      },
      NO_TEACHERS: {
        name: 'member-details',
        params: { id: 'new' },
        query: { role: 'teacher' }
      },
      NO_CLASSES: {
        name: 'class-details',
        params: { id: 'new' }
      },
      NO_STUDENTS: {
        name: 'member-details',
        params: { id: 'new' },
        query: { role: 'student' }
      },
      REVIEW_PAYMENTS: {
        name: 'configuration',
        query: { section: 'payments' }
      },
      REVIEW_SOCIAL_NETWORKS: {
        name: 'configuration',
        query: { section: 'social_networks' }
      },
      REVIEW_GENERAL_INFORMATION: {
        name: 'configuration',
        query: { section: 'general_information' }
      },
      REVIEW_BILLING_INFORMATION: {
        name: 'configuration',
        query: { section: 'invoicing' }
      }
    },
    priorities: {
      minimum: 'Minimum',
      low: 'Low',
      normal: 'Normal',
      high: 'High',
      maximum: 'Maximum'
    },
    task_saved: 'Task Saved successfully',
    task_created: 'Task Created successfully',
    task_deleted: 'The Task has been Deleted',
    confirm_delete_task: 'Delete Task Confirmation',
    confirm_delete_content: 'You are about to delete this task. Are you sure that you want to proceed?',
    pending_tasks: 'You have pending or outstanding tasks to review'
  },
  welcome_modal: {
    next: 'Next',
    welcome_text: 'Welcome to Kydemy!',
    continue: 'Let\'s Begin!',
    do_not_show_again: 'Do not show this message again.',
    thank_you: '<b class="has-text-info">Thank you</b> for choosing Kydemy.',
    main_message: 'Your Kydemy platform is ready, but first you need to configure some details before you can begin. Kydemy has an embedded Task management tool and we have created some tasks to guide you in the configuration process.',
    list_message: 'In order to properly use Kydemy you will need to:',
    list_message_items: [
      'Define your <b>Styles</b> (or categories)',
      'Create <b>Levels</b> for each Style',
      'Set up <b>Memberships</b> fees for your students/clients',
      'Create <b>Locations and Classrooms</b> for your classes',
      'Start creating <b>Teachers</b>, <b>Students</b> and <b>Managers</b>',
      'Create <b>Classes</b> and schedules'
    ],
    contact: 'Do not hesitate to <a href="mailto:contact@kydemy.com">contact us</a> if you require assistance or have any questions.',
    show_welcome_message: 'Open Configuration Wizard'
  },
  validations: {
    snackbars: {
      email_exists: 'This email is already in use in the platform',
      phone_exists: 'This phone number is already registered in the platform'
    },
    messages: {
      _default: 'The field is required',
      email: 'A valid email address should be provided',
      minLength: 'It must have at least {num} characters',
      maxLength: 'It must have a maximum of {num} characters',
      minValue: 'The minimum value is: {num}',
      maxValue: 'The value must not exceed {num}',
      phone_exists: 'The phone already exists',
      email_exists: 'The email is already registered',
      username_exists: 'The username is already registered',
      username_format: 'Only lowercase letters, digits and underscore are allowed',
      password_format: 'From 6 to 30 characters. Spaces are not allowed',
      password_confirmation: 'The confirmation and the password do not match',
      registration_exists: 'You have a pending registration',
      accept_terms: 'You must accept the Terms & Conditions in order to continue',
      image_required: 'Please provide a valid image',
      duration_error: 'The end time must be after the start time',
      venue_error: 'Please select or create a new Venue',
      classroom_error: 'Please select a Classroom',
      event_type_error: 'Please select or create a new Event Type',
      class_style_error: 'Please select a class Style',
      class_level_error: 'Please select a Style Level',
      url: 'Please enter a valid URL',
      membership_error: 'Students must have a membership',
      select_user_error: 'A User must be selected',
      select_role_error: 'A Role must be selected',
      accept_payment: 'You must accept the payment conditions in order to continue',
      card_missing: 'Please enter a valid Credit/Debit Card to continue',
      select_memberships_error: 'You must select a valid membership fee',
      select_months_error: 'You must select at least one month',
      select_class_error: 'You must select an existing class',
      select_event_error: 'You must select an existing event',
      select_belt_error: 'You must select an existing belt'
    },
    custom: {
      event_name: {
        required: 'The Event must have a name'
      },
      event_picture: {
        required: 'The picture is required'
      },
      event_venue: {
        required: 'Please select an existing venue or create a new one'
      },
      event_type: {
        required: 'Please select an existing type or create a new one'
      },
      event_duration: {
        min_value: 'The end date must be greater than the start date'
      }
    }
  },
  reports: {
    sections: {
      classes_performance: 'Classes Performance',
      expenses_report: 'Expenses Report',
      class_students: 'Class Students',
      memberships_performance: 'Memberships Performance',
      styles_performance: 'Styles Performance',
      teachers_performance: 'Teachers Performance',
      students_attendance: 'Inactive Students',
      lost_students: 'Lost Students',
      login_activity: 'Platform Access',
      media_stats: 'Multimedia Stats',
      best_customers: 'Best Customers',
      month_memberships: 'Classes & Fees per Month',
      classes_performance_description: 'Analyze and compare in detail which classes are more profitable, their associated running costs, success among your students, etc.',
      expenses_report_description: 'Review your monthly expenses broken down by category in order to optimize you expenditure.',
      class_students_description: 'Find out how classes evolve and get insights about the students: new students, drop-ins/trials, cancellations/absences, payments overview, etc.',
      memberships_performance_description: 'Find out the effective price per hour associated to each membership, the profitability margin and compare them side by side.',
      styles_performance_description: 'Take a quick glance to find out which are your most successful styles and contrast their economic performance.',
      teachers_performance_description: 'Obtain insight about your staff performance: Do you know how much income each teacher generates? what is your profit margin?',
      students_attendance_description: 'Review which students have stopped to attend classes and the student abandonment progression in time.',
      lost_students_description: 'Review the history of lost students so you can take action in order to re-engage them and get them back to class.',
      login_activity_description: 'It shows the accesses to the platform for each month, broken down by roles and with information by device types.',
      media_stats_description: 'Review the most watched videos in your platform, their monthly evolution, and who has watched each video.',
      best_customers_description: 'Find out which are your best customers for different periods of time, their payment methods and what are the type of payments made.',
      month_memberships_description: 'Analyze which students have paid their membership/classes fees for a specific month, regardless of when they performed the payment.'
    },
    students_attendance: {
      note: 'Only those students who have not attended class for more than a month are shown.',
      disclaimer: 'The information presented in this page relies directly on the attendance recorded. Therefore if the student attendance has not been properly recorded, this information might not be accurate.',
      show_inactive: 'Show inactive accounts',
      firstname: 'First Name',
      lastname: 'Last Name',
      last_attendance: 'Last Attendance',
      active: 'Active',
      chart_title: 'New Inactive Students',
      nodata: 'There is not enough data to display a chart for inactive students.'
    },
    classes_performance: {
      note: 'Please note that only non private regular and thematic classes are displayed bellow.',
      disclaimer: 'The information displayed in this page depends directly of the attendance records, classrooms configuration, teachers wage information, payments and students class registration. Please provide accurate data in a daily basis to yield an usable report.',
      nodata: 'We do not have enough data recorded in order to generate this report',
      class_name: 'Name',
      attendance_lists_abbr: 'Att. Lists',
      attendance_lists: 'Attendance Lists',
      classes_month: 'Classes',
      minutes: 'Hours',
      students: 'Students',
      income: 'Income',
      classroom_expenses: 'Classroom Expenses',
      teachers_expenses: 'Teachers Expenses',
      classroom_expenses_abbr: 'Classrooms',
      teachers_expenses_abbr: 'Teachers',
      profit: 'Profit',
      profit_margin: 'Margin',
      total: 'TOTAL',
      chart: {
        profit_margin: 'Profit Margin',
        profit: 'Profit',
        income: 'Income',
        expenses: 'Expenses'
      }
    },
    expenses_report: {
      chart: {
        month_total: 'Total Month Expenses'
      },
      columns: {
        num_invoices: 'Invoices',
        subtotal: 'SubTotal',
        total: 'Total'
      }
    },
    memberships_performance: {
      note: 'Only memberships with payments and with payment amounts greater than zero are displayed bellow.',
      disclaimer: 'In order to match which membership payment is associated to which class we use the attendance lists information. Therefore missing or inaccurate attendance list records will generate inaccurate data.',
      payments: 'Payments',
      name: 'Name',
      month_total: 'Month Income',
      avg_hours: 'Avg. Hours',
      avg_amount_hour: 'Avg. Income/Hour',
      hours: 'hours',
      per_hour: 'per hour',
      num_payments: 'payments',
      chart: {
        num_payments: 'Membership Payments',
        avg_hours: 'Average Lective Hours',
        avg_amount: 'Average Payment',
        avg_amount_hour: 'Average Hour Income'
      }
    },
    class_students: {
      note: 'Please note that only non private regular and thematic classes are displayed bellow.',
      disclaimer: 'This information relies directly on regular classes, attendance lists, memberships payments and trial class payments. Therefore each class information might display erroneous/inaccurate information if their associated information is not accurate.',
      disclaimer2: 'Please note that the number of membership payments is not tight to a single class. Some students might have a memberships payment associated to several classes.',
      name: 'Name',
      num_registered: 'Registered',
      num_attended: 'Attended',
      num_trial: 'Trials',
      num_new: 'New Students',
      num_cancelled: 'Cancellations',
      membership_payments: 'Membership Payments',
      num_month_payments: 'Month',
      num_two_month_payments: 'Two Months',
      num_quarter_payments: 'Quarter',
      num_other_payments: 'Other'
    },
    login_activity: {
      columns: {
        name: 'Name',
        last_login: 'Last Login',
        num_logins: 'Num Logins',
        roles: 'Roles',
        devices: 'Devices'
      }
    },
    best_customers: {
      title_chart: 'Top {num} Customers',
      title_table: 'Top {num} Customers Data',
      modes: {
        '4weeks': '4 Weeks',
        '3months': '3 Months',
        '1year': 'One Year',
        absolute: 'Absolute',
        month_avg: 'Monthly Average'
      },
      columns: {
        name: 'Name',
        types: 'Types',
        methods: 'Methods',
        payments: 'Payments',
        total: 'Total'
      }
    },
    month_memberships: {
      no_items: '-- There are no payments related to the selected month --',
      num_classes: '{num} classes',
      total_prorated: 'Total Month - Prorated',
      columns: {
        student: 'Student',
        type: 'Type',
        date: 'Date',
        months: 'Months',
        classes: 'Att. Classes',
        trial_classes: 'Trial Classes',
        amount: 'Amount',
        prorated: 'Prorated',
        classes_trial: 'Classes/Trials'
      },
      filter_types: {
        all: '-- ALL --',
        membership: 'Only Memberships',
        class: 'Only Classes'
      },
      mode_students: 'Students',
      mode_classes: 'Classes',
      trial_class: '{name} - Trial Students'
    }
  },
  colors: {
    white: {
      name: 'White',
      color: 'FFFEFD'
    },
    yellow: {
      name: 'Yellow',
      color: 'F6DB48'
    },
    orange: {
      name: 'Orange',
      color: 'FD7027'
    },
    green: {
      name: 'Green',
      color: '168C6D'
    },
    blue: {
      name: 'Blue',
      color: '244799'
    },
    brown: {
      name: 'Brown',
      color: '964C16'
    },
    red: {
      name: 'Red',
      color: 'FF1211'
    },
    black: {
      name: 'Black',
      color: '1D1C28'
    },
    purple: {
      name: 'Purple',
      color: '672C91'
    },
    camo: {
      name: 'Camouflage',
      color: '606946'
    }
  },
  wizard: {
    error: 'There was an unexpected error processing your configuration, please contact us so we can help you with your platform configuration.',
    skip_wizard: 'Skip this setup and go to Kydemy (NOT RECOMMENDED)',
    finish: 'Finish',
    saving_business_type: 'Updating Business Type...',
    saving_styles_levels: 'Configuring Styles & Levels...',
    saving_venues_classrooms: 'Creating Venues & Classrooms...',
    saving_currency: 'Selecting Currency & Language...',
    saving_prefix: 'Saving Phone Prefix...',
    saving_memberships: 'Setting up Memberships...',
    saving_random_data: 'Generating Random Contents...',
    saving_wizard: 'Congratulations, your Kydemy is ready!',
    creating_teachers: 'Generating Teachers ({current}/{total})',
    creating_classes: 'Generating Classes ({current}/{total})',
    creating_students: 'Generating Students ({current}/{total})',
    wizard_warning: '<b>WARNING:</b> Your platform is already configured. Using this Wizard might change your configuration and render your platform unusable. Please contact us before proceeding or if you have any doubts.',
    wizard_warning_help: 'Click on this message to go back to Kydemy',
    wizard_tab_title: 'Click here to clear platform data',
    wizard_tab_clear: 'Click here to clear platform data',
    panels: {
      welcome: {
        title: 'Welcome to Kydemy!',
        first_message: 'We are going to help you to get started with Kydemy. In the following screens you will be able to configure the required information to get you started. Completing this configuration will take you from 4 to 7 minutes.',
        second_message: 'Please note that in order to start creating classes and students there is some required information that will be completed during this setup. Eg: styles, levels, venues/classrooms, membership fees, currency, etc.',
        box_message: 'Please note that you will be able to add or update any information later on using the Configuration panel.<br/>Any missing information or additional settings can be reviewed using the integrated task manager of Kydemy.'
      },
      business_type: {
        title: 'Select a Business Type'
      },
      styles: {
        title: 'Select your Styles',
        add_custom_style: 'Add custom style:',
        belts_message: 'Some martial arts disciplines use belts/grades and colors to track the students\' progression. Please select if you would like to use belts and the desired color/grade system. Please note that you will be able to adjust these and other settings later on.',
        wtf_red: 'WTF/ITF Red',
        wtf_brown: 'WTF/ITF Brown',
        ata: 'ATA/Songahm',
        belts_enabled: 'Belts/Grades Enabled:',
        belts_colors: 'Belts Colors:',
        style_paint: 'Painting',
        style_technical_drawing: 'Technical Drawing',
        style_sculpture: 'Sculpture',
        style_handcrafts: 'Handcrafts',
        style_comic: 'Comic',
        style_portraiture: 'Portraiture',
        style_water_painting: 'Water Painting',
        style_photography: 'Photography',
        style_sing: 'Singing',
        style_piano: 'Piano',
        style_violin: 'Violin',
        style_acoustic_guitar: 'Acoustic Guitar',
        style_electric_guitar: 'Electric Guitar',
        style_musical_language: 'Musical Language',
        style_percussion: 'Percussion',
        style_electronic_music: 'Electronic Music',
        style_english: 'English',
        style_spanish: 'Spanish',
        style_french: 'French',
        style_german: 'German',
        style_russian: 'Russian',
        style_chinese: 'Chinese',
        style_review: 'Review',
        style_secondary: 'Secondary',
        style_act: 'Acting',
        style_it: 'Inf. Technology',
        style_oppositions: 'Oppositions',
        style_cooking: 'Cooking',
        style_interpretation: 'Interpretation',
        style_theater: 'Theater',
        style_pilates: 'Pilates',
        style_yoga: 'Yoga',
        style_languages: 'Languages',
        style_art: 'Art',
        style_music: 'Music'
      },
      style_levels: {
        title: 'Adjust Levels',
        help_message: 'Levels will be used to identify the level of students and as minimum requirements for classes. You can select a pre-configured set of levels for each style. Please note that you will be able to adjust and modify these levels later on.',
        types: {
          single: 'Single Level',
          basic: '3 Basic Levels',
          intermediate: '5 Levels',
          advanced: '12 Levels',
          grades: 'Ballet Grades'
        },
        levels: {
          single: 'Single Level',
          initiation: 'Initiation',
          intermediate: 'Intermediate',
          advanced: 'Advanced',
          basic: 'Basic',
          intermediate_advanced: 'Intermediate / Advanced',
          b1: 'Basic 1',
          b2: 'Basic 2',
          b3: 'Basic 3',
          i1: 'Intermediate 1',
          i2: 'Intermediate 2',
          i3: 'Intermediate 3',
          ia1: 'Int / Adv 1',
          ia2: 'Int / Adv 2',
          ia3: 'Int / Adv 3',
          a1: 'Advanced 1',
          a2: 'Advanced 2',
          a3: 'Advanced 3',
          fam: 'Family Dance',
          dyot1: 'Dance your own Tune 1',
          dyot2: 'Dance your own Tune 2',
          prepri: 'Pre Primary',
          pri: 'Primary',
          g1: 'Grade 1',
          g2: 'Grade 2',
          g3: 'Grade 3',
          g4: 'Grade 4',
          g5: 'Grade 5',
          g6: 'Grade 6',
          g7: 'Grade 7',
          g8: 'Grade 8',
          if: 'Intermediate Foundation',
          af: 'Advanced Foundation'
        }
      },
      venues: {
        title: 'Add all your Venues',
        venues_help: 'Please search for your venue in google maps and add it to your locations',
        venues_label: 'Search for a Venue:',
        message: 'Please search and add all the venues where you provide your services. In the next step you will be able to define classrooms for each venue.',
        add_venue: 'Add Venue'
      },
      classrooms: {
        title: 'Set-up your Classrooms',
        new_classroom_placeholder: 'Classroom name',
        venues_label: 'Venues',
        classrooms_label: 'Classrooms'
      },
      memberships: {
        title: 'Define your memberships',
        message: 'Here you can configure your membership monthly/quarterly fees. Please select a name, the prices for the monthly fee, quarterly fee and the amount of classes included in a month for that type of membership. Please set 0 in the corresponding field if you do not want to allow month or quarter payments. You will be able to modify or add additional memberships later on.',
        select_currency: 'Select your main Currency:',
        name: 'Name',
        price_month_placeholder: 'Price Month',
        price_trimester_placeholder: 'Price Quarter',
        classes_month_placeholder: 'Classes included in Month',
        price_month: 'Month',
        price_trimester: 'Quarter',
        classes_month: 'Classes Month',
        other_currency: 'If your currency is not listed, we will add it to your Kydemy right away. Please contact us to let us know.'
      },
      final: {
        title: 'Configuration Review',
        message: 'We have all the information for you to start using Kydemy. Please review the following information. Please note that you can go back to the desired step to update your settings or you can adjust it later using the Kydemy Configuration panel.',
        message_end: 'Please choose if you want an empty platform or a randomly pre-populated platform to complete the setup.',
        option_empty: 'Empty Platform',
        option_desc_empty: 'Pick this option if you want to get started with Kydemy right away. The platform will be empty and ready for you to create classes, students, etc.',
        option_populate: 'Populated Platform',
        option_desc_populate: 'We will use your settings to create random students, classes, etc. You can delete all this data once you\'re ready to use Kydemy for real.',
        option_finish: 'Save Configuration',
        option_desc_finish: 'You\'re all set, click this button or in the Finish button to get started with your Kydemy platform.',
        setting_business: 'Business Type',
        setting_styles: 'Styles',
        setting_venues: 'Venues',
        setting_currency: 'Currency',
        setting_memberships: 'Memberships'
      }
    }
  },
  quick_search: {
    attendance_button_attended: 'The student has attended this class. Click to remove to attendance list.',
    attendance_button_no_attended: 'The student is marked as absent. Click to add to attendance list.',
    attendance_button_no_list: 'There is no attendance list created. Click to create the attendance list.',
    caption_attendance_button_no_list: 'Create Attendance List',
    class_attendance_button_no_list: 'There is no attendance list created. Click to create the attendance list.',
    no_results: 'We could not any result that matches the text provided.',
    no_common_searches: '-- No searches found --',
    common_searches: 'Most Common Searches:',
    today_classes_attendance_lists: 'Today\'s Classes Attendance Lists:',
    today_debts: 'Students of Today with Debts:',
    no_debts_today: '-- There are no debts pending for today\'s students --',
    no_classes_today: '-- There are no classes scheduled today --'
  },
  print_receipt: {
    month: 'Month',
    membership: 'Fee',
    class: 'Class',
    event: 'Event',
    belt: 'Belt',
    other: 'Other',
    concept: 'Concept',
    amount: 'Amount',
    discount: 'Discount',
    total: 'Total',
    vat: 'VAT',
    taxes: 'TAXES',
    voucher: '{num} Class Voucher',
    license: 'License/Registration Fee',
    pack: 'Classes Pack',
    trial: 'Trial: {name}',
    refund: 'Refund',
    invoice_number: 'Invoice Number',
    popup_error: 'Print-window blocked by browser permissions. Please enable/allow "Open Pop-up Windows"'
  },
  widgets: {
    save: 'Save',
    reset: 'Reset',
    cancel: 'Cancel',
    memberships: 'Memberships',
    dance_roles: 'Dance Roles',
    today_classes: 'Today\'s Classes',
    week_classes: 'Week Classes',
    birthdays: 'Birthdays',
    week_payments: 'Week Payments',
    students_classes: 'Students/Classes',
    belts: 'Belts',
    connected_users: 'Connected Users',
    new_members: 'Registrations',
    month_payments: 'Month Payments Overview',
    desc_memberships: 'Pie chart that shows the amount of students for each membership fee.',
    desc_dance_roles: 'Pie chart that shows the amount of students by dance role.',
    desc_today_classes: 'Day calendar with the classes schedule for today.',
    desc_week_classes: 'Week calendar with the classes schedule for the current week.',
    desc_birthdays: 'Shows students upcoming birthdays for the next week.',
    desc_week_payments: 'Bar chart with the income generated for each week day.',
    desc_students_classes: 'Line chart displaying the evolution of active students and classes.',
    desc_belts: 'Pie chart that shows the amount of students for each belt.',
    desc_connected_users: 'Shows the active users for the last 15 minutes.',
    desc_new_members: 'Line chart that shows the evolution of new registrations.',
    desc_month_payments: 'Displays all payments performed in a month grouped by payment type.'
  },
  shortcuts: {
    title: 'Keyboard Shortcuts',
    subtitle: 'These are the keyboard shortcuts that can be used by Administrators and Managers from any part of the application for a more agile and productive use of Kydemy.',
    search: 'Quick Search',
    shortcuts: 'Keyboard Shortcuts',
    create_student: 'Create Student',
    create_student_quick: 'Quick Create Student',
    create_class: 'Create Couples Class',
    create_class_singles: 'Create Singles Class',
    create_event: 'Create new Event',
    create_task: 'Create new Task',
    create_lead: 'Create new Lead'
  },
  streaming: {
    default_cam: 'Default Camera',
    default_mic: 'Default Microphone',
    select_cam: 'Select webcam/camera',
    select_mic: 'Select microphone',
    echo_cancellation_enabled: 'Enable echo cancellation if possible',
    noise_reduction_enabled: 'Enable noise reduction if possible',
    echo_cancellation_explain: 'Echo cancellation is a technology that aims to avoid echoes and feedbacks. Disable this option if you want to play music over a speaker and want the others to be able to listen it correctly. We recommend the use of a headset to avoid unwanted noises/echoes.',
    noise_reduction_explain: 'Noise reduction is a technology that aims to reduce noises that are not human voices. Disable this option if you want to play music over a speaker and want the others to be able to listen it correctly. We recommend the use of a headset to avoid unwanted noises/echoes.',
    initializing: 'Initializing, please wait...',
    start_now: 'Start Now!',
    enter: 'Enter',
    duration: '{minutes} minutes',
    fullscreen: 'Full Screen',
    exit_fullscreen: 'Minimize',
    configuration_title: 'Check your Camera and Mic',
    getting_media: 'Retrieving Camera and Mic',
    leave: 'Exit',
    open_class: 'Go to Class',
    open_class_tooltip: 'Open current class configuration / attendance list',
    scheduled_class: 'You have an online class that will start in <b class="has-text-info">{left}</b>, at <b class="has-text-danger">{time}</b>',
    available_class: 'You have an online class that will start in <b class="has-text-info">{left}</b>',
    ongoing_class: 'Your class already started <b class="has-text-danger">{left}</b>',
    admin_data: 'Online Classes: <b class="has-text-danger">{ongoing} on going</b>, <b class="has-text-success">{available} upcoming</b> and <b class="has-text-info">{scheduled} scheduled</b>',
    end_class: 'End Class',
    mute_all: 'Mute all',
    unmute_all: 'Unmute all',
    options: 'Options',
    close: 'Collapse',
    allow_debts: 'Allow debts',
    allow_debts_tooltip: 'Click to allow students with debts to enter this online session',
    disallow_debts_tooltip: 'Click to disallow students with debts to enter this online session',
    disallow_debts: 'Disallow debts',
    join_now: 'Join Now',
    ending_class: 'Finishing up Online Session...',
    class_rating: 'Rate your class',
    teacher_rating: 'Rate your teacher/s',
    meeting_rating: 'Rate the meeting quality',
    submit_ratings: 'Send Ratings',
    submit_notes: 'Send Class Notes',
    class_notes: 'Please enter your notes for this class',
    sending_ratings: 'Sending you class ratings...',
    sending_notes: 'Storing class notes...',
    payment_required: 'You must have your payments up to date to access this online session',
    class_ended: 'You cannot join this class because it has already concluded',
    registration_required: 'You must be registered or being invited in order to join this class',
    virtual_classroom: 'Virtual Classroom',
    channels: {
      classroom: 'Classroom',
      streaming: 'Virtual Class',
      live: 'Classroom + Live'
    },
    end_class_modal: {
      title: 'End Online Session',
      content: 'You are about to end this online session/class. This will close this virtual classroom and disconnect all participants.',
      content_bold: 'Do you really want to end this session?<br/><span class="is-size-65">If you just need to log out temporarily, click "Leave without Ending".</span>',
      button: 'End Online Session',
      button_exit: 'Leave without Ending'
    },
    error_not_found: 'We could not detect your mic & camera, please check if your devices are properly plugged in and that you have allowed your mic & camera.',
    error_failed: 'There has been a problem connecting to the room. If the problem persist, please, contact us.',
    error_not_compatible: 'Your browser is not compatible with live class streamings. Please <a href="https://www.google.com/chrome/">Download Google Chrome clicking here</a>.',
    error_not_compatible_student: 'Your browser is not compatible with live class streamings. Please <a href="https://www.google.com/chrome/">Download Google Chrome clicking here</a> or use our Mobile app.',
    error_muting: 'We have been unable to mute the participant',
    error_not_permissions: 'We were unable to access your camera or microphone. Check that you have correctly installed your camera/microphone and that you have allowed access to these devices in the browser.<br/>For more information check the support page of your browser or click here for Chrome:<br/><a target="_blank" href="https://support.google.com/chrome/answer/2693767">Use the camera and microphone</a>',
    connecting: 'Connecting...',
    reconnecting: 'Reconnecting...',
    allow_students_debts: 'Allow students with debts to join online class/session',
    mode_teachers: 'Teachers View',
    mode_grid: 'Classroom View',
    tooltip_mode_teachers: 'Students will only hear other students, only the teachers video will be shown',
    tooltip_mode_grid: 'The students will watch and hear all participants: teachers and students',
    notifications: {
      peer_joined: '{name} has joined the room',
      room_joined: 'The class has started!',
      mic_disconnected: 'The microphone has been disconnected',
      webcam_disconnected: 'The webcam has been disconnected',
      error: 'We have detected an unexpected error. Please reload the page if you experience technical problems.',
      error_details: 'Internal error, please reload if you experience technical problems: {error}',
      disconnected: 'You have been disconnected...',
      message: 'New message from {name}:',
      message_bot: 'New message:',
      mic_error: 'Error initializing your microphone, please review your configuration and re-enter the room: {error}',
      webcam_error: 'Error initializing your webcam, please review your configuration and re-enter the room: {error}',
      change_webcam_error: 'Error switching webcams: {error}',
      change_microphone_error: 'Error switching microphone: {error}',
      resolution_error: 'Error updating video quality: {error}',
      share_disconnected: 'Screen sharing completed',
      connection_error: 'Could not connect to the server. Please contact us.'
    },
    config_modal: {
      title: 'Video/Audio Settings',
      content: 'Please select the camera and microphone you would like to use for this videoconference session.',
      button: 'Close Settings'
    }
  },
  subscriptions: {
    title: 'Select your Subscription Plan:',
    title_selected: 'Your Subscription Plan:',
    button_vat: 'VAT Configuration',
    button_payment: 'Payment Configuration',
    payment_configuration: 'Payments Configuration',
    payment_info: 'Please introduce directions for your subscribers so they know how they should perform payments.<br/><b>Do not include specific pricing as this information will be already be presented to them:</b>',
    info_save: 'Save Info',
    label_online_payment: 'Enable Online Payments',
    accounts_tooltip: 'Number of accounts that can simultaneously use this subscription',
    payment_month: 'Month',
    payment_year: 'Year',
    payment_mode: 'Payment Mode',
    payment_terms: 'I accept that <b>{business}</b> will charge the credit card provided every <b class="has-text-info">{span}</b> the amount of <b class="has-text-success">{total}</b> <span class="is-size-65">{base} + {vat} ({vatPercent}% VAT)</span>',
    cancel_terms: 'You will be able to cancel your subscription at anytime so future payments are not charged.',
    accept_payment: 'I accept the subscription payment conditions',
    button_back: 'Back',
    button_next: 'Next',
    button_cancel: 'Cancel',
    button_finish: 'Confirm',
    confirmation: {
      plan: 'Subscription Plan',
      contact: 'Subscription Contact',
      interval: 'Subscription Interval',
      accounts: 'Max. Accounts',
      price: 'Subscription Fee',
      cardholder: 'Cardholder Name',
      card_error: 'There was a problem processing your card, please go to the previous step and try a again or use a different card. If the problem persists, please contact your bank to verify that your card is active and can be used for online purchases.'
    },
    msg_available_days: 'This content will be available in <b class="is-size-6 has-text-blue">{numDays}</b> days.',
    msg_available_deps: 'You need to complete:',
    no_content_filter: 'There are no contents for the selected filters',
    registration_success: 'Congratulations! You are now subscribed to <b>{name}</b>.<br/>You can access the platform using the selected email address and password.<br/>Click on the following button to sign in:',
    login_button: 'Sign In',
    subscription_status_error: 'The subscription is not currently active, therefore this content is not available',
    error_messages: {
      canceled: 'Your subscription has been cancelled, therefore you have no longer access to the subscription contents. Contact us for more information.',
      past_due: 'You have an outstanding subscription payment and you will not be able to access your subscription contents until your pending payments are settled.',
      unpaid: 'You have an outstanding subscription payment and you will not be able to access your subscription contents until your pending payments are settled.',
      incomplete: 'There was an problem validating your payment method, please click on the following button to validate your payment method.',
      incomplete_expired: 'There was an problem validating your payment method, please click on the following button setup a valid payment method.',
      button: 'Review payment method'
    },
    configuration: {
      sections: {
        subscription: 'Subscription',
        'payment-method': 'Payment Method',
        billing: 'Billing',
        accounts: 'Accounts'
      },
      subscription_title: 'Subscription Information',
      payment_method_title: 'Subscription Payment Method',
      accounts_title: 'Subscription Accounts',
      billing_information: 'Billing Information',
      billing_history: 'Billing History',
      expires: 'Expires',
      new_card: 'Configure new card',
      billing_columns: {
        status: 'Status',
        period: 'Period',
        tax: 'Tax',
        amount: 'Amount',
        invoice: 'Invoice'
      },
      status: {
        draft: 'Draft',
        open: 'Pending',
        uncollectible: 'Error',
        paid: 'Paid',
        void: 'Void',
        active: 'Active',
        canceled: 'Canceled',
        incomplete: 'Incomplete',
        incomplete_expired: 'Expired',
        past_due: 'Payment Past Due',
        trialing: 'Trialing',
        unpaid: 'Unpaid'
      },
      customer_fields: {
        name: 'Subscriber/Billing name',
        email: 'Subscriber email',
        line1: 'Address - Line 1',
        line2: 'Address - Line 2',
        postal_code: 'Postal Code / Zip',
        city: 'City / Town',
        state: 'State / Region',
        country: 'Country'
      },
      subscription: {
        plan: 'Subscription Plan',
        status: 'Subscription Status',
        activity: 'Subscription Activity',
        name: 'Plan Name',
        since: 'Since',
        days: 'Days',
        accounts: 'Incl. accounts',
        cancel_subscription: 'Cancel Subscription',
        interval: 'Interval',
        price: 'Plan Amount',
        tax: 'Plan Tax',
        videos_total: 'Videos Total',
        videos_completed: 'Videos Completed',
        trial_start: 'Trial Start',
        trial_end: 'Trial End',
        canceled_at: 'Canceled',
        cancel_at: 'Cancel At',
        next_payment: 'Next Payment',
        cancel_title: 'Confirm Cancel Subscription',
        cancel_content: 'You are about to cancel your subscription.<br/>If you proceed with the cancellation, you will not be able to access any contents from <b class="has-text-danger">{date}</b> onwards.',
        cancel_button: 'Cancel Subscription',
        cancel_success: 'Subscription cancelled successfully',
        cancel_error: 'There was a problem cancelling your subscription, please contact us',
        canceling: 'Cancelling Subscription on {date}'
      },
      accounts: {
        new_tooltip: 'Create a new account',
        cancel: 'Cancel',
        create: 'Add Account',
        save: 'Save Changes',
        delete: 'Delete',
        account_fields: {
          firstname: 'Fist name',
          lastname: 'Last name',
          email: 'Email Address',
          phone: 'Phone number'
        },
        new_account_info: 'The new account will receive an invitation via email with the necessary information to sign into the platform.',
        save_success: 'Account information saved successfully',
        save_error: 'Error saving account data, please try again later',
        delete_success: 'Subscription account deleted successfully',
        delete_error: 'Error deleting subscription account, please try again later',
        delete_title: 'Confirm Delete Account',
        delete_button: 'Delete Account',
        delete_content: 'If you delete this account <b class="has-text-info">{name}</b> will not be able to access the platform or the subscription contents anymore.'
      }
    }
  },
  evaluations: {
    no_class_selected_message: 'Please select a class to review grades or start grading students',
    save_grade: 'Save student grades',
    no_students_in_class: 'There are no students in this class',
    student_no_grades: 'There are no Grades available yet',
    teacher_no_courses: 'There are no assessments or classes for you to evaluate at this moment',
    attendance_info: '{attendances} out of {lists} classes',
    ignore_insufficient_attendance: 'This student has a class attendance of <b class="has-text-danger">{attendance}%</b>, and cannot be graded as the minimum grading attendance is <b class="has-text-info">{min}%</b>.',
    ignore_insufficient_attendance_button: 'Ignore'
  },
  qr: {
    access_has_debts_title: 'ERROR QR Access',
    access_has_debts: '{name} at {qr_name} ({qr_location}) <b>with debts</b>',
    access_no_debts_title: 'New QR Access',
    access_no_debts: '{name} at {qr_name} ({qr_location})'
  },
  documents: {
    documents: 'Documents & Signatures',
    not_all_signed: 'Missing Signatures',
    all_signed_not_latest: 'Signature Outdated',
    all_signed: 'All Signed',
    signed_info_signed_outdated: 'Signed {date} [ver. {version}], latest version {last_version}',
    signed_info_signed: 'Signed {date} [ver. {version}]',
    signed_info_not_signed_required: 'Required signature pending',
    signed_info_not_signed: 'Optional signature pending',
    signed_at: 'Signed At',
    ip_address: 'IP',
    browser: 'Info',
    version: 'Version',
    outdated: 'Outdated',
    signed_by: 'Authorized signer:',
    signed_by_placeholder: 'Fill only if signer is not: {name}',
    signed_by_id: 'Authorized signer ID:',
    signed_by_id_placeholder: 'Fill only if signer is not: {name}',
    field: 'Field',
    field_info: '<span class="has-text-grey is-size-65 m-l-1 is-uppercase">Find this field in the document</span>',
    available_docs: 'Available Documents',
    signed_docs: 'Signed Documents'
  }
}
